(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["active-facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grouped-metal-active-facet')) {
    class GroupedMetalActiveFacet extends HTMLElement {
      connectedCallback() {
        const selectedGroups = new URLSearchParams(window.location.search).getAll('rr_metal');

        if (selectedGroups.length > 0) {
          this.hidden = !selectedGroups.includes(this.dataset.metalGroup);
        }

        queueMicrotask(() => {
          const activeFacets = this.closest('.active-facets');

          if (!activeFacets) {
            return;
          }

          const visibleFacets = Array.from(
            activeFacets.querySelectorAll('.removable-facet')
          ).filter((facet) => !facet.hidden);
          const clearAllWrapper = activeFacets
            .querySelector('.facets-clear-all')
            ?.closest('facet-link');

          if (clearAllWrapper) {
            clearAllWrapper.hidden = visibleFacets.length <= 1;
          }
        });
      }
    }

    customElements.define('grouped-metal-active-facet', GroupedMetalActiveFacet);
  }

  if (!window.rrGroupedMetalActiveFacetLinkReady) {
    window.rrGroupedMetalActiveFacetLinkReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-grouped-metal-active-facet]');

      if (!link) {
        return;
      }

      const wrapper = link.closest('[data-metal-active-wrapper]');
      const activeFacets = link.closest('.active-facets');

      if (!wrapper || !activeFacets) {
        return;
      }

      const parameterName = link.dataset.groupedMetalFilterParam;
      const clickedGroup = wrapper.dataset.metalGroup;
      const url = new URL(window.location.href);
      const metalFacets = Array.from(
        activeFacets.querySelectorAll('[data-metal-active-wrapper]')
      );
      let selectedGroups = url.searchParams.getAll('rr_metal');

      if (selectedGroups.length === 0) {
        selectedGroups = metalFacets
          .filter((facet) => !facet.hidden)
          .map((facet) => facet.dataset.metalGroup);
      }

      const remainingGroups = selectedGroups.filter((group) => group !== clickedGroup);
      const remainingGroupSet = new Set(remainingGroups);
      const remainingValues = new Set();

      metalFacets.forEach((facet) => {
        if (!remainingGroupSet.has(facet.dataset.metalGroup)) {
          return;
        }

        const facetLink = facet.querySelector('[data-grouped-metal-active-facet]');

        (facetLink?.dataset.groupedMetalFilterValues || '')
          .split(',')
          .filter(Boolean)
          .forEach((value) => remainingValues.add(value));
      });

      url.searchParams.delete(parameterName);
      remainingValues.forEach((value) => url.searchParams.append(parameterName, value));

      url.searchParams.delete('rr_metal');
      remainingGroups.forEach((group) => url.searchParams.append('rr_metal', group));

      url.searchParams.delete('page');

      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    }, true);
  }

  if (!customElements.get('grouped-color-active-facet')) {
    class GroupedColorActiveFacet extends HTMLElement {
      connectedCallback() {
        const selectedGroups = new URLSearchParams(window.location.search).getAll('rr_color');

        if (selectedGroups.length > 0) {
          this.hidden = !selectedGroups.includes(this.dataset.colorGroup);
        }

        queueMicrotask(() => {
          const activeFacets = this.closest('.active-facets');

          if (!activeFacets) return;

          const visibleFacets = Array.from(
            activeFacets.querySelectorAll('.removable-facet')
          ).filter((facet) => !facet.hidden);
          const clearAllWrapper = activeFacets
            .querySelector('.facets-clear-all')
            ?.closest('facet-link');

          if (clearAllWrapper) {
            clearAllWrapper.hidden = visibleFacets.length <= 1;
          }
        });
      }
    }

    customElements.define('grouped-color-active-facet', GroupedColorActiveFacet);
  }

  if (!window.rrGroupedColorActiveFacetLinkReady) {
    window.rrGroupedColorActiveFacetLinkReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-grouped-color-active-facet]');

      if (!link) {
        return;
      }

      const wrapper = link.closest('[data-color-active-wrapper]');
      const activeFacets = link.closest('.active-facets');

      if (!wrapper || !activeFacets) {
        return;
      }

      const parameterName = link.dataset.groupedColorFilterParam;
      const clickedGroup = wrapper.dataset.colorGroup;
      const url = new URL(window.location.href);
      const colorFacets = Array.from(
        activeFacets.querySelectorAll('[data-color-active-wrapper]')
      );
      let selectedGroups = url.searchParams.getAll('rr_color');

      if (selectedGroups.length === 0) {
        selectedGroups = colorFacets
          .filter((facet) => !facet.hidden)
          .map((facet) => facet.dataset.colorGroup);
      }

      const remainingGroups = selectedGroups.filter((group) => group !== clickedGroup);
      const remainingGroupSet = new Set(remainingGroups);
      const remainingValues = new Set();

      colorFacets.forEach((facet) => {
        if (!remainingGroupSet.has(facet.dataset.colorGroup)) return;

        const facetLink = facet.querySelector('[data-grouped-color-active-facet]');

        (facetLink?.dataset.groupedColorFilterValues || '')
          .split(',')
          .filter(Boolean)
          .forEach((value) => remainingValues.add(value));
      });

      url.searchParams.delete(parameterName);
      remainingValues.forEach((value) => url.searchParams.append(parameterName, value));

      url.searchParams.delete('rr_color');
      remainingGroups.forEach((group) => url.searchParams.append('rr_color', group));

      url.searchParams.delete('page');

      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    }, true);
  }

  if (!customElements.get('carat-active-facet-label')) {
    class CaratActiveFacetLabel extends HTMLElement {
      connectedCallback() {
        const searchParams = new URLSearchParams(window.location.search);
        const minimum = searchParams.get('rr_carat_min') || this.dataset.rangeMin || this.dataset.defaultMin;
        const maximum = searchParams.get('rr_carat_max') || this.dataset.rangeMax || this.dataset.defaultMax;
        const format = (value) => Number.parseFloat(value).toFixed(2);

        this.textContent = `${format(minimum)}–${format(maximum)} ${this.dataset.unit}`;
      }
    }

    customElements.define('carat-active-facet-label', CaratActiveFacetLabel);
  }

  if (!window.rrCaratActiveFacetLinkReady) {
    window.rrCaratActiveFacetLinkReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-carat-active-facet]');

      if (!link) {
        return;
      }

      const url = new URL(window.location.href);

      url.searchParams.delete(link.dataset.caratFilterParam);
      url.searchParams.delete('rr_carat_min');
      url.searchParams.delete('rr_carat_max');
      url.searchParams.delete('page');

      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["center-stone-carat-weight-range"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('center-stone-carat-range')) {
    class CenterStoneCaratRange extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') {
          return;
        }

        this.dataset.ready = 'true';

        const rangeMin = this.querySelector('[data-carat-range-min]');
        const rangeMax = this.querySelector('[data-carat-range-max]');
        const rangeGroup = rangeMin.parentElement;
        const inputMin = this.querySelector('[data-carat-input-min]');
        const inputMax = this.querySelector('[data-carat-input-max]');
        const filterValues = Array.from(this.querySelectorAll('[data-carat-filter-value]'));
        const noMatchValue = this.querySelector('[data-carat-no-match]');
        let maximum = Number.parseFloat(rangeMax.max);
        const originalMaximum = maximum;
        let contextualMinimum = 0;
        const queryMinName = this.dataset.queryMin;
        const queryMaxName = this.dataset.queryMax;
        const searchParams = new URLSearchParams(window.location.search);
        const queryMin = searchParams.get(queryMinName);
        const queryMax = searchParams.get(queryMaxName);
        const displaySwapDuration = 100;
        const rangeTrackSliderDuration = 260;
        const rangeResetSliderDuration = 360;
        const rangeTrackDragThreshold = 4;
        const rangeMinStep = rangeMin.step;
        const rangeMaxStep = rangeMax.step;
        let displaySwapTimer = null;
        let rangeTrackSliderFrame = null;
        let rangeTrackSliderRange = null;
        let rangeTrackSliderTarget = null;
        let rangeTrackSliderStep = null;
        let rangeResetSliderFrame = null;
        let pendingMinimumDisplay = inputMin.value;
        let pendingMaximumDisplay = inputMax.value;
        let rangesReversed = Number.parseFloat(rangeMin.value) > Number.parseFloat(rangeMax.value);

        const clamp = (value) => Math.min(Math.max(value, contextualMinimum), maximum);
        const round = (value) => Math.round(value * 100) / 100;
        const format = (value) => round(value).toFixed(2);
        const commitDisplaySwap = () => {
          displaySwapTimer = null;
          inputMin.value = pendingMinimumDisplay;
          inputMax.value = pendingMaximumDisplay;

          requestAnimationFrame(() => {
            inputMin.classList.remove('range-value--swapping');
            inputMax.classList.remove('range-value--swapping');
          });
        };
        const beginDisplaySwap = () => {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
          }

          if (displaySwapTimer !== null) {
            window.clearTimeout(displaySwapTimer);
          }

          pendingMinimumDisplay = inputMin.value;
          pendingMaximumDisplay = inputMax.value;
          inputMin.classList.add('range-value--swapping');
          inputMax.classList.add('range-value--swapping');
          displaySwapTimer = window.setTimeout(commitDisplaySwap, displaySwapDuration);
        };
        const setMinimumDisplay = (value) => {
          if (displaySwapTimer !== null) {
            pendingMinimumDisplay = value;
          } else {
            inputMin.value = value;
          }
        };
        const setMaximumDisplay = (value) => {
          if (displaySwapTimer !== null) {
            pendingMaximumDisplay = value;
          } else {
            inputMax.value = value;
          }
        };
        const cancelDisplaySwap = () => {
          if (displaySwapTimer !== null) {
            window.clearTimeout(displaySwapTimer);
            displaySwapTimer = null;
          }

          inputMin.classList.remove('range-value--swapping');
          inputMax.classList.remove('range-value--swapping');
          pendingMinimumDisplay = inputMin.value;
          pendingMaximumDisplay = inputMax.value;
        };

        const updateProgress = (lower, upper) => {
          rangeGroup.style.setProperty('--range-min', `${(lower - contextualMinimum) / Math.max(0.01, maximum - contextualMinimum) * 100}%`);
          rangeGroup.style.setProperty('--range-max', `${(upper - contextualMinimum) / Math.max(0.01, maximum - contextualMinimum) * 100}%`);
        };

        const updatePhysicalProgress = () => {
          const firstValue = Number.parseFloat(rangeMin.value);
          const secondValue = Number.parseFloat(rangeMax.value);

          updateProgress(Math.min(firstValue, secondValue), Math.max(firstValue, secondValue));
        };

        const clearRangeTrackSliderTransition = () => {
          rangeTrackSliderFrame = null;
          rangeTrackSliderRange = null;
          rangeTrackSliderTarget = null;
          rangeTrackSliderStep = null;
        };

        const cancelRangeTrackSliderTransition = () => {
          if (rangeTrackSliderFrame !== null) {
            window.cancelAnimationFrame(rangeTrackSliderFrame);
          }

          if (rangeTrackSliderRange) {
            rangeTrackSliderRange.step = rangeTrackSliderStep;
            rangeTrackSliderRange.value = round(clamp(
              Number.parseFloat(rangeTrackSliderRange.value)
            ));
            updatePhysicalProgress();
          }

          clearRangeTrackSliderTransition();
        };

        const completeRangeTrackSliderTransition = () => {
          if (!rangeTrackSliderRange) {
            return;
          }

          if (rangeTrackSliderFrame !== null) {
            window.cancelAnimationFrame(rangeTrackSliderFrame);
          }

          const range = rangeTrackSliderRange;
          const targetValue = rangeTrackSliderTarget;

          range.step = rangeTrackSliderStep;
          range.value = targetValue;
          clearRangeTrackSliderTransition();
          range.dispatchEvent(new Event('input', { bubbles: true }));
          normalizePhysicalRangeOrder();
        };

        const easeRangeTrackSlider = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const cancelRangeResetSliderTransition = () => {
          if (rangeResetSliderFrame === null) {
            return;
          }

          window.cancelAnimationFrame(rangeResetSliderFrame);
          rangeResetSliderFrame = null;
          rangeMin.step = rangeMinStep;
          rangeMax.step = rangeMaxStep;
          rangeMin.value = round(clamp(Number.parseFloat(rangeMin.value)));
          rangeMax.value = round(clamp(Number.parseFloat(rangeMax.value)));
          updatePhysicalProgress();
        };

        const cancelSliderTransitions = () => {
          cancelRangeTrackSliderTransition();
          cancelRangeResetSliderTransition();
        };

        const animateRangeSlidersToDefaults = () => {
          cancelRangeResetSliderTransition();

          const minimumStartValue = Number.parseFloat(rangeMin.value);
          const maximumStartValue = Number.parseFloat(rangeMax.value);
          const finish = () => {
            rangeMin.value = contextualMinimum;
            rangeMax.value = maximum;
            rangeMin.step = rangeMinStep;
            rangeMax.step = rangeMaxStep;
            rangeResetSliderFrame = null;
            updateProgress(contextualMinimum, maximum);
          };

          if (
            (minimumStartValue === contextualMinimum && maximumStartValue === maximum)
            || window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            finish();
            return;
          }

          rangeMin.step = 'any';
          rangeMax.step = 'any';

          let startTime = null;
          const animate = (timestamp) => {
            if (!this.isConnected) {
              finish();
              return;
            }

            startTime ??= timestamp;
            const progress = Math.min((timestamp - startTime) / rangeResetSliderDuration, 1);
            const easedProgress = easeRangeTrackSlider(progress);

            rangeMin.value = minimumStartValue + (contextualMinimum - minimumStartValue) * easedProgress;
            rangeMax.value = maximumStartValue + (maximum - maximumStartValue) * easedProgress;
            updatePhysicalProgress();

            if (progress < 1) {
              rangeResetSliderFrame = window.requestAnimationFrame(animate);
            } else {
              finish();
            }
          };

          rangeResetSliderFrame = window.requestAnimationFrame(animate);
        };

        const animateRangeTrackSliderTo = (range, target) => {
          cancelSliderTransitions();

          const startValue = Number.parseFloat(range.value);
          const targetValue = round(clamp(target));

          rangeTrackSliderRange = range;
          rangeTrackSliderTarget = targetValue;
          rangeTrackSliderStep = range.step;

          if (
            startValue === targetValue
            || window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            completeRangeTrackSliderTransition();
            return;
          }

          range.step = 'any';

          let startTime = null;
          const animate = (timestamp) => {
            if (!this.isConnected) {
              cancelRangeTrackSliderTransition();
              return;
            }

            startTime ??= timestamp;
            const progress = Math.min((timestamp - startTime) / rangeTrackSliderDuration, 1);
            const easedProgress = easeRangeTrackSlider(progress);

            range.value = startValue + (targetValue - startValue) * easedProgress;
            updatePhysicalProgress();

            if (progress < 1) {
              rangeTrackSliderFrame = window.requestAnimationFrame(animate);
            } else {
              completeRangeTrackSliderTransition();
            }
          };

          rangeTrackSliderFrame = window.requestAnimationFrame(animate);
        };

        this.cancelTrackClickTransition = cancelSliderTransitions;

        let draggedRange = null;
        let draggedPointerId = null;
        let pointerStartClientX = null;
        let pendingTrackClickTarget = null;

        const normalizePhysicalRangeOrder = () => {
          if (!rangesReversed) {
            return;
          }

          const firstValue = Number.parseFloat(rangeMin.value);
          const secondValue = Number.parseFloat(rangeMax.value);

          rangeMin.value = Math.min(firstValue, secondValue);
          rangeMax.value = Math.max(firstValue, secondValue);
          rangesReversed = false;
        };

        const progressFromPointer = (event) => {
          const bounds = rangeGroup.getBoundingClientRect();

          if (bounds.width <= 0 || maximum <= 0) {
            return null;
          }

          const isRightToLeft = getComputedStyle(rangeGroup).direction === 'rtl';
          const rawProgress = (event.clientX - bounds.left) / bounds.width;

          return Math.min(1, Math.max(0, isRightToLeft ? 1 - rawProgress : rawProgress));
        };

        let pointerSmoothFrame = null;
        let pointerSmoothRange = null;
        let pointerSmoothValue = 0;
        let pointerSmoothTarget = 0;
        const renderPointerValue = () => {
          pointerSmoothRange.value = contextualMinimum + pointerSmoothValue * (maximum - contextualMinimum);
          pointerSmoothRange.dispatchEvent(new Event('input', { bubbles: true }));
        };
        const flushPointerMotion = () => {
          if (pointerSmoothFrame !== null) cancelAnimationFrame(pointerSmoothFrame);
          pointerSmoothFrame = null;
          if (pointerSmoothRange) {
            pointerSmoothValue = pointerSmoothTarget;
            renderPointerValue();
            pointerSmoothRange = null;
          }
        };
        this.cancelPointerMotion = () => {
          if (pointerSmoothFrame !== null) cancelAnimationFrame(pointerSmoothFrame);
          pointerSmoothFrame = null;
          pointerSmoothRange = null;
        };
        const smoothPointerTo = (range, progress) => {
          if (pointerSmoothRange !== range) { pointerSmoothRange = range; pointerSmoothValue = (Number(range.value) - contextualMinimum) / Math.max(.01, maximum - contextualMinimum); }
          pointerSmoothTarget = progress;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) { flushPointerMotion(); return; }
          if (pointerSmoothFrame !== null) return;
          const tick = () => {
            if (!this.isConnected || !pointerSmoothRange) { this.cancelPointerMotion(); return; }
            const distance = pointerSmoothTarget - pointerSmoothValue;
            pointerSmoothValue += distance * .4;
            if (Math.abs(distance) < .0005) pointerSmoothValue = pointerSmoothTarget;
            renderPointerValue();
            pointerSmoothFrame = pointerSmoothValue === pointerSmoothTarget ? null : requestAnimationFrame(tick);
          };
          pointerSmoothFrame = requestAnimationFrame(tick);
        };
        const setRangeFromPointer = (event, range) => {
          const progress = progressFromPointer(event);

          if (progress === null) {
            return;
          }

          smoothPointerTo(range, progress);
        };

        const moveClosestHandle = (event) => {
          if (this.hasAttribute('data-single-range')) return;
          if (event.button !== 0) {
            return;
          }

          completeRangeTrackSliderTransition();
          cancelRangeResetSliderTransition();

          const progress = progressFromPointer(event);

          if (progress === null) {
            return;
          }

          const minimumProgress = (Number.parseFloat(rangeMin.value) - contextualMinimum) / Math.max(0.01, maximum - contextualMinimum);
          const maximumProgress = (Number.parseFloat(rangeMax.value) - contextualMinimum) / Math.max(0.01, maximum - contextualMinimum);
          const pointerRange = event.target === rangeMin || event.target === rangeMax
            ? event.target
            : null;

          draggedRange = pointerRange || (
            Math.abs(progress - minimumProgress) <= Math.abs(progress - maximumProgress)
              ? rangeMin
              : rangeMax
          );
          draggedPointerId = event.pointerId;
          pointerStartClientX = event.clientX;
          pendingTrackClickTarget = pointerRange ? null : round(contextualMinimum + progress * (maximum - contextualMinimum));

          event.preventDefault();
          rangeGroup.setPointerCapture(event.pointerId);

          if (pointerRange) {
            setRangeFromPointer(event, draggedRange);
          }
        };

        const dragClosestHandle = (event) => {
          if (draggedRange === null || event.pointerId !== draggedPointerId) {
            return;
          }

          if (
            pendingTrackClickTarget !== null
            && Math.abs(event.clientX - pointerStartClientX) < rangeTrackDragThreshold
          ) {
            return;
          }

          event.preventDefault();
          pendingTrackClickTarget = null;
          setRangeFromPointer(event, draggedRange);
        };

        const stopDragging = (event) => {
          if (event.pointerId !== draggedPointerId) {
            return;
          }

          if (rangeGroup.hasPointerCapture(event.pointerId)) {
            rangeGroup.releasePointerCapture(event.pointerId);
          }

          flushPointerMotion();
          const range = draggedRange;
          const trackClickTarget = pendingTrackClickTarget;
          const shouldAnimateTrackClick = event.type === 'pointerup'
            && trackClickTarget !== null;

          draggedRange = null;
          draggedPointerId = null;
          pointerStartClientX = null;
          pendingTrackClickTarget = null;

          if (shouldAnimateTrackClick) {
            animateRangeTrackSliderTo(range, trackClickTarget);
          } else {
            normalizePhysicalRangeOrder();
            this.dispatchEvent(new CustomEvent('raiman:facet-range-change', { bubbles: true }));
          }
        };

        const setQueryNames = (hasMinimum, hasMaximum) => {
          if (hasMinimum) {
            inputMin.name = queryMinName;
          } else {
            inputMin.removeAttribute('name');
          }

          if (hasMaximum) {
            inputMax.name = queryMaxName;
          } else {
            inputMax.removeAttribute('name');
          }
        };

        const normalizeRangeValues = (lower, upper, animateSwap = false) => {
          const normalizedLower = round(clamp(lower));
          const normalizedUpper = round(clamp(upper));
          const minimumIsDefault = normalizedLower <= contextualMinimum;
          const maximumIsDefault = normalizedUpper >= round(maximum);

          if (animateSwap) {
            beginDisplaySwap();
          }

          rangeMin.value = normalizedLower;
          rangeMax.value = normalizedUpper;
          rangesReversed = false;
          updateProgress(normalizedLower, normalizedUpper);
          setMinimumDisplay(minimumIsDefault ? '' : format(normalizedLower));
          setMaximumDisplay(maximumIsDefault ? '' : format(normalizedUpper));
          setQueryNames(!minimumIsDefault, !maximumIsDefault);

          return {
            active: !minimumIsDefault || !maximumIsDefault,
            lower: normalizedLower,
            upper: normalizedUpper
          };
        };

        const normalizeInputs = (changedInput) => {
          let hasMinimum = inputMin.value.trim() !== '';
          let hasMaximum = inputMax.value.trim() !== '';

          if (!hasMinimum && !hasMaximum) {
            rangeMin.value = contextualMinimum;
            rangeMax.value = maximum;
            rangesReversed = false;
            updateProgress(contextualMinimum, maximum);
            setQueryNames(false, false);

            return { active: false, lower: contextualMinimum, upper: maximum };
          }

          let lower = hasMinimum ? clamp(Number.parseFloat(inputMin.value)) : contextualMinimum;
          let upper = hasMaximum ? clamp(Number.parseFloat(inputMax.value)) : maximum;

          if (lower > upper) {
            if (changedInput === inputMin) {
              lower = upper;
              inputMin.value = format(lower);
            } else {
              upper = lower;
              inputMax.value = format(upper);
            }
          }

          const minimumIsDefault = round(lower) <= contextualMinimum;
          const maximumIsDefault = round(upper) >= round(maximum);

          rangeMin.value = lower;
          rangeMax.value = upper;
          rangesReversed = false;
          updateProgress(lower, upper);
          inputMin.value = minimumIsDefault ? '' : format(lower);
          inputMax.value = maximumIsDefault ? '' : format(upper);
          setQueryNames(!minimumIsDefault, !maximumIsDefault);

          return {
            active: !minimumIsDefault || !maximumIsDefault,
            lower,
            upper
          };
        };

        const syncPhysicalRangeValues = (animateSwap = false) => {
          const firstValue = round(clamp(Number.parseFloat(rangeMin.value)));
          const secondValue = round(clamp(Number.parseFloat(rangeMax.value)));
          const lower = Math.min(firstValue, secondValue);
          const upper = Math.max(firstValue, secondValue);
          const minimumIsDefault = lower <= contextualMinimum;
          const maximumIsDefault = upper >= round(maximum);

          if (animateSwap) {
            beginDisplaySwap();
          }

          updateProgress(lower, upper);
          setMinimumDisplay(minimumIsDefault ? '' : format(lower));
          setMaximumDisplay(maximumIsDefault ? '' : format(upper));
          setQueryNames(!minimumIsDefault, !maximumIsDefault);

          return {
            active: !minimumIsDefault || !maximumIsDefault,
            lower,
            upper
          };
        };

        const applyFilter = (state, notify = true) => {
          let matches = 0;

          filterValues.forEach((filterValue) => {
            const caratValue = Number.parseFloat(filterValue.dataset.caratFilterValue);
            const checked = state.active && caratValue >= state.lower && caratValue <= state.upper;

            filterValue.checked = checked;

            if (checked) {
              matches += 1;
            }
          });

          noMatchValue.checked = state.active && matches === 0;

          if (notify) {
            this.dispatchEvent(new CustomEvent('raiman:facet-range-change', { bubbles: true }));
          }
        };

        this.readContextSelection = () => [inputMin.value, inputMax.value];
        this.contextRangeBusy = () => !!draggedRange || rangeTrackSliderFrame !== null || rangeResetSliderFrame !== null;
        this.applyContextBounds = (bounds, selection) => {
          if (this.contextRangeBusy()) return false;
          cancelDisplaySwap();
          const single = !!bounds && bounds[0] === bounds[1];
          this.toggleAttribute('data-single-range', single);
          contextualMinimum = bounds ? bounds[0] : 0;
          maximum = bounds ? bounds[1] : originalMaximum;
          [rangeMin, rangeMax].forEach(range => { range.min = contextualMinimum; range.max = maximum; });
          inputMin.placeholder = bounds ? format(contextualMinimum) : '—';
          inputMax.placeholder = bounds ? format(maximum) : '—';
          const valid = value => value !== '' && Number(value) >= contextualMinimum && Number(value) <= maximum;
          inputMin.value = valid(selection[0]) ? selection[0] : '';
          inputMax.value = valid(selection[1]) ? selection[1] : '';
          applyFilter(normalizeInputs(), false);
          [rangeMin, rangeMax, inputMin, inputMax].forEach(input => { input.disabled = !bounds || bounds[0] === bounds[1]; });
          if (single) {
            [rangeMin, rangeMax].forEach(range => { range.min = 0; range.max = 1; });
            rangeMin.value = 0; rangeMax.value = 1;
            rangeGroup.style.setProperty('--range-min', '0%');
            rangeGroup.style.setProperty('--range-max', '100%');
          }
          return true;
        };
        this.resetRange = () => {
          cancelSliderTransitions();
          cancelDisplaySwap();
          inputMin.value = '';
          inputMax.value = '';
          delete inputMin.dataset.caratTypedDigits;
          delete inputMin.dataset.caratReplaceOnType;
          delete inputMax.dataset.caratTypedDigits;
          delete inputMax.dataset.caratReplaceOnType;
          setQueryNames(false, false);
          filterValues.forEach((filterValue) => {
            filterValue.checked = false;
          });
          noMatchValue.checked = false;
          rangesReversed = false;
          animateRangeSlidersToDefaults();
        };

        if (queryMin !== null && queryMin !== '') {
          inputMin.value = queryMin;
        }

        if (queryMax !== null && queryMax !== '') {
          inputMax.value = queryMax;
        }

        applyFilter(normalizeInputs(), false);

        [inputMin, inputMax].forEach((input) => {
          const formatTypedDigits = (digits) => {
            if (digits === '') {
              return '';
            }

            return (Number.parseInt(digits, 10) / 100).toFixed(2);
          };

          const replaceOrAppendDigits = (newDigits) => {
            const existingDigits = input.dataset.caratTypedDigits || '';
            const shouldReplace = input.dataset.caratReplaceOnType === 'true';
            const nextDigits = shouldReplace ? newDigits : `${existingDigits}${newDigits}`;

            input.dataset.caratTypedDigits = nextDigits;
            input.dataset.caratReplaceOnType = 'false';
            input.value = formatTypedDigits(nextDigits);
          };

          input.addEventListener('focus', () => {
            cancelSliderTransitions();
            input.dataset.caratTypedDigits = '';
            input.dataset.caratReplaceOnType = 'true';
            input.select();
          });

          input.addEventListener('keydown', (event) => {
            if (event.ctrlKey || event.metaKey || event.altKey) {
              return;
            }

            if (/^\d$/.test(event.key)) {
              event.preventDefault();
              replaceOrAppendDigits(event.key);

              return;
            }

            if (event.key === 'Backspace' || event.key === 'Delete') {
              event.preventDefault();

              const shouldClear = input.dataset.caratReplaceOnType === 'true';
              const existingDigits = shouldClear ? '' : input.dataset.caratTypedDigits || '';
              const nextDigits = event.key === 'Delete' ? '' : existingDigits.slice(0, -1);

              input.dataset.caratTypedDigits = nextDigits;
              input.dataset.caratReplaceOnType = 'false';
              input.value = formatTypedDigits(nextDigits);

              return;
            }

            if (event.key === '.' || event.key === ',') {
              event.preventDefault();
            }
          });

          input.addEventListener('paste', (event) => {
            const pastedDigits = event.clipboardData
              ?.getData('text')
              .replace(/\D/g, '');

            if (!pastedDigits) {
              return;
            }

            event.preventDefault();
            replaceOrAppendDigits(pastedDigits);
          });

          input.addEventListener('change', (event) => {
            event.stopPropagation();
            const state = normalizeInputs(input);

            input.dataset.caratTypedDigits = input.value === ''
              ? ''
              : String(Math.round(Number.parseFloat(input.value) * 100));
            applyFilter(state);
          });
        });

        [rangeMin, rangeMax].forEach((range) => {
          range.addEventListener('input', () => {
            if (rangeTrackSliderFrame !== null || rangeResetSliderFrame !== null) {
              cancelSliderTransitions();
            }
          });
        });

        rangeMin.addEventListener('input', (event) => {
          const nextRangesReversed = Number.parseFloat(event.target.value) > Number.parseFloat(rangeMax.value);
          const rolesChanged = nextRangesReversed !== rangesReversed;

          rangesReversed = nextRangesReversed;
          applyFilter(syncPhysicalRangeValues(rolesChanged), false);
          this.dispatchEvent(new CustomEvent('raiman:facet-range-change', { bubbles: true }));
        });

        rangeMax.addEventListener('input', (event) => {
          const nextRangesReversed = Number.parseFloat(rangeMin.value) > Number.parseFloat(event.target.value);
          const rolesChanged = nextRangesReversed !== rangesReversed;

          rangesReversed = nextRangesReversed;
          applyFilter(syncPhysicalRangeValues(rolesChanged), false);
          this.dispatchEvent(new CustomEvent('raiman:facet-range-change', { bubbles: true }));
        });

        rangeGroup.addEventListener('pointerdown', moveClosestHandle);
        rangeGroup.addEventListener('pointermove', dragClosestHandle);
        rangeGroup.addEventListener('pointerup', stopDragging);
        rangeGroup.addEventListener('pointercancel', stopDragging);

        [rangeMin, rangeMax].forEach((range) => {
          range.addEventListener('change', (event) => {
            event.stopPropagation();
            const state = syncPhysicalRangeValues();

            normalizePhysicalRangeOrder();
            applyFilter(state);
          });
        });
      }
    }

    customElements.define('center-stone-carat-range', CenterStoneCaratRange);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["center-stone-clarity-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grouped-label-filter-control')) {
    class GroupedLabelFilterControl extends HTMLElement {
      connectedCallback() {
        this.hidden = false;
        this.parentElement
          ?.querySelectorAll('noscript[data-grouped-label-no-js]')
          .forEach((fallback) => fallback.remove());

        const controller = this.querySelector('[data-grouped-label-controller]');

        if (!controller || controller.dataset.groupedLabelReady === 'true') {
          return;
        }

        controller.dataset.groupedLabelReady = 'true';
        this.syncController();

        controller.addEventListener('change', (event) => {
          event.stopPropagation();
          controller.indeterminate = false;
          this.syncValues(true);
        });
      }

      syncController() {
        const controller = this.querySelector('[data-grouped-label-controller]');
        const values = Array.from(this.querySelectorAll('[data-grouped-label-value]'));

        if (!controller) {
          return;
        }

        const activeValueCount = values.filter((input) => input.checked).length;

        controller.checked = values.length > 0 && activeValueCount === values.length;
        controller.indeterminate = activeValueCount > 0 && activeValueCount < values.length;
      }

      syncValues(notify = false) {
        const controller = this.querySelector('[data-grouped-label-controller]');
        const values = Array.from(this.querySelectorAll('[data-grouped-label-value]'));

        if (!controller) {
          return;
        }

        values.forEach((input) => {
          input.checked = controller.checked;
        });

        if (notify) {
          values[0]?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('grouped-label-filter-control', GroupedLabelFilterControl);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets-live-counts"] && !Shopify.designMode) return;
  try {
    if (!window.raimanFacetsLiveCountsReady) {
    window.raimanFacetsLiveCountsReady = true;

    const stockParam = window.RRCatalogAvailability?.param || 'filter.v.availability';
    const stockURL = url => window.RRCatalogAvailability?.normalize(url) || url;
    let refreshTimer;
    let refreshController;
    const resultsFadeDuration = 200;
    const facetCountFadeDuration = 160;
    const facetCountFadeTimers = new WeakMap();
    const facetDrawerScrollAnimations = new WeakMap();
    const groupedColorBaseline = new Map();
    const groupedMetalBaseline = new Map();
    const clarityBaseline = new Map();
    const singleOptionFacetBaseline = new Map();
    let groupedColorBaselinePath = '';
    let groupedColorBaselineReady = false;
    let groupedColorBaselinePromise;
    let initialDrawerStateHandled = false;
    let activePushLayoutRuntime = null;
    let toolbarLayoutCleanup;

    const initializeToolbarLayout = () => {
      toolbarLayoutCleanup?.();
      const section = document.querySelector('.shopify-section--main-collection');
      const banner = document.querySelector('.shopify-section--collection-banner');
      const title = banner?.querySelector('.h1');
      const subtitle = banner?.querySelector('.collection-banner__subtitle');
      const toolbar = section?.querySelector('.collection-toolbar');
      const list = toolbar?.querySelector('.collection-toolbar__button-list');
      if (!title || !subtitle || !list) return;
      let frame;
      let disposed = false;
      const update = () => {
        frame = null;
        if (!toolbar.isConnected) return;
        const header = document.querySelector('.shopify-section--header');
        const logo = document.querySelector('.header__logo');
        if (header?.getBoundingClientRect && logo?.getBoundingClientRect && banner?.style) {
          const inset = getRestingBottom(header) - getRestingBottom(logo);
          banner.style.setProperty('--rr-logo-bottom-inset', `${Math.max(0, inset)}px`);
        }
        const range = document.createRange();
        range.selectNodeContents(title);
        const titleBounds = range.getBoundingClientRect();
        const bounds = section.getBoundingClientRect();
        const controlsWidth = [...list.querySelectorAll('.collection-toolbar__button')]
          .reduce((width, button) => width + button.getBoundingClientRect().width, 0);
        const gutter = Number.parseFloat(getComputedStyle(section).getPropertyValue('--container-gutter')) || 0;
        const controlsLeft = bounds.right - Math.max(0, gutter - 23) - controlsWidth;
        const combined = [...list.querySelectorAll('.rr-filter-sort-button')].some(button => button.getBoundingClientRect().width > 0);
        const below = combined || window.innerWidth < 700 || titleBounds.right + 24 > controlsLeft;
        toolbar.toggleAttribute('data-rr-below-subtitle', below);
        if (below) {
          const gap = combined ? (window.innerWidth < 700 ? 40 : 32) : Math.max(0, subtitle.getBoundingClientRect().top - title.getBoundingClientRect().bottom);
          if (combined) {
            toolbar.style.setProperty('--rr-toolbar-collapse-space', `${toolbar.getBoundingClientRect().height + gap}px`);
            section.style.setProperty('--rr-toolbar-collapse-space', `${toolbar.getBoundingClientRect().height + gap}px`);
          }
          const currentMargin = Number.parseFloat(getComputedStyle(toolbar).marginTop) || 0;
          const naturalTop = toolbar.getBoundingClientRect().top - currentMargin;
          const margin = subtitle.getBoundingClientRect().bottom + gap - naturalTop;
          const value = `${Math.round(margin * 100) / 100}px`;
          if (toolbar.style.getPropertyValue('--rr-toolbar-flow-offset') !== value) {
            toolbar.style.setProperty('--rr-toolbar-flow-offset', value);
          }
        } else {
          toolbar.style.removeProperty('--rr-toolbar-flow-offset');
        }
      };
      const schedule = () => {
        if (!disposed && !frame) frame = requestAnimationFrame(update);
      };
      // Header hide-on-scroll moves the inner header while the section keeps
      // its layout box. Measure both elements in their resting coordinate
      // space so a filter refresh during the return-to-top cannot preserve a
      // transient transform as collection intro spacing.
      const getRestingBottom = (element) => {
        if (!element?.getBoundingClientRect) return 0;
        let bottom = element.getBoundingClientRect().bottom;
        for (let ancestor = element; ancestor; ancestor = ancestor.parentElement) {
          if (!ancestor.matches?.('.header, .shopify-section--header')) continue;
          const transform = window.getComputedStyle(ancestor).transform;
          if (!transform || transform === 'none') continue;
          let translateY = 0;
          if (window.DOMMatrixReadOnly) {
            const matrix = new window.DOMMatrixReadOnly(transform);
            translateY = Number.isFinite(matrix.m42) ? matrix.m42 : 0;
          } else {
            const values = transform.match(/^matrix(?:3d)?\(([^)]+)\)$/)?.[1]
              ?.split(',').map(Number);
            translateY = values?.length === 16 ? values[13] : values?.length === 6 ? values[5] : 0;
          }
          bottom -= Number.isFinite(translateY) ? translateY : 0;
        }
        return bottom;
      };
      const observer = new ResizeObserver(schedule);
      [section, title, subtitle, list, ...list.querySelectorAll('.collection-toolbar__button')]
        .forEach(element => observer.observe(element));
      window.addEventListener('resize', schedule, { passive: true });
      document.fonts?.ready.then(schedule);
      toolbarLayoutCleanup = () => {
        disposed = true;
        observer.disconnect();
        window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame);
      };
      update();
      // Reveal only after font metrics and the subtitle-relative position agree.
      Promise.resolve(document.fonts?.ready).then(() => {
        if (disposed) return;
        requestAnimationFrame(() => {
          if (disposed) return;
          update();
          section.removeAttribute('data-rr-toolbar-pending');
        });
      });
    };

    const waitForResultsFade = (element) => {
      if (!element || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        let timeout;

        const finish = (event) => {
          if (event && (event.target !== element || event.propertyName !== 'opacity')) {
            return;
          }

          element.removeEventListener('transitionend', finish);
          window.clearTimeout(timeout);
          resolve();
        };

        element.addEventListener('transitionend', finish);
        timeout = window.setTimeout(finish, resultsFadeDuration + 80);
      });
    };

    const fadeResultsBackIn = (element) => {
      if (!element) {
        return;
      }

      element.classList.add('facets-live-results--transitioning', 'facets-live-results--entering');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.classList.remove('facets-live-results--entering');

          waitForResultsFade(element).then(() => {
            element.classList.remove('facets-live-results--transitioning');
          });
        });
      });
    };

    window.raimanCollectionResultsTransition = {
      leave(element) {
        element?.setAttribute('aria-busy', 'true');
        element?.classList.add('facets-live-results--transitioning', 'facets-live-results--leaving');
        return waitForResultsFade(element);
      },
      enter: fadeResultsBackIn,
      restore(element) {
        element?.classList.remove('facets-live-results--leaving', 'facets-live-results--entering');
        element?.removeAttribute('aria-busy');
        return waitForResultsFade(element).then(() => {
          element?.classList.remove('facets-live-results--transitioning');
        });
      }
    };

    const scrollPageToTop = () => {
      if (window.scrollY <= 0) {
        return;
      }

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';

      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior });
      });
    };

    const getFacetDrawerVignetteTop = (facetsDrawer, scrollArea) => {
      const visibleBodyBottom = Math.min(
        scrollArea.getBoundingClientRect().bottom,
        window.innerHeight
      );
      const footer = facetsDrawer.shadowRoot?.querySelector('[part~="footer"]');

      if (!footer) {
        return visibleBodyBottom;
      }

      if (window.innerWidth < 1000 && !facetsDrawer.querySelector('[slot="footer"].has-active-filters')) {
        const shortVignetteHeight = 1.5 * Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize);
        return visibleBodyBottom - shortVignetteHeight;
      }

      const footerRect = footer.getBoundingClientRect();
      const footerStyle = window.getComputedStyle(footer);

      if (footerStyle.display === 'none') {
        return visibleBodyBottom;
      }

      if (footerStyle.backgroundImage === 'none') {
        return Math.min(visibleBodyBottom, footerRect.top);
      }

      const backgroundSize = footerStyle.backgroundSize
        .split(',')[window.innerWidth < 1000 ? 1 : 0]
        .trim()
        .split(/\s+/);
      const blockSizeToken = backgroundSize[1] || 'auto';
      let vignetteHeight = footerRect.height;

      if (blockSizeToken.endsWith('%')) {
        vignetteHeight = footerRect.height * Number.parseFloat(blockSizeToken) / 100;
      } else if (blockSizeToken.endsWith('px')) {
        vignetteHeight = Number.parseFloat(blockSizeToken);
      }

      if (!Number.isFinite(vignetteHeight)) {
        vignetteHeight = footerRect.height;
      }

      const remainingFooterHeight = footerRect.height - vignetteHeight;
      const blockPosition = footerStyle.backgroundPositionY.split(',')[0].trim();
      let vignetteOffset = 0;

      if (blockPosition === 'bottom') {
        vignetteOffset = remainingFooterHeight;
      } else if (blockPosition === 'center') {
        vignetteOffset = remainingFooterHeight / 2;
      } else if (blockPosition.endsWith('%')) {
        vignetteOffset = remainingFooterHeight * Number.parseFloat(blockPosition) / 100;
      } else if (blockPosition.endsWith('px')) {
        vignetteOffset = Number.parseFloat(blockPosition);
      }

      if (!Number.isFinite(vignetteOffset)) {
        vignetteOffset = 0;
      }

      return Math.min(visibleBodyBottom, footerRect.top + vignetteOffset);
    };

    const getVignetteSafeFacetScrollTarget = (
      accordion,
      facetsDrawer,
      scrollArea,
      minimumScrollTop
    ) => {
      const overflow = accordion.getBoundingClientRect().bottom
        - getFacetDrawerVignetteTop(facetsDrawer, scrollArea);

      if (overflow <= 0) {
        return minimumScrollTop;
      }

      const maxScrollTop = Math.max(0, scrollArea.scrollHeight - scrollArea.clientHeight);

      return Math.min(
        maxScrollTop,
        Math.max(minimumScrollTop, scrollArea.scrollTop + overflow)
      );
    };

    const scrollExpandedFilterAboveDrawerVignette = (details) => {
      const accordion = details?.closest('accordion-disclosure.facet-filter');
      const facetsDrawer = details?.closest('#facets-drawer');
      const facetsForm = details?.closest('facets-form');
      const sectionId = facetsForm?.getAttribute('section-id');
      const owningSection = sectionId
        ? document.getElementById(`shopify-section-${sectionId}`)
        : null;
      const ownsSupportedFacetPage = owningSection?.matches(
        '.shopify-section--main-collection, .shopify-section--main-search'
      );
      const scrollArea = facetsDrawer?.shadowRoot?.querySelector('[part~="body"]');

      if (
        !accordion
        || !scrollArea
        || !ownsSupportedFacetPage
        || !facetsDrawer.hasAttribute('open')
        || details.getAttribute('aria-expanded') !== 'true'
      ) {
        return;
      }

      const previousAnimation = facetDrawerScrollAnimations.get(scrollArea);

      if (previousAnimation) {
        cancelAnimationFrame(previousAnimation);
        facetDrawerScrollAnimations.delete(scrollArea);
      }

      const vignetteTop = getFacetDrawerVignetteTop(facetsDrawer, scrollArea);
      const expandedAccordionBottom = accordion.getBoundingClientRect().top
        + details.scrollHeight;

      if (expandedAccordionBottom <= vignetteTop) {
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        requestAnimationFrame(() => {
          const openingAnimations = details.getAnimations?.({ subtree: true }) || [];
          const finish = () => {
            if (
              details.isConnected
              && facetsDrawer.hasAttribute('open')
              && details.getAttribute('aria-expanded') === 'true'
            ) {
              scrollArea.scrollTop = getVignetteSafeFacetScrollTarget(
                accordion,
                facetsDrawer,
                scrollArea,
                scrollArea.scrollTop
              );
            }
          };

          if (openingAnimations.length === 0) {
            finish();
            return;
          }

          Promise.allSettled(openingAnimations.map((animation) => animation.finished))
            .then(() => requestAnimationFrame(finish));
        });
        return;
      }

      const startTime = performance.now();
      const startScrollTop = scrollArea.scrollTop;
      const duration = 420;
      let targetScrollTop = startScrollTop;
      const animate = (currentTime) => {
        if (
          !details.isConnected
          || details.getAttribute('aria-expanded') !== 'true'
          || !facetsDrawer.hasAttribute('open')
        ) {
          facetDrawerScrollAnimations.delete(scrollArea);
          return;
        }

        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        targetScrollTop = Math.max(
          targetScrollTop,
          getVignetteSafeFacetScrollTarget(
            accordion,
            facetsDrawer,
            scrollArea,
            startScrollTop
          )
        );

        scrollArea.scrollTop = startScrollTop
          + (targetScrollTop - startScrollTop) * easedProgress;

        if (progress < 1) {
          facetDrawerScrollAnimations.set(
            scrollArea,
            requestAnimationFrame(animate)
          );
        } else {
          scrollArea.scrollTop = targetScrollTop;
          facetDrawerScrollAnimations.delete(scrollArea);
        }
      };

      facetDrawerScrollAnimations.set(scrollArea, requestAnimationFrame(animate));
    };

    const buildPreviewUrl = (facetsForm) => {
      const form = facetsForm.querySelector('form');
      const formData = new FormData(form);
      const url = new URL(form.action, window.location.origin);

      url.search = '';

      formData.forEach((value, key) => {
        url.searchParams.append(key, value);
      });

      ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((key) => {
        if (url.searchParams.get(key) === '') {
          url.searchParams.delete(key);
        }
      });

      const currentUrl = new URL(window.location.href);
      const activeSortControl = document.querySelector(
        '#sort-by-popover [data-rr-sort-control-row].is-active'
      );
      const activeSortDirection = activeSortControl?.dataset.rrSortDirection;
      const activeSortCriterion = activeSortControl?.dataset.rrSortControlRow;
      const selectedShopifySort = document.querySelector(
        '#sort-by-popover [role="option"][aria-selected="true"]:not([data-rr-sort-label-toggle])'
      )?.value;
      let currentCustomSort = currentUrl.searchParams.get('rr_sort');
      let currentShopifySort = currentUrl.searchParams.get('sort_by');

      if (
        (activeSortDirection === 'ascending' || activeSortDirection === 'descending')
        && activeSortCriterion === 'carat'
      ) {
        currentCustomSort = activeSortDirection;
        currentShopifySort = null;
      } else if (
        (activeSortDirection === 'ascending' || activeSortDirection === 'descending')
        && activeSortCriterion === 'price'
      ) {
        currentCustomSort = null;
        currentShopifySort = `price-${activeSortDirection}`;
      } else if (!currentCustomSort && currentShopifySort && selectedShopifySort) {
        currentShopifySort = selectedShopifySort;
      }

      url.searchParams.delete('rr_sort');
      url.searchParams.delete('sort_by');

      if (currentCustomSort) {
        url.searchParams.set('rr_sort', currentCustomSort);
      } else if (currentShopifySort) {
        url.searchParams.set('sort_by', currentShopifySort);
      }

      window.RRPastDesignPrice?.decorateUrl(url);
      url.searchParams.set('section_id', facetsForm.getAttribute('section-id'));

      return stockURL(url);
    };

    const readGroupedColorBaseline = (sourceForm) => {
      groupedColorBaseline.clear();

      sourceForm.querySelectorAll('[data-color-group]').forEach((option) => {
        const countElement = option.querySelector('.facet-option-count');
        const countText = countElement?.textContent.trim() || '0';
        const parsedCount = Number.parseInt(countText.replace(/[^\d]/g, ''), 10);

        groupedColorBaseline.set(option.dataset.colorGroup, {
          count: Number.isNaN(parsedCount) ? 0 : parsedCount,
          countText
        });
      });
    };

    const readClarityBaseline = (sourceForm) => {
      clarityBaseline.clear();

      sourceForm.querySelectorAll('[data-clarity-filter-option]').forEach((option) => {
        const countElement = option.querySelector('.facet-option-count');
        const countText = countElement?.textContent.trim() || '0';
        const parsedCount = Number.parseInt(countText.replace(/[^\d]/g, ''), 10);

        clarityBaseline.set(option.dataset.clarityFilterOption, {
          count: Number.isNaN(parsedCount) ? 0 : parsedCount,
          countText
        });
      });
    };

    const readGroupedMetalBaseline = (sourceForm) => {
      groupedMetalBaseline.clear();

      sourceForm.querySelectorAll('[data-metal-group]').forEach((option) => {
        const countElement = option.querySelector('.facet-option-count');
        const countText = countElement?.textContent.trim() || '0';
        const parsedCount = Number.parseInt(countText.replace(/[^\d]/g, ''), 10);

        groupedMetalBaseline.set(option.dataset.metalGroup, {
          count: Number.isNaN(parsedCount) ? 0 : parsedCount,
          countText
        });
      });
    };

    const groupedFacetOptionSelector = [
      'grouped-filter-control[data-color-group]',
      'grouped-metal-filter-control[data-metal-group]',
      'grouped-label-filter-control'
    ].join(', ');

    const getFacetIdentity = (accordion) => {
      return Array.from(accordion.classList).find((className) => (
        className.startsWith('facet-filter--param-')
      ));
    };

    const baselineOptionHasResults = (option) => {
      const countElement = option.querySelector('.facet-option-count');

      if (!countElement) {
        return true;
      }

      const parsedCount = Number.parseInt(
        countElement.textContent.replace(/[^\d]/g, ''),
        10
      );

      return Number.isNaN(parsedCount) || parsedCount > 0;
    };

    // Visibility uses collection + availability only, never the narrowed live counts.
    // Keep the final visibility marker synchronous; animate the occupied space before hiding.
    const availabilityMotions = new WeakMap();
    const setAvailabilityHidden = (node, hidden) => {
      if (node.matches?.('.checkbox-control')) node.parentElement?.setAttribute('data-rr-availability-stack', '');
      const previous = node.hasAttribute('data-rr-availability-hidden');
      const initialized = node.hasAttribute('data-rr-availability-ready');
      node.toggleAttribute('data-rr-availability-ready', true);
      if (initialized && previous === hidden) return;
      const start = node.getBoundingClientRect?.().height || 0;
      const interrupted = availabilityMotions.has(node) && node.animate ? getComputedStyle(node) : null;
      const currentMargin = interrupted?.marginBottom;
      const opacity = previous && !availabilityMotions.has(node) ? '0' : node.animate ? getComputedStyle(node).opacity : '1';
      availabilityMotions.get(node)?.cancel();
      node.toggleAttribute('data-rr-availability-animating', false);
      node.toggleAttribute('data-rr-availability-hidden', hidden);
      if (!hidden) node.hidden = false;
      if (!initialized || !node.animate || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      node.toggleAttribute('data-rr-availability-animating', true);
      const style = getComputedStyle(node);
      const end = hidden ? 0 : node.getBoundingClientRect().height;
      const expanded = {height: `${hidden ? start : end}px`, opacity: style.opacity, paddingTop: style.paddingTop, paddingBottom: style.paddingBottom, marginTop: style.marginTop, marginBottom: style.marginBottom};
      const siblings = Array.from(node.parentElement.children).filter(sibling => sibling !== node && !sibling.hidden && !sibling.hasAttribute('data-rr-availability-hidden'));
      const gap = siblings.length ? parseFloat(getComputedStyle(node.parentElement).rowGap) || 0 : 0;
      const collapsed = {height: '0px', opacity: '0', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: `${-gap}px`};
      const animation = node.animate([
        {...(previous ? collapsed : expanded), height: `${start}px`, opacity, ...(currentMargin ? {marginBottom: currentMargin} : {})},
        hidden ? collapsed : expanded
      ], {duration: 300, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'both'});
      availabilityMotions.set(node, animation);
      // Hold the starting frame while the result grid commits its DOM changes.
      animation.pause();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (availabilityMotions.get(node) === animation) animation.play();
      }));
      animation.onfinish = () => {
        if (availabilityMotions.get(node) !== animation) return;
        node.toggleAttribute('data-rr-availability-animating', false);
        animation.cancel(); availabilityMotions.delete(node);
      };
    };
    window.RRSetAvailabilityHidden = setAvailabilityHidden;
    const waitForAvailabilityMotion = root => Promise.allSettled(
      Array.from(root?.querySelectorAll('[data-rr-availability-animating]') || [])
        .map(node => availabilityMotions.get(node)?.finished)
    );
    window.RRAvailabilityMotionReady = waitForAvailabilityMotion;
    const availabilityModeCache = new Map();
    const suspendedAvailabilityOptions = new Map();
    let availabilityScope = '';
    const availabilityOptionKey = option => {
      if (option.matches(groupedFacetOptionSelector)) return option.querySelector('input[id]')?.id;
      const input = option.querySelector('input[name^="filter."]');
      return input ? `${input.name}=${input.value}` : undefined;
    };
    const availabilityOptions = root => Array.from(root.querySelectorAll('.facet-option-count'))
      .map(count => count.closest(groupedFacetOptionSelector) || count.closest('.checkbox-control'))
      .filter((option, index, all) => option && all.indexOf(option) === index
        && !option.closest('noscript, rr-availability-filter, formatted-price-range, center-stone-carat-range'));
    const availabilityMode = root => Array.from(root.querySelectorAll('rr-availability-filter input[type="checkbox"]:checked'))
      .map(input => input.value).sort().join(',');
    const applyAvailabilityVisibility = (root, deferVisibility = false) => {
      if(window.RRSearchPage?.active)return false;
      const mode = availabilityMode(root);
      const baseline = availabilityModeCache.get(`${availabilityScope}|${mode}`)?.options;
      if (!baseline) return false;
      let changed = false;
      availabilityOptions(root).forEach(option => {
        const key = availabilityOptionKey(option);
        if (!key) return;
        const allowed = mode !== '' && baseline.get(key) === true;
        const inputs = Array.from(option.querySelectorAll('input'));
        if (!allowed) {
          if (!suspendedAvailabilityOptions.has(key) && inputs.some(input => input.checked || input.indeterminate)) {
            suspendedAvailabilityOptions.set(key, inputs.map(input => ({
              id: input.id, name: input.name, value: input.value,
              checked: input.checked, indeterminate: input.indeterminate
            })));
          }
          inputs.forEach(input => {
            if (input.type === 'checkbox' || input.type === 'radio') {
              changed ||= input.checked || input.indeterminate;
              input.checked = false; input.indeterminate = false;
            } else if (input.name.startsWith('rr_') && input.value) {
              changed = true; input.value = '';
            }
          });
        } else if (suspendedAvailabilityOptions.has(key)) {
          const saved = suspendedAvailabilityOptions.get(key);
          inputs.forEach(input => {
            const state = saved.find(item => input.id ? item.id === input.id : item.name === input.name && (input.type === 'hidden' || item.value === input.value));
            if (!state) return;
            input.checked = state.checked; input.indeterminate = state.indeterminate;
            if (input.type === 'hidden') input.value = state.value;
          });
          option.syncController?.();
          suspendedAvailabilityOptions.delete(key);
          changed = true;
        }
        if (!deferVisibility) {
          setAvailabilityHidden(option, !allowed);
          if (allowed) option.hidden = false;
        }
      });
      if (deferVisibility) return changed;
      root.querySelectorAll('accordion-disclosure.facet-filter').forEach(accordion => {
        const options = availabilityOptions(accordion);
        const singleOption = singleOptionFacetBaseline.get(getFacetIdentity(accordion)) === 1;
        setAvailabilityHidden(accordion, singleOption || (options.length > 0
          && options.every(option => option.hasAttribute('data-rr-availability-hidden'))));
      });
      root.querySelectorAll('.facets-filter-group').forEach(group => {
        const accordions = Array.from(group.querySelectorAll('accordion-disclosure.facet-filter'));
        setAvailabilityHidden(group, accordions.length > 0
          && accordions.every(accordion => accordion.hidden || accordion.hasAttribute('data-rr-availability-hidden')));
      });
      return changed;
    };
    // Shopify can omit a value entirely in a narrowed initial response.
    const mergeAvailabilityOptions = (root, source) => {
      const existing = new Map(availabilityOptions(root).map(option => [availabilityOptionKey(option), option]));
      availabilityOptions(source).forEach(option => {
        const key = availabilityOptionKey(option);
        if (!key || existing.has(key)) return;
        const sourceAccordion = option.closest('accordion-disclosure.facet-filter');
        const identity = getFacetIdentity(sourceAccordion);
        const targetAccordion = Array.from(root.querySelectorAll('accordion-disclosure.facet-filter'))
          .find(accordion => getFacetIdentity(accordion) === identity);
        if (!targetAccordion) return;
        const path = [];
        let parent = option.parentElement;
        while (parent && parent !== sourceAccordion) {
          path.unshift(Array.from(parent.parentElement.children).indexOf(parent));
          parent = parent.parentElement;
        }
        const targetParent = path.reduce((node, index) => node?.children[index], targetAccordion);
        if (!targetParent) return;
        const clone = option.cloneNode(true);
        clone.querySelectorAll('input').forEach(input => {
          input.checked = false; input.indeterminate = false;
          input.removeAttribute('checked');
          if (input.id) {
            const originalId = input.id;
            input.id = `${originalId}-availability-${existing.size}`;
            clone.querySelectorAll('label').forEach(label => {
              if (label.htmlFor === originalId) label.htmlFor = input.id;
            });
          }
        });
        // Grouped controller IDs are hashes and are the stable option identity.
        if (option.matches(groupedFacetOptionSelector)) {
          const original = option.querySelector('input[id]');
          const controller = clone.querySelector('input[id]');
          clone.querySelectorAll('label').forEach(label => {
            if (label.htmlFor === controller.id) label.htmlFor = original.id;
          });
          controller.id = original.id;
        }
        clone.toggleAttribute('data-rr-availability-ready', true);
        clone.toggleAttribute('data-rr-availability-hidden', true);
        targetParent.append(clone);
        existing.set(key, clone);
      });
    };
    const prepareAvailabilityOptions = async (root, deferVisibility = false) => {
      if(window.RRSearchPage?.active)return false;
      if (!root?.querySelector('rr-availability-filter')) return false;
      const form = root.querySelector('form');
      const url = new URL(form.action, location.origin);
      const scope = `${(window.RRCatalogAvailability?.base(url) || url).pathname}|${root.getAttribute('section-id')}`;
      if (availabilityScope !== scope) {
        availabilityScope = scope; availabilityModeCache.clear(); suspendedAvailabilityOptions.clear();
      }
      const mode = availabilityMode(root);
      const key = `${scope}|${mode}`;
      if (!availabilityModeCache.has(key)) {
        url.search = '';
        url.searchParams.set('section_id', root.getAttribute('section-id'));
        url.searchParams.set('rr_availability', 'selected');
        for (const value of mode.split(',').filter(Boolean)) url.searchParams.append(stockParam, value);
        const entry = {};
        entry.promise = fetch(stockURL(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(response => { if (!response.ok) throw new Error('Unable to load availability options.'); return response.text(); })
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const base = doc.querySelector('#facets-drawer facets-form');
            if (!base) throw new Error('Availability options missing from collection response.');
            entry.source = base;
            const empty = window.RRCatalogAvailability?.empty(url) === true;
            entry.options = new Map(availabilityOptions(base).map(option => [availabilityOptionKey(option), !empty && baselineOptionHasResults(option)]));
          }).catch(error => { availabilityModeCache.delete(key); throw error; });
        availabilityModeCache.set(key, entry);
      }
      await availabilityModeCache.get(key).promise;
      if (!root.isConnected || availabilityMode(root) !== mode || availabilityScope !== scope) return false;
      mergeAvailabilityOptions(root, availabilityModeCache.get(key).source);
      return applyAvailabilityVisibility(root, deferVisibility);
    };
    window.RRAvailabilityOptions = { reset: () => suspendedAvailabilityOptions.clear() };

    const getLogicalFacetOptionCount = (accordion) => {
      const logicalOptions = [];

      accordion.querySelectorAll(groupedFacetOptionSelector).forEach((option) => {
        if (baselineOptionHasResults(option)) {
          logicalOptions.push(option);
        }
      });

      accordion.querySelectorAll('.accordion__content .checkbox-control').forEach((option) => {
        if (
          option.matches(groupedFacetOptionSelector)
          || option.closest(groupedFacetOptionSelector)
          || option.closest('noscript, formatted-price-range, center-stone-carat-range')
        ) {
          return;
        }

        const directFilterInput = Array.from(option.children).find((child) => (
          child.matches?.('input[type="checkbox"][name^="filter."], input[type="radio"][name^="filter."]')
        ));

        if (directFilterInput && baselineOptionHasResults(option)) {
          logicalOptions.push(option);
        }
      });

      accordion.querySelectorAll('.accordion__content input.sr-only[name^="filter."]').forEach((input) => {
        if (
          input.closest('.checkbox-control')
          || input.closest(groupedFacetOptionSelector)
          || input.closest('noscript, formatted-price-range, center-stone-carat-range')
        ) {
          return;
        }

        logicalOptions.push(input);
      });

      return logicalOptions.length;
    };

    const readSingleOptionFacetBaseline = (sourceForm) => {
      singleOptionFacetBaseline.clear();

      sourceForm.querySelectorAll(
        'accordion-disclosure.facet-filter--single-option-eligible'
      ).forEach((accordion) => {
        const facetIdentity = getFacetIdentity(accordion);

        if (facetIdentity) {
          singleOptionFacetBaseline.set(
            facetIdentity,
            getLogicalFacetOptionCount(accordion)
          );
        }
      });
    };

    const applySingleOptionFacetBaseline = (targetForm) => {
      if (!targetForm) {
        return;
      }

      targetForm.querySelectorAll(
        'accordion-disclosure.facet-filter--single-option-eligible'
      ).forEach((accordion) => {
        const facetIdentity = getFacetIdentity(accordion);
        const logicalOptionCount = facetIdentity
          ? singleOptionFacetBaseline.get(facetIdentity)
          : undefined;

        accordion.hidden = logicalOptionCount === 1;
        if (logicalOptionCount !== undefined) {
          accordion.classList.remove('facet-filter--single-option-pending');
        }
      });

      targetForm.querySelectorAll('.facets-filter-group').forEach((filterGroup) => {
        const facetAccordions = Array.from(
          filterGroup.querySelectorAll('accordion-disclosure.facet-filter')
        );

        filterGroup.hidden = facetAccordions.length > 0
          && facetAccordions.every((accordion) => accordion.hidden);
      });
    };

    const applySingleOptionFacetBaselineToSection = (sourceForm) => {
      const sectionId = sourceForm?.getAttribute('section-id');

      if (!sectionId) {
        applySingleOptionFacetBaseline(sourceForm);
        return;
      }

      document.querySelectorAll(
        `facets-form[section-id="${CSS.escape(sectionId)}"]`
      ).forEach((facetsForm) => {
        applySingleOptionFacetBaseline(facetsForm);
      });
    };

    const updateFacetCount = (countElement, nextValue) => {
      if (!countElement) {
        return;
      }

      const nextText = String(nextValue).trim();
      const pendingUpdate = facetCountFadeTimers.get(countElement);

      if (pendingUpdate?.nextText === nextText) {
        return;
      }

      if (pendingUpdate) {
        window.clearTimeout(pendingUpdate.timer);
        facetCountFadeTimers.delete(countElement);
      }

      if (countElement.textContent.trim() === nextText) {
        countElement.classList.remove('facet-option-count--updating');
        return;
      }

      const replaceCount = () => {
        facetCountFadeTimers.delete(countElement);

        if (!countElement.isConnected) {
          return;
        }

        countElement.textContent = nextText;
        updateZeroCountOptionStates(countElement.closest('facets-form'));

        requestAnimationFrame(() => {
          countElement.classList.remove('facet-option-count--updating');
        });
      };

      if (countElement.closest('[data-rr-availability-hidden]') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        replaceCount();
        return;
      }

      countElement.classList.add('facet-option-count--updating');

      const timer = window.setTimeout(replaceCount, facetCountFadeDuration);
      facetCountFadeTimers.set(countElement, { nextText, timer });
    };

    const applyGroupedColorBaseline = (targetForm, contextualForm = targetForm) => {
      if (!groupedColorBaselineReady || !targetForm) {
        return;
      }

      const contextualOptions = new Map(
        Array.from(contextualForm?.querySelectorAll('[data-color-group]') || []).map((option) => [
          option.dataset.colorGroup,
          option
        ])
      );

      targetForm.querySelectorAll('[data-color-group]').forEach((option) => {
        const baseline = groupedColorBaseline.get(option.dataset.colorGroup);

        if (!baseline) {
          option.hidden = true;
          return;
        }

        option.hidden = baseline.count === 0;

        const countElement = option.querySelector('.facet-option-count');
        const contextualCountElement = contextualOptions
          .get(option.dataset.colorGroup)
          ?.querySelector('.facet-option-count');

        if (countElement) {
          updateFacetCount(
            countElement,
            contextualCountElement
            ? contextualCountElement.textContent.trim()
              : baseline.countText
          );
        }
      });
    };

    const applyClarityBaseline = (targetForm, contextualForm = targetForm) => {
      if (!groupedColorBaselineReady || !targetForm) {
        return;
      }

      const contextualOptions = new Map(
        Array.from(contextualForm?.querySelectorAll('[data-clarity-filter-option]') || []).map((option) => [
          option.dataset.clarityFilterOption,
          option
        ])
      );

      targetForm.querySelectorAll('[data-clarity-filter-option]').forEach((option) => {
        const baseline = clarityBaseline.get(option.dataset.clarityFilterOption);

        if (!baseline) {
          option.hidden = true;
          return;
        }

        option.hidden = baseline.count === 0;

        const countElement = option.querySelector('.facet-option-count');
        const contextualCountElement = contextualOptions
          .get(option.dataset.clarityFilterOption)
          ?.querySelector('.facet-option-count');

        if (countElement) {
          updateFacetCount(
            countElement,
            contextualCountElement
            ? contextualCountElement.textContent.trim()
              : baseline.countText
          );
        }
      });
    };

    const applyGroupedMetalBaseline = (targetForm, contextualForm = targetForm) => {
      if (!groupedColorBaselineReady || !targetForm) {
        return;
      }

      const contextualOptions = new Map(
        Array.from(contextualForm?.querySelectorAll('[data-metal-group]') || []).map((option) => [
          option.dataset.metalGroup,
          option
        ])
      );

      targetForm.querySelectorAll('[data-metal-group]').forEach((option) => {
        const baseline = groupedMetalBaseline.get(option.dataset.metalGroup);

        if (!baseline) {
          option.hidden = true;
          return;
        }

        option.hidden = baseline.count === 0;

        const countElement = option.querySelector('.facet-option-count');
        const contextualCountElement = contextualOptions
          .get(option.dataset.metalGroup)
          ?.querySelector('.facet-option-count');

        if (countElement) {
          updateFacetCount(
            countElement,
            contextualCountElement
              ? contextualCountElement.textContent.trim()
              : baseline.countText
          );
        }
      });
    };

    const updateZeroCountOptionStates = (facetsForm) => {
      facetsForm?.querySelectorAll('.facet-option-count').forEach((countElement) => {
        const control = countElement.closest('.checkbox-control');
        const input = control?.querySelector(':scope > input[type="checkbox"], :scope > input[type="radio"]');

        if (!input) {
          return;
        }

        const parsedCount = Number.parseInt(
          countElement.textContent.replace(/[^\d]/g, ''),
          10
        );
        const countIsZero = !Number.isNaN(parsedCount) && parsedCount === 0;

        input.disabled = countIsZero && !input.checked && !input.indeterminate;
      });
    };

    const initializeGroupedColorBaseline = (facetsForm) => {
      if(window.RRSearchPage?.active){
        if(facetsForm){
          // Search loads a clean collection drawer before applying query counts.
          if(!groupedColorBaselineReady){readSingleOptionFacetBaseline(facetsForm);groupedColorBaselineReady=true;}
          applySingleOptionFacetBaseline(facetsForm);
        }
        return Promise.resolve();
      }
      if (!facetsForm) {
        return Promise.resolve();
      }

      const form = facetsForm.querySelector('form');

      if (!form) {
        return Promise.resolve();
      }

      const collectionUrl = window.RRCatalogAvailability?.base(form.action) || new URL(form.action, window.location.origin);

      if (groupedColorBaselinePath && groupedColorBaselinePath !== collectionUrl.pathname) {
        groupedColorBaseline.clear();
        groupedMetalBaseline.clear();
        clarityBaseline.clear();
        singleOptionFacetBaseline.clear();
        groupedColorBaselineReady = false;
        groupedColorBaselinePromise = undefined;
      }

      groupedColorBaselinePath = collectionUrl.pathname;

      if (groupedColorBaselineReady) {
        applyGroupedColorBaseline(facetsForm);
        applyGroupedMetalBaseline(facetsForm);
        applyClarityBaseline(facetsForm);
        applySingleOptionFacetBaselineToSection(facetsForm);
        return Promise.resolve();
      }

      if (groupedColorBaselinePromise) {
        return groupedColorBaselinePromise.then(() => {
          applyGroupedColorBaseline(facetsForm);
          applyGroupedMetalBaseline(facetsForm);
          applyClarityBaseline(facetsForm);
          applySingleOptionFacetBaselineToSection(facetsForm);
        });
      }

      const hasFilterParameters = Array.from(new URLSearchParams(window.location.search).keys())
        .some((name) => name.startsWith('filter.') || name.startsWith('rr_'));

      if (!hasFilterParameters) {
        readGroupedColorBaseline(facetsForm);
        readGroupedMetalBaseline(facetsForm);
        readClarityBaseline(facetsForm);
        readSingleOptionFacetBaseline(facetsForm);
        groupedColorBaselineReady = true;
        applyGroupedColorBaseline(facetsForm);
        applyGroupedMetalBaseline(facetsForm);
        applyClarityBaseline(facetsForm);
        applySingleOptionFacetBaselineToSection(facetsForm);
        return Promise.resolve();
      }

      collectionUrl.search = '';
      collectionUrl.searchParams.set('section_id', facetsForm.getAttribute('section-id'));

      groupedColorBaselinePromise = fetch(collectionUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Unable to load base collection colors (${response.status}).`);
          }

          return response.text();
        })
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const baseForm = documentFragment.querySelector('#facets-drawer facets-form');

          if (!baseForm) {
            throw new Error('Unable to find base collection color filters.');
          }

          readGroupedColorBaseline(baseForm);
          readGroupedMetalBaseline(baseForm);
          readClarityBaseline(baseForm);
          readSingleOptionFacetBaseline(baseForm);
          groupedColorBaselineReady = true;
          applyGroupedColorBaseline(facetsForm);
          applyGroupedMetalBaseline(facetsForm);
          applyClarityBaseline(facetsForm);
          applySingleOptionFacetBaselineToSection(facetsForm);
        })
        .catch((error) => {
          console.error('Unable to initialize base collection color counts.', error);
        })
        .finally(() => {
          groupedColorBaselinePromise = undefined;
        });

      return groupedColorBaselinePromise;
    };

    const copyUpdatedCounts = (currentForm, updatedForm) => {
      const inputKey = (input) => `${input.type}\u001F${input.name}\u001F${input.value}`;
      const currentInputsByValue = new Map(
        Array.from(currentForm.querySelectorAll('input[name]')).map((input) => [
          inputKey(input),
          input
        ])
      );
      updatedForm.querySelectorAll('input[id]').forEach((updatedInput) => {
        if (
          updatedInput.matches('[data-grouped-filter-controller]')
          || updatedInput.closest('formatted-price-range, center-stone-carat-range')
        ) {
          return;
        }

        const currentInput = currentInputsByValue.get(inputKey(updatedInput))
          || currentForm.querySelector(`#${CSS.escape(updatedInput.id)}`);

        if (!currentInput) {
          return;
        }

        currentInput.disabled = updatedInput.disabled;

        const updatedLabel = updatedInput.labels?.[0];
        const currentLabel = currentInput.labels?.[0];

        if (updatedLabel && currentLabel) {
          const updatedCount = updatedLabel.querySelector('.facet-option-count');
          const currentCount = currentLabel.querySelector('.facet-option-count');

          if (updatedCount && currentCount) {
            updateFacetCount(currentCount, updatedCount.textContent);
          } else {
            currentLabel.innerHTML = updatedLabel.innerHTML;
          }
        }
      });

      applyGroupedColorBaseline(currentForm, updatedForm);
      applyGroupedMetalBaseline(currentForm, updatedForm);
      applyClarityBaseline(currentForm, updatedForm);
      applySingleOptionFacetBaselineToSection(currentForm);
      updateZeroCountOptionStates(currentForm);
      applyAvailabilityVisibility(currentForm);
    };

    const getCollectionResults = (root, sectionId) => {
      const sectionSelector = `#shopify-section-${CSS.escape(sectionId)}`;
      const section = root.querySelector(sectionSelector) || root;
      const collection = section.querySelector('.collection');

      if (!collection) {
        return null;
      }

      return collection.querySelector('.collection__main')
        || Array.from(collection.children).find((element) => element.matches('.empty-state'))
        || null;
    };

    // No selected availability groups means no pieces, not Shopify's unrestricted default.
    const applyEmptyAvailabilityResults = (root, sectionId, url) => {
      const values = url.searchParams.getAll(stockParam).flatMap(value => value.split(','));
      if (!window.RRCatalogAvailability?.empty(url) && (!url.searchParams.has('rr_availability') || values.some(value => value === '1' || value === '0'))) return;
      const availability = root.querySelector('rr-availability-filter');
      const template = availability?.querySelector('[data-availability-empty-results]');
      const results = getCollectionResults(root, sectionId);
      if (!template || !results) return;
      results.replaceWith(template.content.firstElementChild.cloneNode(true));
      root.querySelectorAll('facets-form').forEach(form => { form.dataset.resultsCount = '0'; });
      root.querySelectorAll('.collection-toolbar__products-count').forEach(count => { count.textContent = '0'; });
    };

    const copyToolbarContent = (documentFragment, sectionId) => {
      const sectionSelector = `#shopify-section-${CSS.escape(sectionId)}`;
      const currentSection = document.querySelector(sectionSelector) || document;
      const updatedSection = documentFragment.querySelector(sectionSelector) || documentFragment;

      [
        '.collection-toolbar__products-count',
        'button[aria-controls="facets-drawer"]'
      ].forEach((selector) => {
        const currentElement = currentSection.querySelector(selector);
        const updatedElement = updatedSection.querySelector(selector);

        if (currentElement && updatedElement) {
          currentElement.innerHTML = updatedElement.innerHTML;
        }
      });
    };

    const getActiveFilterCount = (facetsForm) => {
      if (!facetsForm) {
        return 0;
      }

      const visibleSelectedOptions = Array.from(
        facetsForm.querySelectorAll(
          '.checkbox-control > input[type="checkbox"]:not([data-online-purchase-toggle]), .checkbox-control > input[type="radio"]'
        )
      ).filter((input) => {
        if (input.closest('rr-grid-density')) return false;
        if (input.name === stockParam) {
          const defaultValue = input.closest('rr-availability-filter')?.getAttribute('data-default-availability') || '1';
          if (input.value === defaultValue) return false;
        }
        return input.checked || input.indeterminate;
      }).length;

      const priceRange = facetsForm.querySelector('formatted-price-range');
      const priceIsActive = Array.from(
        priceRange?.querySelectorAll('input[name^="filter."]') || []
      ).some((input) => input.value.trim() !== '');

      const caratRange = facetsForm.querySelector('center-stone-carat-range');
      const caratIsActive = Array.from(
        caratRange?.querySelectorAll('input[name]') || []
      ).some((input) => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          return input.checked;
        }

        return input.value.trim() !== '';
      });

      return visibleSelectedOptions
        + (priceIsActive ? 1 : 0)
        + (caratIsActive ? 1 : 0)
        + (facetsForm.querySelector('rr-availability-filter:not([data-archive-collection])') && !facetsForm.querySelector('rr-availability-filter input[type="checkbox"]:checked') ? 1 : 0);
    };

    const syncToolbarActiveFilterCount = (facetsForm) => {
      if (!facetsForm) {
        return;
      }

      let filterButtons = Array.from(document.querySelectorAll(
        '.shopify-section--main-collection button[aria-controls="facets-drawer"]'
      ));

      if (filterButtons.length === 0) {
        filterButtons = Array.from(document.querySelectorAll(
          'button[aria-controls="facets-drawer"]'
        ));
      }

      const activeFilterCount = getActiveFilterCount(facetsForm);
      filterButtons.forEach((filterButton) => {
        const baseLabel = filterButton.dataset.facetsBaseLabel
          || filterButton.textContent.replace(/\s*(?:\(\d+\)|·\s*\d+)\s*$/, '').trim();
        let labelElement = filterButton.querySelector('[data-facets-filter-label]');
        let countBadge = filterButton.querySelector('[data-facets-active-count]');

        filterButton.dataset.facetsBaseLabel = baseLabel;
        filterButton.classList.add('facets-toolbar-filter-button');

        if (!labelElement) {
          labelElement = document.createElement('span');
          labelElement.dataset.facetsFilterLabel = '';
          labelElement.textContent = baseLabel;
          filterButton.replaceChildren(labelElement);
          countBadge = null;
        } else if (labelElement.textContent !== baseLabel) {
          labelElement.textContent = baseLabel;
        }

        if (activeFilterCount === 0) {
          countBadge?.remove();
          return;
        }

        if (!countBadge) {
          countBadge = document.createElement('span');
          countBadge.className = 'facets-toolbar-active-count';
          countBadge.dataset.facetsActiveCount = '';
          filterButton.append(countBadge);
        }

        if (countBadge.textContent !== String(activeFilterCount)) {
          countBadge.textContent = String(activeFilterCount);
        }
      });
    };

    const observeToolbarActiveFilterCount = (facetsForm) => {
      const filterButtons = document.querySelectorAll(
        'button[aria-controls="facets-drawer"]'
      );

      filterButtons.forEach((filterButton) => {
        if (filterButton.dataset.facetsCountObserverReady === 'true') {
          return;
        }

        filterButton.dataset.facetsCountObserverReady = 'true';

        new MutationObserver(() => {
          requestAnimationFrame(() => {
            syncToolbarActiveFilterCount(facetsForm);
          });
        }).observe(filterButton, {
          childList: true,
          characterData: true,
          subtree: true
        });
      });

      requestAnimationFrame(() => {
        syncToolbarActiveFilterCount(facetsForm);
      });
    };

    const hasActiveFilters = (facetsForm) => {
      return Array.from(facetsForm.querySelectorAll('input[name^="filter."]')).some((input) => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          return input.checked;
        }

        return input.value !== '';
      });
    };

    const hasActiveNonPriceFilters = (facetsForm) => {
      return Array.from(facetsForm.querySelectorAll('input[name^="filter."]')).some((input) => {
        if (input.name === 'filter.v.price.gte' || input.name === 'filter.v.price.lte') {
          return false;
        }

        if (input.type === 'checkbox' || input.type === 'radio') {
          return input.checked;
        }

        return input.value !== '';
      });
    };

    const updateActiveFilterAccordions = (facetsForm, openActive = false) => {
      facetsForm?.querySelectorAll('accordion-disclosure').forEach((accordion) => {
        const isAvailability = Boolean(accordion.closest('rr-availability-filter'));
        const archiveAvailability = Boolean(accordion.closest('rr-availability-filter[data-archive-collection]'));
        const filterIsActive = archiveAvailability
          ? !accordion.querySelector('input[value="0"]')?.checked
            || Boolean(accordion.querySelector('input[value="1"]')?.checked)
          : isAvailability
          ? !accordion.querySelector('input[value="1"]')?.checked
            || Boolean(accordion.querySelector('input[value="0"]')?.checked)
          : Array.from(
          accordion.querySelectorAll('input[name^="filter."], input[name^="rr_"]')
        ).some((input) => {
          if (input.type === 'checkbox' || input.type === 'radio') {
            return input.checked;
          }

          return input.value.trim() !== '';
        });
        accordion.classList.toggle('facet-filter-is-active', filterIsActive);
        const initialUrl = openActive ? new URL(window.location.href) : null;
        const activeInUrl = initialUrl && (isAvailability
          ? initialUrl.searchParams.getAll(stockParam).flatMap(value => value.split(',')).includes('0')
            || (initialUrl.searchParams.has('rr_availability') && !initialUrl.searchParams.has(stockParam))
          : Array.from(accordion.querySelectorAll('input[name^="filter."], input[name^="rr_"]')).some(input => {
            const values = initialUrl.searchParams.getAll(input.name);
            return input.type === 'checkbox' || input.type === 'radio'
              ? values.some(value => value.split(',').includes(input.value))
              : values.some(value => value.trim() !== '');
          }));
        if (openActive && (filterIsActive || activeInUrl || accordion.closest('rr-availability-filter[data-archive-collection]'))) {
          const details = accordion.querySelector('details');
          if (details) {
            details.open = true;
            details.setAttribute('aria-expanded', 'true');
          }
        }

      });
    };

    const ensureDrawerFooter = (facetsForm) => {
      const facetsDrawer = facetsForm.closest('#facets-drawer');
      const footer = facetsDrawer?.querySelector('[slot="footer"]');
      const viewResultsButton = footer?.querySelector('dialog-close-button button');

      if (!footer || !viewResultsButton) {
        return null;
      }

      let clearAllWrapper = footer.querySelector('[data-facets-clear-all-wrapper]');

      if (!clearAllWrapper) {
        clearAllWrapper = document.createElement('div');
        clearAllWrapper.className = 'facets-drawer-clear-all';
        clearAllWrapper.dataset.facetsClearAllWrapper = '';
        clearAllWrapper.innerHTML = `
          <div class="facets-drawer-clear-all__inner">
            <button type="button" class="button w-full" data-facets-clear-all></button>
          </div>
        `;
        footer.append(clearAllWrapper);

      }

      clearAllWrapper.querySelector('[data-facets-clear-all]').onclick = () => {
          const form = document.querySelector('#facets-drawer facets-form form');
          if (!form) return;
          if (window.RRSearchPage?.active) window.RRSearchPage.clearQuery?.();
          window.RRPastDesignPrice?.reset();
          window.RRContextualRanges?.reset(form);

          form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
            if (input.closest('rr-grid-density')) return;
            input.checked = false;
            input.indeterminate = false;
          });

          form.querySelectorAll('input[name^="filter."]:not([type="checkbox"]):not([type="radio"])').forEach((input) => {
            input.value = '';
          });

          form.querySelectorAll('[data-price-display]').forEach((input) => {
            input.value = '';
          });

          form.querySelectorAll('formatted-price-range').forEach((priceRange) => {
            if (typeof priceRange.resetRange === 'function') {
              priceRange.resetRange();
              return;
            }

            priceRange.cancelTrackClickTransition?.();
            priceRange.resetOnlinePurchaseFilter?.();
            const ranges = priceRange.querySelectorAll('input[type="range"]');
            const rangeGroup = priceRange.querySelector('.range-group');

            ranges[0].value = ranges[0].min;
            ranges[1].value = ranges[1].max;
            rangeGroup.style.setProperty('--range-min', '0%');
            rangeGroup.style.setProperty('--range-max', '100%');
          });

          form.querySelectorAll('center-stone-carat-range').forEach((caratRange) => {
            if (typeof caratRange.resetRange === 'function') {
              caratRange.resetRange();
              return;
            }

            caratRange.cancelTrackClickTransition?.();
            const minimumInput = caratRange.querySelector('[data-carat-input-min]');
            const maximumInput = caratRange.querySelector('[data-carat-input-max]');
            const minimumRange = caratRange.querySelector('[data-carat-range-min]');
            const maximumRange = caratRange.querySelector('[data-carat-range-max]');
            const rangeGroup = caratRange.querySelector('.range-group');

            [minimumInput, maximumInput].forEach((input) => {
              input.value = '';
              input.removeAttribute('name');
              delete input.dataset.caratTypedDigits;
              delete input.dataset.caratReplaceOnType;
            });

            minimumRange.value = minimumRange.min;
            maximumRange.value = maximumRange.max;
            rangeGroup.style.setProperty('--range-min', '0%');
            rangeGroup.style.setProperty('--range-max', '100%');
          });

          const defaultAvailability = (form.querySelector('rr-availability-filter')?.getAttribute('data-default-availability') || '1').split(',');
          form.querySelectorAll('rr-availability-filter input[type="checkbox"]').forEach(input => {
            input.checked = defaultAvailability.includes(input.value);
          });

          const drawer = form.closest('#facets-drawer');
          drawer?.querySelectorAll('accordion-disclosure').forEach(accordion => {
            if (typeof accordion.close === 'function') accordion.close();
            else {
              const details = accordion.querySelector('details');
              if (details) { details.open = false; details.setAttribute('aria-expanded', 'false'); }
            }
          });
          const body = drawer?.shadowRoot?.querySelector('[part~="body"]');
          if (body) {
            cancelAnimationFrame(facetDrawerScrollAnimations.get(body));
            body.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
          form.dispatchEvent(new Event('change', { bubbles: true }));
      };

      return {
        clearAllButton: clearAllWrapper.querySelector('[data-facets-clear-all]'),
        clearAllWrapper,
        footer,
        viewResultsButton
      };
    };

    const updateDrawerFooter = (currentForm, resultsForm = currentForm) => {
      const footerControls = ensureDrawerFooter(currentForm);

      if (!footerControls) {
        return;
      }

      const activeFilterCount = getActiveFilterCount(currentForm);
      const filtersAreActive = activeFilterCount > 0 || Boolean(window.RRSearchPage?.active && document.querySelector('#rr-search-query')?.value.trim());
      const applyLabel = activeFilterCount === 1
        ? currentForm.dataset.applyFilterLabel
        : currentForm.dataset.applyFiltersLabel;
      const dialogCloseButton = footerControls.viewResultsButton
        .closest('dialog-close-button');

      footerControls.clearAllButton.textContent = currentForm.dataset.clearAllLabel;
      footerControls.viewResultsButton.textContent = applyLabel;
      dialogCloseButton?.setAttribute('aria-hidden', filtersAreActive ? 'false' : 'true');

      currentForm.classList.toggle('has-active-filters', filtersAreActive);
      footerControls.footer.classList.toggle('has-active-filters', filtersAreActive);
      footerControls.footer.setAttribute('aria-hidden', filtersAreActive ? 'false' : 'true');
      footerControls.clearAllButton.tabIndex = filtersAreActive ? 0 : -1;
      footerControls.viewResultsButton.tabIndex = filtersAreActive ? 0 : -1;
      syncToolbarActiveFilterCount(currentForm);
    };

    const syncDrawerSelectionsFromUrl = (destinationUrl) => {
      const facetsForm = document.querySelector(
        '#facets-drawer facets-form:not([update-on-change])'
      );
      const form = facetsForm?.querySelector('form');

      if (!facetsForm || !form) {
        return null;
      }

      const selectedValuesByName = new Map();
      const getSelectedValues = (name) => {
        if (!selectedValuesByName.has(name)) {
          selectedValuesByName.set(
            name,
            destinationUrl.searchParams
              .getAll(name)
              .flatMap((value) => value.split(','))
          );
        }

        return selectedValuesByName.get(name);
      };

      form.querySelectorAll(
        'input[type="checkbox"][name], input[type="radio"][name]'
      ).forEach((input) => {
        input.checked = getSelectedValues(input.name).includes(input.value);
      });

      form.querySelectorAll('formatted-price-range').forEach((priceRange) => {
        const minimumInput = priceRange.querySelector('[data-price-value="minimum"]');
        const maximumInput = priceRange.querySelector('[data-price-value="maximum"]');

        priceRange.syncPriceRangeFromUrl?.(
          destinationUrl.searchParams.get(minimumInput?.name) || '',
          destinationUrl.searchParams.get(maximumInput?.name) || ''
        );
      });

      form.querySelectorAll('center-stone-carat-range').forEach((caratRange) => {
        caratRange.cancelTrackClickTransition?.();
      });

      form.querySelectorAll('[data-grouped-filter-controller]').forEach((controller) => {
        const groupedControl = controller.closest('grouped-filter-control');
        const groupedValues = groupedControl?.querySelectorAll(
          '[data-grouped-filter-value]'
        );

        controller.checked = Array.from(groupedValues || []).some((input) => input.checked);
      });

      form.querySelectorAll('[data-grouped-label-controller]').forEach((controller) => {
        const groupedControl = controller.closest('grouped-label-filter-control');
        const groupedValues = Array.from(
          groupedControl?.querySelectorAll('[data-grouped-label-value]') || []
        );
        const activeValueCount = groupedValues.filter((input) => input.checked).length;

        controller.checked = groupedValues.length > 0
          && activeValueCount === groupedValues.length;
        controller.indeterminate = activeValueCount > 0
          && activeValueCount < groupedValues.length;
      });

      form.querySelectorAll('[data-grouped-metal-controller]').forEach((controller) => {
        const groupedControl = controller.closest('grouped-metal-filter-control');
        const queryInput = groupedControl?.querySelector('[data-grouped-metal-query]');
        const groupedValues = groupedControl?.querySelectorAll(
          '[data-grouped-metal-value]'
        );

        controller.checked = queryInput
          ? queryInput.checked
          : Array.from(groupedValues || []).some((input) => input.checked);
      });

      updateActiveFilterAccordions(facetsForm);
      updateDrawerFooter(facetsForm);

      return facetsForm;
    };

    const updateBrowserUrl = (requestUrl) => {
      const storefrontUrl = new URL(requestUrl);

      storefrontUrl.searchParams.delete('section_id');
      window.history.replaceState(
        window.history.state,
        '',
        `${storefrontUrl.pathname}${storefrontUrl.search}${storefrontUrl.hash}`
      );
    };

    const showFilteringStatus = (results, signal) => {
      if (!results) return () => {};
      const status = document.createElement('div');
      status.className = 'rr-filtering-status';
      const loadingButton = document.querySelector('.rr-collection-more .button');
      if (loadingButton) {
        const loadingStyle = getComputedStyle(loadingButton);
        status.style.font = loadingStyle.font;
        status.style.letterSpacing = loadingStyle.letterSpacing;
        status.style.textTransform = loadingStyle.textTransform;
      }
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      const circle = document.createElement('span');
      circle.className = 'rr-filtering-status__spinner';
      circle.setAttribute('aria-hidden', 'true');
      const label = document.createElement('span');
      label.className = 'sr-only';
      label.textContent = 'Filtering';
      status.append(circle, label);
      let stopped = false;
      let positionFrame = null;
      const position = () => {
        const bounds = results.getBoundingClientRect();
        status.style.left = `${window.scrollX + bounds.left + bounds.width / 2}px`;
        if (status.isConnected && !stopped) status.classList.add('is-visible');
      };
      // Drawer restoration animates gallery geometry without a resize event.
      const followLayout = () => {
        if (stopped || !status.isConnected || !results.isConnected) return;
        position();
        positionFrame = requestAnimationFrame(followLayout);
      };
      if (!signal.aborted && results.isConnected) {
        position();
        document.body.append(status);
        const baseStyle = getComputedStyle(status);
        const fontSize = parseFloat(baseStyle.fontSize);
        const letterSpacing = parseFloat(baseStyle.letterSpacing) || 0;
        status.style.fontSize = `${fontSize * 1.15}px`;
        status.style.letterSpacing = `${letterSpacing * 1.15}px`;
        window.addEventListener('resize', position, { passive: true });
        window.addEventListener('scroll', position, { passive: true });
        status.getBoundingClientRect();
        positionFrame = requestAnimationFrame(followLayout);
      }
      const stop = () => {
        if (stopped) return;
        stopped = true;
        cancelAnimationFrame(positionFrame);
        window.removeEventListener('resize', position);
        window.removeEventListener('scroll', position);
        signal.removeEventListener('abort', stop);
        status.removeAttribute('role');
        status.removeAttribute('aria-live');
        status.classList.remove('is-visible');
        if (status.isConnected) setTimeout(() => status.remove(), 240);
      };
      signal.addEventListener('abort', stop, { once: true });
      return stop;
    };

    window.raimanCollectionResultsTransition.showLoading = showFilteringStatus;

    const refreshCollection = async (facetsForm) => {
      if(window.RRSearchPage?.active){
        await window.RRSearchPage.ready;
        await window.RRSearchPage.refresh(buildPreviewUrl(facetsForm));
        updateDrawerFooter(facetsForm);syncToolbarActiveFilterCount(facetsForm);
        return;
      }
      if (!facetsForm.isConnected) {
        return;
      }

      refreshController?.abort();
      const controller = new AbortController();
      refreshController = controller;
      const sectionId = facetsForm.getAttribute('section-id');
      const currentResults = getCollectionResults(document, sectionId);
      const stopFilteringStatus = showFilteringStatus(currentResults, controller.signal);
      currentResults?.setAttribute('aria-busy', 'true');
      currentResults?.classList.add('facets-live-results--transitioning', 'facets-live-results--leaving');
      const fadeOutComplete = waitForResultsFade(currentResults);
      scrollPageToTop();

      try {
        await prepareAvailabilityOptions(facetsForm, true);
        if (controller.signal.aborted || !facetsForm.isConnected) { stopFilteringStatus(); return; }
        // Start results alongside contextual bounds. Bounds may restore a selection,
        // so reuse this response only when the final query still matches.
        const earlyRequestUrl = buildPreviewUrl(facetsForm);
        const requestResults = url => fetch(url, {
          signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(response => ({ response }), error => ({ error }));
        const earlyResults = requestResults(earlyRequestUrl);
        try {
          window.RRContextualRanges ||= await import(document.querySelector('[data-rr-contextual-range-url]').dataset.rrContextualRangeUrl);
          await window.RRContextualRanges.prepare(facetsForm, buildPreviewUrl(facetsForm), controller.signal);
        } catch (error) { if (error.name !== 'AbortError') console.error(error); }
        if (controller.signal.aborted || !facetsForm.isConnected) { stopFilteringStatus(); return; }
        const requestUrl = buildPreviewUrl(facetsForm);

        const result = await (String(requestUrl) === String(earlyRequestUrl)
          ? earlyResults : requestResults(requestUrl));
        if (result.error) throw result.error;
        const response = result.response;

        if (!response.ok || !facetsForm.isConnected) {
          return;
        }

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        applyEmptyAvailabilityResults(documentFragment, sectionId, requestUrl);
        const updatedForm = documentFragment.querySelector('#facets-drawer facets-form');
        const updatedResults = getCollectionResults(documentFragment, sectionId);

        await fadeOutComplete;

        if (controller.signal.aborted || !facetsForm.isConnected) {
          return;
        }

        if (updatedForm) {
          copyUpdatedCounts(facetsForm, updatedForm);
          facetsForm.dataset.resultsCount = updatedForm.dataset.resultsCount || '0';
          updateDrawerFooter(facetsForm, updatedForm);
        }

        // Keep expensive gallery replacement out of the drawer animation frames.
        await waitForAvailabilityMotion(facetsForm);
        if (controller.signal.aborted || !facetsForm.isConnected) return;
        updateBrowserUrl(requestUrl);

        if (currentResults?.isConnected && updatedResults) {
          updatedResults.classList.add('facets-live-results--transitioning', 'facets-live-results--entering');
          currentResults.replaceWith(updatedResults);
          document.dispatchEvent(new CustomEvent('rr:collection-results-replaced', {
            detail: { root: updatedResults, drawerReplaced: false }
          }));
          fadeResultsBackIn(updatedResults);
        }

        copyToolbarContent(documentFragment, sectionId);
        syncToolbarActiveFilterCount(facetsForm);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Unable to refresh collection filters.', error);
        }
      } finally {
        stopFilteringStatus();
        if (refreshController === controller) {
          refreshController = null;
          // Release a pending price reveal even if contextual requests failed.
          window.RRPastDesignPrice?.finishRestore(facetsForm.querySelector('formatted-price-range'));

          if (currentResults?.isConnected) {
            currentResults.classList.remove('facets-live-results--leaving');

            waitForResultsFade(currentResults).then(() => {
              currentResults.classList.remove('facets-live-results--transitioning');
            });
          }

          getCollectionResults(document, sectionId)?.removeAttribute('aria-busy');
        }
      }
    };

    const scheduleRefresh = (eventTarget) => {
      window.RRPastDesignPrice?.sync();
      const facetsForm = eventTarget.closest('#facets-drawer facets-form:not([update-on-change])');

      if (!facetsForm) {
        return;
      }

      updateActiveFilterAccordions(facetsForm);
      updateDrawerFooter(facetsForm);
      clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => refreshCollection(facetsForm), 120);
    };

    document.addEventListener('change', (event) => {
      scheduleRefresh(event.target);
    });

    document.addEventListener('raiman:facet-range-change', (event) => {
      scheduleRefresh(event.target);
    });

    document.addEventListener('click', (event) => {
      const facetSummary = event.target.closest?.(
        '#facets-drawer accordion-disclosure.facet-filter > details > summary'
      );
      const details = facetSummary?.closest('details');

      if (!details) {
        return;
      }

      requestAnimationFrame(() => {
        if (details.getAttribute('aria-expanded') === 'true') {
          scrollExpandedFilterAboveDrawerVignette(details);
        }
      });
    });

    document.addEventListener('click', (event) => {
      const emptyStateClearLink = event.target.closest?.(
        '.empty-state facet-link a.button[href]'
      );

      if (!emptyStateClearLink) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const facetsForm = document.querySelector(
        '#facets-drawer facets-form:not([update-on-change])'
      );
      const footerControls = facetsForm
        ? ensureDrawerFooter(facetsForm)
        : null;

      if (footerControls) {
        footerControls.clearAllButton.click();
      } else {
        window.location.assign(emptyStateClearLink.href);
      }
    }, true);

    document.addEventListener('click', (event) => {
      const activeFacetLink = event.target.closest?.('.active-facets a[href]');

      if (!activeFacetLink) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      queueMicrotask(() => {
        const facetsForm = syncDrawerSelectionsFromUrl(
          new URL(activeFacetLink.href, window.location.origin)
        );

        if (!facetsForm) {
          window.location.assign(activeFacetLink.href);
          return;
        }

        clearTimeout(refreshTimer);
        refreshCollection(facetsForm);
      });
    }, true);

    document.addEventListener('submit', (event) => {
      const facetsForm = event.target.closest?.('#facets-drawer facets-form');
      const facetsDrawer = facetsForm?.closest('#facets-drawer');

      if (!facetsDrawer || facetsDrawer.hasAttribute('open')) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    document.addEventListener('rr:search-page-counts', () => {
      const form=document.querySelector('#facets-drawer facets-form');
      if(form){updateDrawerFooter(form);syncToolbarActiveFilterCount(form);}
    });
    document.addEventListener('rr:grid-density-change', () => {
      const form = document.querySelector('#facets-drawer facets-form');
      if (form) updateDrawerFooter(form);
    });
    const initializeDrawerFooters = () => {
      document.querySelectorAll('#facets-drawer facets-form:not([update-on-change])').forEach((facetsForm) => {
        initializeGroupedColorBaseline(facetsForm).then(() => {
          updateZeroCountOptionStates(facetsForm);
          applyAvailabilityVisibility(facetsForm);
        });
        updateZeroCountOptionStates(facetsForm);
        updateActiveFilterAccordions(facetsForm);
        if (facetsForm.dataset.rrInitialAccordionsRestored !== 'true') {
          facetsForm.dataset.rrInitialAccordionsRestored = 'true';
          requestAnimationFrame(() => updateActiveFilterAccordions(facetsForm, true));
        }
        updateDrawerFooter(facetsForm);
        observeToolbarActiveFilterCount(facetsForm);
      });
    };

    const initializeDesktopDrawerPushLayout = () => {
      const facetsDrawer = document.querySelector('#facets-drawer');

      if (!facetsDrawer) {
        activePushLayoutRuntime?.cleanup();
        return;
      }

      if (activePushLayoutRuntime?.drawer === facetsDrawer) {
        return;
      }

      activePushLayoutRuntime?.cleanup();
      facetsDrawer.dataset.pushLayoutReady = 'true';

      const desktopMedia = window.matchMedia('(min-width: 1000px)');
      const originalAriaModal = facetsDrawer.getAttribute('aria-modal');
      const isCollectionDrawer = facetsDrawer.dataset.rrCollectionDrawer === 'true';
      const fastDrawerAnimations = isCollectionDrawer;
      const drawerAnimationDuration = 300;
      const drawerAnimationPlaybackRate = 300 / drawerAnimationDuration;
      const originalCreateEnterAnimationControls = facetsDrawer.createEnterAnimationControls;
      const originalCreateLeaveAnimationControls = facetsDrawer.createLeaveAnimationControls;
      const drawerHomeAnchor = document.getElementById(
        facetsDrawer.dataset.rrDrawerHomeId || ''
      );
      const originalDrawerParent = drawerHomeAnchor?.parentElement
        || (facetsDrawer.parentElement === document.body ? null : facetsDrawer.parentElement);
      const originalDrawerNextSibling = drawerHomeAnchor?.nextSibling
        || facetsDrawer.nextSibling;
      let drawerWarmupLoadQueued = false;
      let drawerWarmupIdleCallback = 0;
      let drawerWarmupTimer = 0;
      let drawerWarmupFrame = 0;
      let drawerHasWarmed = false;
      let drawerAccordionStates = null;
      let drawerIsPrepositioned = isCollectionDrawer
        && facetsDrawer.parentElement === document.body;
      let layoutFrame = 0;
      let disposed = false;

      if (fastDrawerAnimations) {
        document.documentElement.classList.add('rr-fast-facets-drawer');
        facetsDrawer.dataset.fastAnimation = 'true';
        facetsDrawer.createEnterAnimationControls = function() {
          const animationControls = originalCreateEnterAnimationControls.call(this);

          animationControls.playbackRate = drawerAnimationPlaybackRate;
          return animationControls;
        };
        facetsDrawer.createLeaveAnimationControls = function() {
          const animationControls = originalCreateLeaveAnimationControls.call(this);

          animationControls.playbackRate = drawerAnimationPlaybackRate;
          return animationControls;
        };
      }

      const cancelScheduledDrawerWarmup = () => {
        if (drawerWarmupLoadQueued) {
          window.removeEventListener('load', queueDrawerWarmup);
          drawerWarmupLoadQueued = false;
        }

        if (drawerWarmupIdleCallback && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(drawerWarmupIdleCallback);
        }

        window.clearTimeout(drawerWarmupTimer);
        window.cancelAnimationFrame(drawerWarmupFrame);
        drawerWarmupIdleCallback = 0;
        drawerWarmupTimer = 0;
        drawerWarmupFrame = 0;
        delete facetsDrawer.dataset.rrFirstOpenWarming;
      };

      const restorePrepositionedDrawer = () => {
        cancelScheduledDrawerWarmup();

        if (!drawerIsPrepositioned) {
          return;
        }

        if (!originalDrawerParent?.isConnected) {
          drawerIsPrepositioned = false;
          facetsDrawer.remove();
          return;
        }

        if (facetsDrawer.hasAttribute('open')) {
          return;
        }

        drawerIsPrepositioned = false;

        if (facetsDrawer.parentElement !== document.body) {
          return;
        }

        if (drawerHomeAnchor?.parentNode === originalDrawerParent) {
          originalDrawerParent.insertBefore(facetsDrawer, drawerHomeAnchor.nextSibling);
        } else if (originalDrawerNextSibling?.parentNode === originalDrawerParent) {
          originalDrawerParent.insertBefore(facetsDrawer, originalDrawerNextSibling);
        } else {
          originalDrawerParent.append(facetsDrawer);
        }
      };

      const warmAndPrepositionDrawer = () => {
        drawerWarmupIdleCallback = 0;
        drawerWarmupTimer = 0;

        if (
          disposed
          || !isCollectionDrawer
          || !desktopMedia.matches
          || facetsDrawer.hasAttribute('open')
          || !originalDrawerParent?.isConnected
        ) {
          return;
        }

        if (facetsDrawer.parentElement !== document.body) {
          drawerIsPrepositioned = true;
          document.body.append(facetsDrawer);
        }

        if (drawerHasWarmed) {
          return;
        }

        facetsDrawer.dataset.rrFirstOpenWarming = 'true';
        drawerWarmupFrame = window.requestAnimationFrame(() => {
          drawerWarmupFrame = 0;

          if (
            disposed
            || facetsDrawer.hasAttribute('open')
            || !facetsDrawer.isConnected
          ) {
            delete facetsDrawer.dataset.rrFirstOpenWarming;
            return;
          }

          facetsDrawer.shadowRoot
            ?.querySelector('[part~="content"]')
            ?.getBoundingClientRect();
          drawerHasWarmed = true;
          delete facetsDrawer.dataset.rrFirstOpenWarming;
        });
      };

      function queueDrawerWarmup() {
        drawerWarmupLoadQueued = false;

        if (
          disposed
          || !desktopMedia.matches
          || facetsDrawer.hasAttribute('open')
        ) {
          return;
        }

        if ('requestIdleCallback' in window) {
          drawerWarmupIdleCallback = window.requestIdleCallback(
            warmAndPrepositionDrawer,
            { timeout: 1200 }
          );
        } else {
          drawerWarmupTimer = window.setTimeout(warmAndPrepositionDrawer, 400);
        }
      }

      const scheduleDrawerWarmup = () => {
        if (
          disposed
          || !isCollectionDrawer
          || !desktopMedia.matches
          || facetsDrawer.hasAttribute('open')
          || drawerWarmupLoadQueued
          || drawerWarmupIdleCallback
          || drawerWarmupTimer
          || drawerWarmupFrame
          || (drawerHasWarmed && facetsDrawer.parentElement === document.body)
        ) {
          return;
        }

        if (document.readyState === 'complete') {
          queueDrawerWarmup();
        } else {
          drawerWarmupLoadQueued = true;
          window.addEventListener('load', queueDrawerWarmup, { once: true });
        }
      };

      const reconcileDrawerWarmup = () => {
        if (disposed) {
          return;
        }

        if (desktopMedia.matches) {
          scheduleDrawerWarmup();
        } else if (!facetsDrawer.hasAttribute('open')) {
          restorePrepositionedDrawer();
        }
      };

      const captureDrawerAccordionStates = () => {
        drawerAccordionStates = Array.from(
          facetsDrawer.querySelectorAll('accordion-disclosure > details')
        ).map((details) => ({
          details,
          expanded: details.getAttribute('aria-expanded') === 'true'
        }));
      };

      const restoreDrawerAccordionStates = () => {
        drawerAccordionStates?.forEach(({ details, expanded }) => {
          if (!details.isConnected || !facetsDrawer.contains(details)) {
            return;
          }

          details.open = expanded;
          details.setAttribute('aria-expanded', String(expanded));
        });
      };

      const handleDrawerBeforeHide = () => {
        captureDrawerAccordionStates();
      };

      const handleDrawerBeforeShow = () => {
        cancelScheduledDrawerWarmup();
        drawerHasWarmed = true;
        restoreDrawerAccordionStates();
      };

      const getInheritedGetter = (propertyName) => {
        let prototype = Object.getPrototypeOf(facetsDrawer);

        while (prototype) {
          const descriptor = Object.getOwnPropertyDescriptor(prototype, propertyName);

          if (descriptor?.get) {
            return descriptor.get.bind(facetsDrawer);
          }

          prototype = Object.getPrototypeOf(prototype);
        }

        return null;
      };
      const originalShouldLock = getInheritedGetter('shouldLock');
      const originalShouldTrapFocus = getInheritedGetter('shouldTrapFocus');
      const desktopNonModalIsActive = () => {
        return desktopMedia.matches || facetsDrawer.dataset.desktopNonModalOpen === 'true';
      };

      Object.defineProperties(facetsDrawer, {
        shouldLock: {
          configurable: true,
          get() {
            if (desktopNonModalIsActive()) {
              if (facetsDrawer.hasAttribute('open')) {
                facetsDrawer.dataset.desktopNonModalOpen = 'true';
              }

              return false;
            }

            return originalShouldLock ? originalShouldLock() : true;
          }
        },
        shouldTrapFocus: {
          configurable: true,
          get() {
            if (desktopNonModalIsActive()) {
              return false;
            }

            return originalShouldTrapFocus ? originalShouldTrapFocus() : true;
          }
        }
      });

      const updatePushLayout = () => {
        if (disposed || !facetsDrawer.isConnected) {
          return;
        }

        const drawerIsOpen = facetsDrawer.hasAttribute('open');
        const pushLayoutIsActive = desktopMedia.matches && drawerIsOpen;

        document.documentElement.classList.toggle('facets-drawer-push-open', pushLayoutIsActive);
        facetsDrawer.setAttribute('aria-modal', pushLayoutIsActive ? 'false' : 'true');

        window.RRDrawerLayout?.refresh(facetsDrawer);

        if (!pushLayoutIsActive) {
          if (!drawerIsOpen) {
            delete facetsDrawer.dataset.desktopNonModalOpen;
          }

          return;
        }

        // Unrelated dialogs (for example sizing) still own their native lock.
        if (!document.querySelector('[open][aria-modal="true"]')) {
          document.documentElement.classList.remove('lock');
        }
      };

      const updateAfterLayout = () => {
        if (disposed) {
          return;
        }

        updatePushLayout();

        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = window.requestAnimationFrame(() => {
          layoutFrame = 0;
          updatePushLayout();
        });
      };

      const handleDesktopMediaChange = () => {
        if (facetsDrawer.hasAttribute('open')) {
          facetsDrawer.hide().then(() => {
            reconcileDrawerWarmup();
            updateAfterLayout();
          });
          return;
        }

        reconcileDrawerWarmup();
        updateAfterLayout();
      };

      const handleResize = () => {
        if (!desktopMedia.matches && !facetsDrawer.hasAttribute('open')) {
          return;
        }

        updateAfterLayout();
      };

      const drawerStateObserver = new MutationObserver(updateAfterLayout);

      const cleanup = () => {
        if (disposed) {
          return;
        }

        disposed = true;
        drawerStateObserver.disconnect();
        desktopMedia.removeEventListener('change', handleDesktopMediaChange);
        window.removeEventListener('resize', handleResize);
        document.removeEventListener('rr:drawer-layout-ready', updateAfterLayout);
        facetsDrawer.removeEventListener('dialog:before-hide', handleDrawerBeforeHide);
        facetsDrawer.removeEventListener('dialog:before-show', handleDrawerBeforeShow);
        window.cancelAnimationFrame(layoutFrame);
        restorePrepositionedDrawer();

        delete facetsDrawer.shouldLock;
        delete facetsDrawer.shouldTrapFocus;

        if (fastDrawerAnimations) {
          document.documentElement.classList.remove('rr-fast-facets-drawer');
          delete facetsDrawer.createEnterAnimationControls;
          delete facetsDrawer.createLeaveAnimationControls;
          delete facetsDrawer.dataset.fastAnimation;
        }

        delete facetsDrawer.dataset.desktopNonModalOpen;
        delete facetsDrawer.dataset.pushLayoutReady;

        if (originalAriaModal === null) {
          facetsDrawer.removeAttribute('aria-modal');
        } else {
          facetsDrawer.setAttribute('aria-modal', originalAriaModal);
        }

        window.RRDrawerLayout?.forget(facetsDrawer);

        if (activePushLayoutRuntime?.drawer === facetsDrawer) {
          document.documentElement.classList.remove('facets-drawer-push-open');
          activePushLayoutRuntime = null;
        }
      };

      drawerStateObserver.observe(facetsDrawer, {
        attributeFilter: ['open']
      });

      desktopMedia.addEventListener('change', handleDesktopMediaChange);
      window.addEventListener('resize', handleResize, { passive: true });
      document.addEventListener('rr:drawer-layout-ready', updateAfterLayout);
      facetsDrawer.addEventListener('dialog:before-hide', handleDrawerBeforeHide);
      facetsDrawer.addEventListener('dialog:before-show', handleDrawerBeforeShow);
      activePushLayoutRuntime = { drawer: facetsDrawer, cleanup };
      scheduleDrawerWarmup();
      updateAfterLayout();
    };

    // Only desktop drawer interactions persist; filter selections retain their existing URL handling.
    const rememberDrawerState = (event) => {
      if (event.target?.id !== 'facets-drawer' || !event.target.isConnected
          || (!window.RRSearchPage?.active && !window.matchMedia('(min-width: 1000px)').matches)) return;
      try {
        sessionStorage.setItem(window.RRSearchPage?.active ? 'rr-search-drawer-open' : 'rr-collection-drawer-open', String(event.type === 'dialog:before-show'));
      } catch {}
    };
    document.addEventListener('dialog:before-show', rememberDrawerState, true);
    document.addEventListener('dialog:before-hide', rememberDrawerState, true);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted || window.RRSearchPage?.active || window.matchMedia('(min-width: 1000px)').matches) return;
      const drawer = document.querySelector('#facets-drawer');
      if (drawer?.hasAttribute('open')) {
        if (typeof drawer.hide === 'function') drawer.hide();
        else drawer.removeAttribute('open');
      }
    });

    const restoreInitialDrawerState = () => {
      if (initialDrawerStateHandled) {
        return;
      }

      const facetsDrawer = document.querySelector('#facets-drawer');
      const facetsForm = facetsDrawer?.querySelector(
        'facets-form:not([update-on-change])'
      );

      if (!facetsDrawer || !facetsForm) {
        return;
      }

      initialDrawerStateHandled = true;

      let savedOpen = false;
      try { savedOpen = sessionStorage.getItem(window.RRSearchPage?.active ? 'rr-search-drawer-open' : 'rr-collection-drawer-open') === 'true'; } catch {}
      if ((!window.RRSearchPage?.active && !window.matchMedia('(min-width: 1000px)').matches) || !savedOpen) return;

      requestAnimationFrame(() => {
        if (!facetsDrawer.isConnected || facetsDrawer.hasAttribute('open')) {
          return;
        }

        if (typeof facetsDrawer.show === 'function') {
          facetsDrawer.show();
        } else {
          facetsDrawer.setAttribute('open', '');
        }
      });
    };

    const initializeFacetDrawerEnhancements = () => {
      const initialForm = document.querySelector('#facets-drawer facets-form');
      if (initialForm) applyEmptyAvailabilityResults(document, initialForm.getAttribute('section-id'), new URL(window.location.href));
      initializeToolbarLayout();
      initializeDrawerFooters();
      if (initialForm) prepareAvailabilityOptions(initialForm).then(changed => { if (changed) scheduleRefresh(initialForm); }).catch(console.error);
      initializeDesktopDrawerPushLayout();
      restoreInitialDrawerState();
    };

    const handleCollectionResultsReplaced = (event) => {
      initializeToolbarLayout();
      const drawerWasReplaced = event.detail?.drawerReplaced === true;
      const currentDrawer = drawerWasReplaced
        ? event.detail?.root?.querySelector('#facets-drawer')
          || document.querySelector('.shopify-section--main-collection #facets-drawer')
        : document.querySelector('#facets-drawer');
      const replacedDrawers = drawerWasReplaced && currentDrawer
        ? Array.from(document.querySelectorAll('#facets-drawer')).filter(
          (drawer) => drawer !== currentDrawer
        )
        : [];
      const drawerWasOpen = replacedDrawers.some((drawer) => (
        drawer.hasAttribute('open')
      ));

      if (!drawerWasReplaced && activePushLayoutRuntime?.drawer === currentDrawer) {
        return;
      }

      activePushLayoutRuntime?.cleanup();

      replacedDrawers.forEach((drawer) => {
        drawer.removeAttribute('open');
        drawer.remove();
      });

      initializeFacetDrawerEnhancements();

      if (drawerWasReplaced) {
        syncDrawerSelectionsFromUrl(new URL(window.location.href));

        if (drawerWasOpen && currentDrawer && !currentDrawer.hasAttribute('open')) {
          if (typeof currentDrawer.show === 'function') {
            currentDrawer.show(false);
          } else {
            currentDrawer.setAttribute('open', 'immediate');
          }
        }
      }
    };

    document.addEventListener(
      'rr:collection-results-replaced',
      handleCollectionResultsReplaced
    );

    document.addEventListener('shopify:section:load', (event) => {
      const loadsCollection = event.target.matches?.('.shopify-section--main-collection');
      const loadsSearch = event.target.matches?.('.shopify-section--main-search');
      const loadsHeader = event.target.matches?.('.shopify-section--header');

      if (event.target.matches?.('.shopify-section--collection-banner')) initializeToolbarLayout();
      if (!loadsCollection && !loadsSearch && !loadsHeader) {
        return;
      }

      const activeDrawer = activePushLayoutRuntime?.drawer;
      const incomingDrawer = loadsCollection || loadsSearch
        ? event.target.querySelector?.('#facets-drawer')
        : null;

      activePushLayoutRuntime?.cleanup();

      if (activeDrawer && incomingDrawer && activeDrawer !== incomingDrawer) {
        activeDrawer.removeAttribute('open');
        activeDrawer.remove();
      }

      initializeFacetDrawerEnhancements();
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches?.('.shopify-section--main-collection, .shopify-section--collection-banner')) toolbarLayoutCleanup?.();
      const activeDrawer = activePushLayoutRuntime?.drawer;
      const unloadsDrawer = activeDrawer && event.target.contains?.(activeDrawer);
      const activeDrawerSectionId = activeDrawer
        ?.querySelector('facets-form[section-id]')
        ?.getAttribute('section-id');
      const unloadsOwningSection = Boolean(
        activeDrawerSectionId
        && event.target.id === `shopify-section-${activeDrawerSectionId}`
      );
      const unloadsHeader = event.target.matches?.('.shopify-section--header');

      if (!unloadsDrawer && !unloadsOwningSection && !unloadsHeader) {
        return;
      }

      activePushLayoutRuntime?.cleanup();

      if (activeDrawer && (unloadsDrawer || unloadsOwningSection)) {
        activeDrawer.removeAttribute('open');
        activeDrawer.remove();
      }

      if (unloadsHeader) {
        window.requestAnimationFrame(() => {
          if (document.querySelector('#facets-drawer')) {
            initializeFacetDrawerEnhancements();
          }
        });
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeFacetDrawerEnhancements();
      }, { once: true });
    } else {
      initializeFacetDrawerEnhancements();
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grouped-active-center-stone-color-facets"] && !Shopify.designMode) return;
  try {
    if (!window.rrGroupedActiveFacetLinkReady) {
    window.rrGroupedActiveFacetLinkReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-grouped-active-facet]');

      if (!link) {
        return;
      }

      const parameterName = link.dataset.groupedFilterParam;
      const valuesToRemove = new Set(
        (link.dataset.groupedFilterValues || '').split(',').filter(Boolean)
      );
      const url = new URL(window.location.href);
      const remainingValues = url.searchParams
        .getAll(parameterName)
        .filter((value) => !valuesToRemove.has(value));

      url.searchParams.delete(parameterName);
      remainingValues.forEach((value) => url.searchParams.append(parameterName, value));
      url.searchParams.delete('page');

      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grouped-center-stone-color-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grouped-filter-control')) {
    class GroupedFilterControl extends HTMLElement {
      connectedCallback() {
        const controller = this.querySelector('[data-grouped-filter-controller]');

        if (!controller || controller.dataset.groupedFilterReady === 'true') {
          return;
        }

        controller.dataset.groupedFilterReady = 'true';

        const selectedGroups = new URLSearchParams(window.location.search).getAll('rr_color');

        if (selectedGroups.length > 0) {
          controller.checked = selectedGroups.includes(this.dataset.colorGroup);
          controller.indeterminate = false;
          this.syncInputs();
        } else {
          controller.indeterminate = this.dataset.groupedFilterPartial === 'true';

          const queryInput = this.querySelector('[data-grouped-color-query]');
          if (queryInput) queryInput.checked = controller.checked;
        }

        controller.addEventListener('change', (event) => {
          event.stopPropagation();
          controller.indeterminate = false;
          this.syncInputs(true);
        });
      }

      syncInputs(notify = false) {
        const controller = this.querySelector('[data-grouped-filter-controller]');
        const queryInput = this.querySelector('[data-grouped-color-query]');
        const values = Array.from(this.querySelectorAll('[data-grouped-filter-value]'));

        if (!controller) return;

        if (queryInput) queryInput.checked = controller.checked;
        values.forEach((input) => {
          input.checked = controller.checked;
        });

        if (notify) {
          const changedInput = values[0] || queryInput;
          changedInput?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('grouped-filter-control', GroupedFilterControl);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grouped-identical-label-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grouped-label-filter-control')) {
    class GroupedLabelFilterControl extends HTMLElement {
      connectedCallback() {
        this.hidden = false;
        this.parentElement
          ?.querySelectorAll('noscript[data-grouped-label-no-js]')
          .forEach((fallback) => fallback.remove());

        const controller = this.querySelector('[data-grouped-label-controller]');

        if (!controller || controller.dataset.groupedLabelReady === 'true') {
          return;
        }

        controller.dataset.groupedLabelReady = 'true';
        this.syncController();

        controller.addEventListener('change', (event) => {
          event.stopPropagation();
          controller.indeterminate = false;
          this.syncValues(true);
        });
      }

      syncController() {
        const controller = this.querySelector('[data-grouped-label-controller]');
        const values = Array.from(this.querySelectorAll('[data-grouped-label-value]'));

        if (!controller) {
          return;
        }

        const activeValueCount = values.filter((input) => input.checked).length;

        controller.checked = values.length > 0 && activeValueCount === values.length;
        controller.indeterminate = activeValueCount > 0 && activeValueCount < values.length;
      }

      syncValues(notify = false) {
        const controller = this.querySelector('[data-grouped-label-controller]');
        const values = Array.from(this.querySelectorAll('[data-grouped-label-value]'));

        if (!controller) {
          return;
        }

        values.forEach((input) => {
          input.checked = controller.checked;
        });

        if (notify) {
          values[0]?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('grouped-label-filter-control', GroupedLabelFilterControl);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grouped-metal-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grouped-metal-filter-control')) {
    class GroupedMetalFilterControl extends HTMLElement {
      connectedCallback() {
        const controller = this.querySelector('[data-grouped-metal-controller]');

        if (!controller || controller.dataset.groupedMetalReady === 'true') {
          return;
        }

        controller.dataset.groupedMetalReady = 'true';

        const selectedGroups = new URLSearchParams(window.location.search).getAll('rr_metal');

        if (selectedGroups.length > 0) {
          controller.checked = selectedGroups.includes(this.dataset.metalGroup);
        }

        this.syncInputs();

        controller.addEventListener('change', (event) => {
          event.stopPropagation();
          this.syncInputs(true);
        });
      }

      syncInputs(notify = false) {
        const controller = this.querySelector('[data-grouped-metal-controller]');
        const queryInput = this.querySelector('[data-grouped-metal-query]');
        const values = Array.from(this.querySelectorAll('[data-grouped-metal-value]'));

        if (!controller) {
          return;
        }

        if (queryInput) {
          queryInput.checked = controller.checked;
        }

        values.forEach((input) => {
          input.checked = controller.checked;
        });

        if (notify) {
          const changedInput = values[0] || queryInput;
          changedInput?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('grouped-metal-filter-control', GroupedMetalFilterControl);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    const defineCountryDrawer = () => {
    if (window.customElements.get('country-drawer')) {
      return;
    }

    const DrawerElement = window.customElements.get('x-drawer');

    if (!DrawerElement) {
      return;
    }

    class CountryDrawer extends DrawerElement {
      connectedCallback() {
        super.connectedCallback();
        this.controls.forEach((control) => control.setAttribute('aria-haspopup', 'dialog'));
      }

      createEnterAnimationControls() {
        return super.createEnterAnimationControls();
      }

      createLeaveAnimationControls() {
        return super.createLeaveAnimationControls();
      }
    }

    window.customElements.define('country-drawer', CountryDrawer);
  };

  if (window.customElements.get('x-drawer')) {
    defineCountryDrawer();
  } else {
    window.customElements.whenDefined('x-drawer').then(defineCountryDrawer);
  }

  // BEGIN GENERATED COUNTRY SEARCH DATA
  // Sources and editable catalogs: manifests/search/*.json. Verify with scripts/build-country-search-data.mjs --check.
  const COUNTRY_SEARCH_COUNTRIES = {"AC":{"alpha3":null,"names":["Ascension Island"],"exact":[]},"AD":{"alpha3":"AND","names":["Andorra","Principality of Andorra"],"exact":[]},"AE":{"alpha3":"ARE","names":["United Arab Emirates","الإمارات العربية المتحدة"],"exact":["UAE","U.A.E."]},"AF":{"alpha3":"AFG","names":["Afghanistan","Islamic Republic of Afghanistan"],"exact":[]},"AG":{"alpha3":"ATG","names":["Antigua and Barbuda","Antigua & Barbuda"],"exact":[]},"AI":{"alpha3":"AIA","names":["Anguilla"],"exact":[]},"AL":{"alpha3":"ALB","names":["Albania","Republic of Albania"],"exact":[]},"AM":{"alpha3":"ARM","names":["Armenia","Republic of Armenia"],"exact":[]},"AO":{"alpha3":"AGO","names":["Angola","Republic of Angola"],"exact":[]},"AQ":{"alpha3":"ATA","names":["Antarctica"],"exact":[]},"AR":{"alpha3":"ARG","names":["Argentina","Argentine Republic"],"exact":[]},"AS":{"alpha3":"ASM","names":["American Samoa"],"exact":[]},"AT":{"alpha3":"AUT","names":["Austria","Republic of Austria","Österreich"],"exact":[]},"AU":{"alpha3":"AUS","names":["Australia"],"exact":[]},"AW":{"alpha3":"ABW","names":["Aruba"],"exact":[]},"AX":{"alpha3":"ALA","names":["Åland Islands","Åland","Aland"],"exact":[]},"AZ":{"alpha3":"AZE","names":["Azerbaijan","Republic of Azerbaijan"],"exact":[]},"BA":{"alpha3":"BIH","names":["Bosnia and Herzegovina","Republic of Bosnia and Herzegovina","Bosnia & Herzegovina","Bosnia"],"exact":[]},"BB":{"alpha3":"BRB","names":["Barbados"],"exact":[]},"BD":{"alpha3":"BGD","names":["Bangladesh","People's Republic of Bangladesh","বাংলাদেশ"],"exact":[]},"BE":{"alpha3":"BEL","names":["Belgium","Kingdom of Belgium","Belgique","België"],"exact":[]},"BF":{"alpha3":"BFA","names":["Burkina Faso","Upper Volta"],"exact":[]},"BG":{"alpha3":"BGR","names":["Bulgaria","Republic of Bulgaria"],"exact":[]},"BH":{"alpha3":"BHR","names":["Bahrain","Kingdom of Bahrain","البحرين"],"exact":[]},"BI":{"alpha3":"BDI","names":["Burundi","Republic of Burundi"],"exact":[]},"BJ":{"alpha3":"BEN","names":["Benin","Republic of Benin","Dahomey"],"exact":[]},"BL":{"alpha3":"BLM","names":["Saint Barthélemy","St. Barthélemy","Saint Barthelemy","Saint Barts","St Barts","Saint Barth"],"exact":[]},"BM":{"alpha3":"BMU","names":["Bermuda"],"exact":[]},"BN":{"alpha3":"BRN","names":["Brunei Darussalam","Brunei"],"exact":[]},"BO":{"alpha3":"BOL","names":["Bolivia, Plurinational State of","Bolivia","Plurinational State of Bolivia"],"exact":[]},"BQ":{"alpha3":"BES","names":["Bonaire, Sint Eustatius and Saba","Caribbean Netherlands","Bonaire","Sint Eustatius","Saba"],"exact":[]},"BR":{"alpha3":"BRA","names":["Brazil","Federative Republic of Brazil","Brasil"],"exact":[]},"BS":{"alpha3":"BHS","names":["Bahamas","Commonwealth of the Bahamas"],"exact":[]},"BT":{"alpha3":"BTN","names":["Bhutan","Kingdom of Bhutan"],"exact":[]},"BV":{"alpha3":"BVT","names":["Bouvet Island"],"exact":[]},"BW":{"alpha3":"BWA","names":["Botswana","Republic of Botswana"],"exact":[]},"BY":{"alpha3":"BLR","names":["Belarus","Republic of Belarus"],"exact":[]},"BZ":{"alpha3":"BLZ","names":["Belize"],"exact":[]},"CA":{"alpha3":"CAN","names":["Canada"],"exact":[]},"CC":{"alpha3":"CCK","names":["Cocos (Keeling) Islands","Cocos Islands"],"exact":[]},"CD":{"alpha3":"COD","names":["Congo, The Democratic Republic of the","Congo - Kinshasa","Congo (DRC)","Congo","Democratic Republic of the Congo","DR Congo","Zaire"],"exact":["DRC","D.R.C."]},"CF":{"alpha3":"CAF","names":["Central African Republic"],"exact":[]},"CG":{"alpha3":"COG","names":["Congo","Republic of the Congo","Congo - Brazzaville","Congo (Republic)"],"exact":[]},"CH":{"alpha3":"CHE","names":["Switzerland","Swiss Confederation","Schweiz","Suisse","Svizzera"],"exact":[]},"CI":{"alpha3":"CIV","names":["Côte d'Ivoire","Republic of Côte d'Ivoire","Côte d’Ivoire","Ivory Coast"],"exact":[]},"CK":{"alpha3":"COK","names":["Cook Islands"],"exact":[]},"CL":{"alpha3":"CHL","names":["Chile","Republic of Chile"],"exact":[]},"CM":{"alpha3":"CMR","names":["Cameroon","Republic of Cameroon"],"exact":[]},"CN":{"alpha3":"CHN","names":["China","People's Republic of China","中国","中國","People’s Republic of China"],"exact":["PRC","P.R.C."]},"CO":{"alpha3":"COL","names":["Colombia","Republic of Colombia"],"exact":[]},"CR":{"alpha3":"CRI","names":["Costa Rica","Republic of Costa Rica"],"exact":[]},"CU":{"alpha3":"CUB","names":["Cuba","Republic of Cuba"],"exact":[]},"CV":{"alpha3":"CPV","names":["Cabo Verde","Republic of Cabo Verde","Cape Verde"],"exact":[]},"CW":{"alpha3":"CUW","names":["Curaçao"],"exact":[]},"CX":{"alpha3":"CXR","names":["Christmas Island"],"exact":[]},"CY":{"alpha3":"CYP","names":["Cyprus","Republic of Cyprus","Κύπρος"],"exact":[]},"CZ":{"alpha3":"CZE","names":["Czechia","Czech Republic","Česko","Česká republika"],"exact":[]},"DE":{"alpha3":"DEU","names":["Germany","Federal Republic of Germany","Deutschland"],"exact":[]},"DJ":{"alpha3":"DJI","names":["Djibouti","Republic of Djibouti"],"exact":[]},"DK":{"alpha3":"DNK","names":["Denmark","Kingdom of Denmark","Danmark"],"exact":[]},"DM":{"alpha3":"DMA","names":["Dominica","Commonwealth of Dominica"],"exact":[]},"DO":{"alpha3":"DOM","names":["Dominican Republic","República Dominicana"],"exact":[]},"DZ":{"alpha3":"DZA","names":["Algeria","People's Democratic Republic of Algeria","الجزائر"],"exact":[]},"EC":{"alpha3":"ECU","names":["Ecuador","Republic of Ecuador"],"exact":[]},"EE":{"alpha3":"EST","names":["Estonia","Republic of Estonia"],"exact":[]},"EG":{"alpha3":"EGY","names":["Egypt","Arab Republic of Egypt","مصر"],"exact":[]},"EH":{"alpha3":"ESH","names":["Western Sahara"],"exact":[]},"ER":{"alpha3":"ERI","names":["Eritrea","the State of Eritrea"],"exact":[]},"ES":{"alpha3":"ESP","names":["Spain","Kingdom of Spain","España"],"exact":[]},"ET":{"alpha3":"ETH","names":["Ethiopia","Federal Democratic Republic of Ethiopia"],"exact":[]},"FI":{"alpha3":"FIN","names":["Finland","Republic of Finland","Suomi"],"exact":[]},"FJ":{"alpha3":"FJI","names":["Fiji","Republic of Fiji"],"exact":[]},"FK":{"alpha3":"FLK","names":["Falkland Islands (Malvinas)","Falkland Islands","Falkland Islands (Islas Malvinas)"],"exact":[]},"FM":{"alpha3":"FSM","names":["Micronesia, Federated States of","Federated States of Micronesia","Micronesia"],"exact":["FSM"]},"FO":{"alpha3":"FRO","names":["Faroe Islands"],"exact":[]},"FR":{"alpha3":"FRA","names":["France","French Republic"],"exact":[]},"GA":{"alpha3":"GAB","names":["Gabon","Gabonese Republic"],"exact":[]},"GB":{"alpha3":"GBR","names":["United Kingdom","United Kingdom of Great Britain and Northern Ireland","Britain","Great Britain","England","Scotland","Wales","Northern Ireland"],"exact":["UK","U.K."]},"GD":{"alpha3":"GRD","names":["Grenada"],"exact":[]},"GE":{"alpha3":"GEO","names":["Georgia"],"exact":[]},"GF":{"alpha3":"GUF","names":["French Guiana"],"exact":[]},"GG":{"alpha3":"GGY","names":["Guernsey"],"exact":[]},"GH":{"alpha3":"GHA","names":["Ghana","Republic of Ghana"],"exact":[]},"GI":{"alpha3":"GIB","names":["Gibraltar"],"exact":[]},"GL":{"alpha3":"GRL","names":["Greenland"],"exact":[]},"GM":{"alpha3":"GMB","names":["Gambia","Republic of the Gambia"],"exact":[]},"GN":{"alpha3":"GIN","names":["Guinea","Republic of Guinea"],"exact":[]},"GP":{"alpha3":"GLP","names":["Guadeloupe"],"exact":[]},"GQ":{"alpha3":"GNQ","names":["Equatorial Guinea","Republic of Equatorial Guinea"],"exact":[]},"GR":{"alpha3":"GRC","names":["Greece","Hellenic Republic","Ελλάδα"],"exact":[]},"GS":{"alpha3":"SGS","names":["South Georgia and the South Sandwich Islands","South Georgia & South Sandwich Islands"],"exact":[]},"GT":{"alpha3":"GTM","names":["Guatemala","Republic of Guatemala"],"exact":[]},"GU":{"alpha3":"GUM","names":["Guam"],"exact":[]},"GW":{"alpha3":"GNB","names":["Guinea-Bissau","Republic of Guinea-Bissau"],"exact":[]},"GY":{"alpha3":"GUY","names":["Guyana","Republic of Guyana"],"exact":[]},"HK":{"alpha3":"HKG","names":["Hong Kong","Hong Kong Special Administrative Region of China","Hong Kong SAR China","中国香港特别行政区","香港","中國香港特別行政區","Hong Kong SAR"],"exact":[]},"HM":{"alpha3":"HMD","names":["Heard Island and McDonald Islands","Heard & McDonald Islands"],"exact":[]},"HN":{"alpha3":"HND","names":["Honduras","Republic of Honduras"],"exact":[]},"HR":{"alpha3":"HRV","names":["Croatia","Republic of Croatia"],"exact":[]},"HT":{"alpha3":"HTI","names":["Haiti","Republic of Haiti"],"exact":[]},"HU":{"alpha3":"HUN","names":["Hungary","Magyarország"],"exact":[]},"ID":{"alpha3":"IDN","names":["Indonesia","Republic of Indonesia"],"exact":[]},"IE":{"alpha3":"IRL","names":["Ireland"],"exact":[]},"IL":{"alpha3":"ISR","names":["Israel","State of Israel","ישראל"],"exact":[]},"IM":{"alpha3":"IMN","names":["Isle of Man"],"exact":[]},"IN":{"alpha3":"IND","names":["India","Republic of India","भारत","ভারত","இந்தியா","Bharat"],"exact":[]},"IO":{"alpha3":"IOT","names":["British Indian Ocean Territory","Chagos Archipelago"],"exact":[]},"IQ":{"alpha3":"IRQ","names":["Iraq","Republic of Iraq","العراق"],"exact":[]},"IR":{"alpha3":"IRN","names":["Iran, Islamic Republic of","Iran","Islamic Republic of Iran","ایران"],"exact":[]},"IS":{"alpha3":"ISL","names":["Iceland","Republic of Iceland"],"exact":[]},"IT":{"alpha3":"ITA","names":["Italy","Italian Republic","Italia"],"exact":[]},"JE":{"alpha3":"JEY","names":["Jersey"],"exact":[]},"JM":{"alpha3":"JAM","names":["Jamaica"],"exact":[]},"JO":{"alpha3":"JOR","names":["Jordan","Hashemite Kingdom of Jordan","الأردن"],"exact":[]},"JP":{"alpha3":"JPN","names":["Japan","日本"],"exact":[]},"KE":{"alpha3":"KEN","names":["Kenya","Republic of Kenya"],"exact":[]},"KG":{"alpha3":"KGZ","names":["Kyrgyzstan","Kyrgyz Republic"],"exact":[]},"KH":{"alpha3":"KHM","names":["Cambodia","Kingdom of Cambodia","Kampuchea","Democratic Kampuchea","Khmer Republic"],"exact":[]},"KI":{"alpha3":"KIR","names":["Kiribati","Republic of Kiribati"],"exact":[]},"KM":{"alpha3":"COM","names":["Comoros","Union of the Comoros"],"exact":[]},"KN":{"alpha3":"KNA","names":["Saint Kitts and Nevis","St. Kitts & Nevis"],"exact":[]},"KP":{"alpha3":"PRK","names":["Korea, Democratic People's Republic of","North Korea","Democratic People's Republic of Korea","북한","Korea","Democratic People’s Republic of Korea"],"exact":["DPRK"]},"KR":{"alpha3":"KOR","names":["Korea, Republic of","South Korea","대한민국","한국","Korea","Republic of Korea"],"exact":["ROK"]},"KW":{"alpha3":"KWT","names":["Kuwait","State of Kuwait","الكويت"],"exact":[]},"KY":{"alpha3":"CYM","names":["Cayman Islands"],"exact":[]},"KZ":{"alpha3":"KAZ","names":["Kazakhstan","Republic of Kazakhstan"],"exact":[]},"LA":{"alpha3":"LAO","names":["Lao People's Democratic Republic","Laos","Lao PDR"],"exact":[]},"LB":{"alpha3":"LBN","names":["Lebanon","Lebanese Republic","لبنان"],"exact":[]},"LC":{"alpha3":"LCA","names":["Saint Lucia","St. Lucia"],"exact":[]},"LI":{"alpha3":"LIE","names":["Liechtenstein","Principality of Liechtenstein"],"exact":[]},"LK":{"alpha3":"LKA","names":["Sri Lanka","Democratic Socialist Republic of Sri Lanka","இலங்கை","Ceylon"],"exact":[]},"LR":{"alpha3":"LBR","names":["Liberia","Republic of Liberia"],"exact":[]},"LS":{"alpha3":"LSO","names":["Lesotho","Kingdom of Lesotho"],"exact":[]},"LT":{"alpha3":"LTU","names":["Lithuania","Republic of Lithuania"],"exact":[]},"LU":{"alpha3":"LUX","names":["Luxembourg","Grand Duchy of Luxembourg"],"exact":[]},"LV":{"alpha3":"LVA","names":["Latvia","Republic of Latvia"],"exact":[]},"LY":{"alpha3":"LBY","names":["Libya"],"exact":[]},"MA":{"alpha3":"MAR","names":["Morocco","Kingdom of Morocco","المغرب"],"exact":[]},"MC":{"alpha3":"MCO","names":["Monaco","Principality of Monaco"],"exact":[]},"MD":{"alpha3":"MDA","names":["Moldova, Republic of","Moldova","Republic of Moldova","Republica Moldova"],"exact":[]},"ME":{"alpha3":"MNE","names":["Montenegro"],"exact":[]},"MF":{"alpha3":"MAF","names":["Saint Martin (French part)","St. Martin","Saint Martin"],"exact":[]},"MG":{"alpha3":"MDG","names":["Madagascar","Republic of Madagascar"],"exact":[]},"MH":{"alpha3":"MHL","names":["Marshall Islands","Republic of the Marshall Islands"],"exact":[]},"MK":{"alpha3":"MKD","names":["North Macedonia","Republic of North Macedonia","Macedonia","The former Yugoslav Republic of Macedonia"],"exact":["FYROM"]},"ML":{"alpha3":"MLI","names":["Mali","Republic of Mali"],"exact":[]},"MM":{"alpha3":"MMR","names":["Myanmar","Republic of Myanmar","Myanmar (Burma)","Burma"],"exact":[]},"MN":{"alpha3":"MNG","names":["Mongolia"],"exact":[]},"MO":{"alpha3":"MAC","names":["Macao","Macao Special Administrative Region of China","Macao SAR China","中国澳门特别行政区","澳门","中國澳門特別行政區","澳門","Macau","Macau SAR","Macao SAR"],"exact":[]},"MP":{"alpha3":"MNP","names":["Northern Mariana Islands","Commonwealth of the Northern Mariana Islands"],"exact":[]},"MQ":{"alpha3":"MTQ","names":["Martinique"],"exact":[]},"MR":{"alpha3":"MRT","names":["Mauritania","Islamic Republic of Mauritania"],"exact":[]},"MS":{"alpha3":"MSR","names":["Montserrat"],"exact":[]},"MT":{"alpha3":"MLT","names":["Malta","Republic of Malta"],"exact":[]},"MU":{"alpha3":"MUS","names":["Mauritius","Republic of Mauritius"],"exact":[]},"MV":{"alpha3":"MDV","names":["Maldives","Republic of Maldives"],"exact":[]},"MW":{"alpha3":"MWI","names":["Malawi","Republic of Malawi"],"exact":[]},"MX":{"alpha3":"MEX","names":["Mexico","United Mexican States","México"],"exact":[]},"MY":{"alpha3":"MYS","names":["Malaysia"],"exact":[]},"MZ":{"alpha3":"MOZ","names":["Mozambique","Republic of Mozambique","Moçambique"],"exact":[]},"NA":{"alpha3":"NAM","names":["Namibia","Republic of Namibia"],"exact":[]},"NC":{"alpha3":"NCL","names":["New Caledonia"],"exact":[]},"NE":{"alpha3":"NER","names":["Niger","Republic of the Niger"],"exact":[]},"NF":{"alpha3":"NFK","names":["Norfolk Island"],"exact":[]},"NG":{"alpha3":"NGA","names":["Nigeria","Federal Republic of Nigeria"],"exact":[]},"NI":{"alpha3":"NIC","names":["Nicaragua","Republic of Nicaragua"],"exact":[]},"NL":{"alpha3":"NLD","names":["Netherlands","Kingdom of the Netherlands","Nederland","Holland"],"exact":[]},"NO":{"alpha3":"NOR","names":["Norway","Kingdom of Norway","Norge"],"exact":[]},"NP":{"alpha3":"NPL","names":["Nepal","Federal Democratic Republic of Nepal"],"exact":[]},"NR":{"alpha3":"NRU","names":["Nauru","Republic of Nauru"],"exact":[]},"NU":{"alpha3":"NIU","names":["Niue"],"exact":[]},"NZ":{"alpha3":"NZL","names":["New Zealand","Aotearoa New Zealand"],"exact":[]},"OM":{"alpha3":"OMN","names":["Oman","Sultanate of Oman","عُمان"],"exact":[]},"PA":{"alpha3":"PAN","names":["Panama","Republic of Panama","Panamá"],"exact":[]},"PE":{"alpha3":"PER","names":["Peru","Republic of Peru","Perú"],"exact":[]},"PF":{"alpha3":"PYF","names":["French Polynesia"],"exact":[]},"PG":{"alpha3":"PNG","names":["Papua New Guinea","Independent State of Papua New Guinea"],"exact":[]},"PH":{"alpha3":"PHL","names":["Philippines","Republic of the Philippines","Pilipinas"],"exact":[]},"PK":{"alpha3":"PAK","names":["Pakistan","Islamic Republic of Pakistan","پاکستان"],"exact":[]},"PL":{"alpha3":"POL","names":["Poland","Republic of Poland","Polska"],"exact":[]},"PM":{"alpha3":"SPM","names":["Saint Pierre and Miquelon","St. Pierre & Miquelon"],"exact":[]},"PN":{"alpha3":"PCN","names":["Pitcairn","Pitcairn Islands"],"exact":[]},"PR":{"alpha3":"PRI","names":["Puerto Rico"],"exact":[]},"PS":{"alpha3":"PSE","names":["Palestine, State of","the State of Palestine","Palestinian Territories","Palestine","الأراضي الفلسطينية","فلسطين","State of Palestine"],"exact":[]},"PT":{"alpha3":"PRT","names":["Portugal","Portuguese Republic"],"exact":[]},"PW":{"alpha3":"PLW","names":["Palau","Republic of Palau"],"exact":[]},"PY":{"alpha3":"PRY","names":["Paraguay","Republic of Paraguay"],"exact":[]},"QA":{"alpha3":"QAT","names":["Qatar","State of Qatar","قطر"],"exact":[]},"RE":{"alpha3":"REU","names":["Réunion","Reunion Island"],"exact":[]},"RO":{"alpha3":"ROU","names":["Romania","România"],"exact":[]},"RS":{"alpha3":"SRB","names":["Serbia","Republic of Serbia"],"exact":[]},"RU":{"alpha3":"RUS","names":["Russian Federation","Russia","Россия"],"exact":[]},"RW":{"alpha3":"RWA","names":["Rwanda","Rwandese Republic"],"exact":[]},"SA":{"alpha3":"SAU","names":["Saudi Arabia","Kingdom of Saudi Arabia","المملكة العربية السعودية"],"exact":["KSA","K.S.A."]},"SB":{"alpha3":"SLB","names":["Solomon Islands"],"exact":[]},"SC":{"alpha3":"SYC","names":["Seychelles","Republic of Seychelles"],"exact":[]},"SD":{"alpha3":"SDN","names":["Sudan","Republic of the Sudan"],"exact":[]},"SE":{"alpha3":"SWE","names":["Sweden","Kingdom of Sweden","Sverige"],"exact":[]},"SG":{"alpha3":"SGP","names":["Singapore","Republic of Singapore","சிங்கப்பூர்"],"exact":[]},"SH":{"alpha3":"SHN","names":["Saint Helena, Ascension and Tristan da Cunha","St. Helena","Saint Helena"],"exact":[]},"SI":{"alpha3":"SVN","names":["Slovenia","Republic of Slovenia"],"exact":[]},"SJ":{"alpha3":"SJM","names":["Svalbard and Jan Mayen","Svalbard & Jan Mayen"],"exact":[]},"SK":{"alpha3":"SVK","names":["Slovakia","Slovak Republic","Slovensko"],"exact":[]},"SL":{"alpha3":"SLE","names":["Sierra Leone","Republic of Sierra Leone"],"exact":[]},"SM":{"alpha3":"SMR","names":["San Marino","Republic of San Marino"],"exact":[]},"SN":{"alpha3":"SEN","names":["Senegal","Republic of Senegal"],"exact":[]},"SO":{"alpha3":"SOM","names":["Somalia","Federal Republic of Somalia"],"exact":[]},"SR":{"alpha3":"SUR","names":["Suriname","Republic of Suriname"],"exact":[]},"SS":{"alpha3":"SSD","names":["South Sudan","Republic of South Sudan"],"exact":[]},"ST":{"alpha3":"STP","names":["Sao Tome and Principe","Democratic Republic of Sao Tome and Principe","São Tomé & Príncipe"],"exact":[]},"SV":{"alpha3":"SLV","names":["El Salvador","Republic of El Salvador"],"exact":[]},"SX":{"alpha3":"SXM","names":["Sint Maarten (Dutch part)","Sint Maarten"],"exact":[]},"SY":{"alpha3":"SYR","names":["Syrian Arab Republic","Syria","سوريا"],"exact":[]},"SZ":{"alpha3":"SWZ","names":["Eswatini","Kingdom of Eswatini","Swaziland"],"exact":[]},"TA":{"alpha3":null,"names":["Tristan da Cunha"],"exact":[]},"TC":{"alpha3":"TCA","names":["Turks and Caicos Islands","Turks & Caicos Islands"],"exact":[]},"TD":{"alpha3":"TCD","names":["Chad","Republic of Chad"],"exact":[]},"TF":{"alpha3":"ATF","names":["French Southern Territories"],"exact":[]},"TG":{"alpha3":"TGO","names":["Togo","Togolese Republic"],"exact":[]},"TH":{"alpha3":"THA","names":["Thailand","Kingdom of Thailand","ไทย"],"exact":[]},"TJ":{"alpha3":"TJK","names":["Tajikistan","Republic of Tajikistan"],"exact":[]},"TK":{"alpha3":"TKL","names":["Tokelau"],"exact":[]},"TL":{"alpha3":"TLS","names":["Timor-Leste","Democratic Republic of Timor-Leste","East Timor"],"exact":[]},"TM":{"alpha3":"TKM","names":["Turkmenistan"],"exact":[]},"TN":{"alpha3":"TUN","names":["Tunisia","Republic of Tunisia","تونس"],"exact":[]},"TO":{"alpha3":"TON","names":["Tonga","Kingdom of Tonga"],"exact":[]},"TR":{"alpha3":"TUR","names":["Türkiye","Republic of Türkiye","Turkey"],"exact":[]},"TT":{"alpha3":"TTO","names":["Trinidad and Tobago","Republic of Trinidad and Tobago","Trinidad & Tobago"],"exact":[]},"TV":{"alpha3":"TUV","names":["Tuvalu"],"exact":[]},"TW":{"alpha3":"TWN","names":["Taiwan, Province of China","Taiwan","台湾","台灣"],"exact":[]},"TZ":{"alpha3":"TZA","names":["Tanzania, United Republic of","Tanzania","United Republic of Tanzania"],"exact":[]},"UA":{"alpha3":"UKR","names":["Ukraine","Україна"],"exact":[]},"UG":{"alpha3":"UGA","names":["Uganda","Republic of Uganda"],"exact":[]},"UM":{"alpha3":"UMI","names":["United States Minor Outlying Islands","U.S. Outlying Islands"],"exact":[]},"US":{"alpha3":"USA","names":["United States","United States of America"],"exact":["US","U.S.","USA","U.S.A."]},"UY":{"alpha3":"URY","names":["Uruguay","Eastern Republic of Uruguay"],"exact":[]},"UZ":{"alpha3":"UZB","names":["Uzbekistan","Republic of Uzbekistan"],"exact":[]},"VA":{"alpha3":"VAT","names":["Holy See (Vatican City State)","Vatican City","Città del Vaticano"],"exact":[]},"VC":{"alpha3":"VCT","names":["Saint Vincent and the Grenadines","St. Vincent & Grenadines"],"exact":[]},"VE":{"alpha3":"VEN","names":["Venezuela, Bolivarian Republic of","Venezuela","Bolivarian Republic of Venezuela"],"exact":[]},"VG":{"alpha3":"VGB","names":["Virgin Islands, British","British Virgin Islands"],"exact":["BVI"]},"VI":{"alpha3":"VIR","names":["Virgin Islands, U.S.","Virgin Islands of the United States","U.S. Virgin Islands","United States Virgin Islands","US Virgin Islands"],"exact":["USVI"]},"VN":{"alpha3":"VNM","names":["Viet Nam","Vietnam","Socialist Republic of Viet Nam","Việt Nam"],"exact":[]},"VU":{"alpha3":"VUT","names":["Vanuatu","Republic of Vanuatu"],"exact":[]},"WF":{"alpha3":"WLF","names":["Wallis and Futuna","Wallis & Futuna"],"exact":[]},"WS":{"alpha3":"WSM","names":["Samoa","Independent State of Samoa"],"exact":[]},"XK":{"alpha3":null,"names":["Kosovo"],"exact":[]},"YE":{"alpha3":"YEM","names":["Yemen","Republic of Yemen","اليمن"],"exact":[]},"YT":{"alpha3":"MYT","names":["Mayotte"],"exact":[]},"ZA":{"alpha3":"ZAF","names":["South Africa","Republic of South Africa"],"exact":["RSA"]},"ZM":{"alpha3":"ZMB","names":["Zambia","Republic of Zambia"],"exact":[]},"ZW":{"alpha3":"ZWE","names":["Zimbabwe","Republic of Zimbabwe"],"exact":[]}};
  const COUNTRY_SEARCH_CURRENCIES = {"AED":{"names":["United Arab Emirates Dirham","UAE dirham","UAE dirhams","Emirati dirham","dirham","dirhams","درهم إماراتي"],"exact":["AED","DH","Dhs","د.إ"],"symbols":[]},"AFN":{"names":["Afghan Afghani","Afghan Afghanis","Afghani","afghanis","افغانۍ","افغانی","افغانی افغانستان"],"exact":["AFN"],"symbols":["؋"]},"ALL":{"names":["Albanian Lek","Albanian lekë","Lek","leke","lekë","Leku shqiptar","lek shqiptar","lekë shqiptar"],"exact":["ALL","L"],"symbols":[]},"AMD":{"names":["Armenian Dram","Armenian drams","dram","drams","դրամ","հայկական դրամ"],"exact":["AMD","դր."],"symbols":["֏"]},"ANG":{"names":["Netherlands Antillean Guilder","Netherlands Antillean guilders","Antillean guilder","Dutch Antillean guilder","guilder","guilders","gulden","florin","florins","Nederlands-Antilliaanse gulden"],"exact":["ANG","NAf","NAƒ","ƒ","f"],"symbols":[]},"AOA":{"names":["Angolan Kwanza","Angolan kwanzas","Kwanza","kwanzas","kwanza angolano","kwanzas angolanos"],"exact":["AOA","Kz"],"symbols":[]},"ARS":{"names":["Argentine Peso","Argentine pesos","peso argentino","pesos argentinos","peso","pesos"],"exact":["ARS"],"symbols":["$"]},"AUD":{"names":["Australian Dollar","Australian dollars","dollar","dollars"],"exact":["AUD"],"symbols":["A$","$"]},"AWG":{"names":["Aruban Florin","Aruban guilder","florin","florins","guilder","guilders","gulden","Arubaanse gulden"],"exact":["AWG","Afl","ƒ"],"symbols":[]},"AZN":{"names":["Azerbaijani Manat","Azerbaijani manats","Azerbaijan Manat","manat","manats","Azərbaycan Manatı"],"exact":["AZN"],"symbols":["₼"]},"BAM":{"names":["Bosnia-Herzegovina Convertible Mark","Bosnia-Herzegovina convertible marks","Convertible Mark","Bosnia and Herzegovina convertible mark","convertible marks","marka","maraka","Bosanskohercegovačka konvertibilna marka","bosanskohercegovačkih konvertibilnih maraka"],"exact":["BAM","KM"],"symbols":[]},"BBD":{"names":["Barbadian Dollar","Barbadian dollars","Barbados Dollar","dollar","dollars"],"exact":["BBD"],"symbols":["$"]},"BDT":{"names":["Bangladeshi Taka","Bangladeshi takas","Taka","Bangladesh taka","takas","টাকা","বাংলাদেশী টাকা"],"exact":["BDT"],"symbols":["৳"]},"BGN":{"names":["Bulgarian Lev","Bulgarian leva","lev","leva","лев","лева","Български лев","български лева"],"exact":["BGN","лв"],"symbols":[]},"BHD":{"names":["Bahraini Dinar","Bahraini dinars","Bahrain dinar","دينار بحريني","dinar","dinars"],"exact":["BHD","BD","د.ب"],"symbols":[]},"BIF":{"names":["Burundian Franc","Burundian francs","Burundi Franc","franc","francs"],"exact":["BIF","FBu"],"symbols":[]},"BMD":{"names":["Bermudan Dollar","Bermudan dollars","Bermudian Dollar","dollar","dollars"],"exact":["BMD"],"symbols":["$","BD$"]},"BND":{"names":["Brunei Dollar","Brunei dollars","dollar","dollars"],"exact":["BND"],"symbols":["$","B$"]},"BOB":{"names":["Bolivian Boliviano","Bolivian bolivianos","Boliviano","bolivianos"],"exact":["BOB","Bs","Bs."],"symbols":[]},"BRL":{"names":["Brazilian Real","Brazilian reals","real","reals","reais","Real brasileiro","Reais brasileiros"],"exact":["BRL"],"symbols":["R$"]},"BSD":{"names":["Bahamian Dollar","Bahamian dollars","dollar","dollars"],"exact":["BSD"],"symbols":["$"]},"BTN":{"names":["Bhutanese Ngultrum","Bhutanese ngultrums","Ngultrum","ngultrums"],"exact":["BTN","Nu","Nu."],"symbols":[]},"BWP":{"names":["Botswanan Pula","Botswanan pulas","Pula","Botswana pula","pulas"],"exact":["BWP","P"],"symbols":[]},"BYN":{"names":["Belarusian Ruble","Belarusian rubles","Belarusian rouble","Belarusian roubles","ruble","rubles","rouble","roubles","беларускі рубель","беларускія рублі"],"exact":["BYN"],"symbols":[]},"BYR":{"names":["Belarusian Ruble (2000–2016)","Belarusian rubles (2000–2016)","Old Belarusian ruble","Belarusian ruble 2000 2016","ruble","rubles","rouble","roubles","беларускі рубель (2000–2016)","беларускія рублі (2000–2016)"],"exact":["BYR"],"symbols":[]},"BZD":{"names":["Belize Dollar","Belize dollars","dollar","dollars"],"exact":["BZD"],"symbols":["$","BZ$"]},"CAD":{"names":["Canadian Dollar","Canadian dollars","dollar","dollars"],"exact":["CAD"],"symbols":["CA$","$","C$"]},"CDF":{"names":["Congolese Franc","Congolese francs","franc congolais","francs congolais","franc","francs"],"exact":["CDF","FC"],"symbols":[]},"CHF":{"names":["Swiss Franc","Swiss francs","franc suisse","Schweizer Franken","franken","francs suisses","franco svizzero","franchi svizzeri","franc","francs"],"exact":["CHF","Fr","Fr.","SFr","SFr."],"symbols":[]},"CLP":{"names":["Chilean Peso","Chilean pesos","Peso chileno","pesos chilenos","peso","pesos"],"exact":["CLP"],"symbols":["$"]},"CNY":{"names":["Chinese Yuan","Yuan Renminbi","Chinese renminbi","renminbi","yuan","ren min bi","人民币","人民幣","元","圆","圓"],"exact":["CNY","RMB","R.M.B."],"symbols":["CN¥","¥","￥"]},"COP":{"names":["Colombian Peso","Colombian pesos","peso colombiano","pesos colombianos","peso","pesos"],"exact":["COP"],"symbols":["$"]},"CRC":{"names":["Costa Rican Colón","Costa Rican colóns","Costa Rican Colon","colon","colón","colones","colón costarricense","colones costarricenses"],"exact":["CRC"],"symbols":["₡"]},"CUP":{"names":["Cuban Peso","Cuban pesos","peso cubano","pesos cubanos","peso","pesos"],"exact":["CUP"],"symbols":["$"]},"CVE":{"names":["Cape Verdean Escudo","Cape Verdean escudos","Cabo Verde Escudo","Cabo Verdean escudo","escudo","escudos","escudo cabo-verdiano","escudos cabo-verdianos"],"exact":["CVE","Esc"],"symbols":[]},"CZK":{"names":["Czech Koruna","Czech korunas","Czech crown","Czech crowns","koruna","korunas","koruny","crown","crowns","česká koruna","české koruny"],"exact":["CZK","Kč"],"symbols":[]},"DJF":{"names":["Djiboutian Franc","Djiboutian francs","Djibouti Franc","franc","francs"],"exact":["DJF","Fdj"],"symbols":[]},"DKK":{"names":["Danish Krone","Danish kroner","krone","kroner","Danish crown","Danish crowns","crown","crowns","dansk krone","danske kroner"],"exact":["DKK","kr","kr."],"symbols":[]},"DOP":{"names":["Dominican Peso","Dominican pesos","peso dominicano","pesos dominicanos","peso","pesos"],"exact":["DOP"],"symbols":["$","RD$"]},"DZD":{"names":["Algerian Dinar","Algerian dinars","Algeria dinar","دينار جزائري","ديناران جزائريان","dinar","dinars"],"exact":["DZD","DA","د.ج"],"symbols":[]},"EGP":{"names":["Egyptian Pound","Egyptian pounds","جنيه","جنيه مصري","جنيهان مصريان","pound","pounds"],"exact":["EGP","LE","L.E.","ج.م"],"symbols":["E£","£"]},"ERN":{"names":["Eritrean Nakfa","Eritrean nakfas","Nakfa","nakfas","ኤርትራዊ ናቕፋ"],"exact":["ERN","Nfk"],"symbols":[]},"ETB":{"names":["Ethiopian Birr","Ethiopian birrs","birr","birrs","ብር","የኢትዮጵያ ብር"],"exact":["ETB","Br"],"symbols":[]},"EUR":{"names":["Euro","euros"],"exact":["EUR"],"symbols":["€"]},"FJD":{"names":["Fijian Dollar","Fijian dollars","Fiji Dollar","dollar","dollars"],"exact":["FJD"],"symbols":["$","FJ$"]},"FKP":{"names":["Falkland Islands Pound","Falkland Islands pounds","pound","pounds"],"exact":["FKP"],"symbols":["£"]},"GBP":{"names":["British Pound","British pounds","Pound Sterling","British pound sterling","pounds sterling","sterling","UK pound","United Kingdom pound","pound","pounds"],"exact":["GBP"],"symbols":["£","GB£"]},"GEL":{"names":["Georgian Lari","Georgian laris","Lari","laris","ლარი","ქართული ლარი"],"exact":["GEL"],"symbols":["₾"]},"GHS":{"names":["Ghanaian Cedi","Ghanaian cedis","Ghana Cedi","cedi","cedis"],"exact":["GHS"],"symbols":["GH₵","₵"]},"GIP":{"names":["Gibraltar Pound","Gibraltar pounds","pound","pounds"],"exact":["GIP"],"symbols":["£"]},"GMD":{"names":["Gambian Dalasi","Gambian dalasis","Dalasi","dalasis"],"exact":["GMD","D"],"symbols":[]},"GNF":{"names":["Guinean Franc","Guinean francs","franc guinéen","francs guinéens","franc","francs"],"exact":["GNF","FG","Fr"],"symbols":[]},"GTQ":{"names":["Guatemalan Quetzal","Guatemalan quetzals","Quetzal","quetzals","quetzales"],"exact":["GTQ","Q"],"symbols":[]},"GYD":{"names":["Guyanaese Dollar","Guyanaese dollars","Guyana Dollar","Guyanese dollar","dollar","dollars"],"exact":["GYD"],"symbols":["$","G$"]},"HKD":{"names":["Hong Kong Dollar","Hong Kong dollars","Hongkong dollar","港元","港幣","港币","dollar","dollars"],"exact":["HKD"],"symbols":["HK$","$"]},"HNL":{"names":["Honduran Lempira","Honduran lempiras","Lempira","lempiras","lempira hondureño","lempiras hondureños"],"exact":["HNL","L"],"symbols":[]},"HRK":{"names":["Croatian Kuna","Croatian kunas","kuna","kunas","kune","hrvatska kuna","hrvatskih kuna"],"exact":["HRK","kn"],"symbols":[]},"HTG":{"names":["Haitian Gourde","Haitian gourdes","Gourde","gourdes","gourde haïtienne","gourdes haïtiennes"],"exact":["HTG","G"],"symbols":[]},"HUF":{"names":["Hungarian Forint","Hungarian forints","Forint","forints","magyar forint"],"exact":["HUF","Ft"],"symbols":[]},"IDR":{"names":["Indonesian Rupiah","Indonesian rupiahs","Rupiah","rupiahs","Rupiah Indonesia"],"exact":["IDR","Rp","Rp."],"symbols":[]},"ILS":{"names":["Israeli New Shekel","Israeli new shekels","New Israeli Sheqel","Israeli shekel","Israeli sheqel","Israeli new sheqel","New Israeli shekel","shekel","shekels","sheqel","sheqels","sheqalim","shekalim","שקל","שקלים","שקל חדש","שקלים חדשים"],"exact":["ILS","NIS","N.I.S.","ש״ח","ש\"ח"],"symbols":["₪"]},"INR":{"names":["Indian Rupee","Indian rupees","rupaya","rupiya","रुपया","रुपये","रुपए","ரூபாய்","भारतीय रुपया","भारतीय रुपए","இந்திய ரூபாய்","இந்திய ரூபாய்கள்","rupee","rupees"],"exact":["INR","Rs","Rs."],"symbols":["₹","₨"]},"IQD":{"names":["Iraqi Dinar","Iraqi dinars","دينار عراقي","dinar","dinars"],"exact":["IQD","ID","ع.د"],"symbols":[]},"IRR":{"names":["Iranian Rial","Iranian rials","Iranian riyal","rial","rials","ریال","ریال ایران","riyal","riyals"],"exact":["IRR"],"symbols":["﷼"]},"ISK":{"names":["Icelandic Króna","Icelandic krónur","Iceland Krona","Icelandic krona","Icelandic kronur","krona","kronur","króna","krónur","Icelandic crown","crown","crowns","íslensk króna","íslenskar krónur"],"exact":["ISK","kr","kr."],"symbols":[]},"JEP":{"names":["Jersey Pound","Jersey pounds","pound","pounds"],"exact":["JEP"],"symbols":["£"]},"JMD":{"names":["Jamaican Dollar","Jamaican dollars","dollar","dollars"],"exact":["JMD"],"symbols":["$","J$"]},"JOD":{"names":["Jordanian Dinar","Jordanian dinars","دينار أردني","dinar","dinars"],"exact":["JOD","JD","د.ا"],"symbols":[]},"JPY":{"names":["Japanese Yen","Yen","日本円","円"],"exact":["JPY"],"symbols":["¥","JP¥","￥"]},"KES":{"names":["Kenyan Shilling","Kenyan shillings","Kenya shilling","shilingi","Shilingi ya Kenya","shilingi za Kenya"],"exact":["KES","KSh","KShs","Sh"],"symbols":[]},"KGS":{"names":["Kyrgyz Som","Kyrgyz soms","Som","Kyrgyzstani som","soms","сом","Кыргызстан сому"],"exact":["KGS","som"],"symbols":["⃀"]},"KHR":{"names":["Cambodian Riel","Cambodian riels","Riel","riels","រៀល","រៀល កម្ពុជា"],"exact":["KHR"],"symbols":["៛"]},"KID":{"names":["Kiribati Dollar","Kiribati dollars","dollar","dollars"],"exact":["KID"],"symbols":["$"]},"KMF":{"names":["Comorian Franc","Comorian francs","franc comorien","francs comoriens","franc","francs"],"exact":["KMF","CF","Fr"],"symbols":[]},"KPW":{"names":["North Korean Won","won","조선 원","원","조선 민주주의 인민 공화국 원"],"exact":["KPW"],"symbols":["₩"]},"KRW":{"names":["South Korean Won","Won","Korean won","대한민국 원","한국 원","원"],"exact":["KRW"],"symbols":["₩"]},"KWD":{"names":["Kuwaiti Dinar","Kuwaiti dinars","دينار كويتي","dinar","dinars"],"exact":["KWD","KD","د.ك"],"symbols":[]},"KYD":{"names":["Cayman Islands Dollar","Cayman Islands dollars","Cayman dollar","dollar","dollars"],"exact":["KYD"],"symbols":["$","CI$"]},"KZT":{"names":["Kazakhstani Tenge","Kazakhstani tenges","Tenge","Kazakh tenge","tenges","теңге","Қазақстан теңгесі"],"exact":["KZT"],"symbols":["₸"]},"LAK":{"names":["Laotian Kip","Laotian kips","Lao Kip","kip","kips","ກີບ","ລາວ ກີບ"],"exact":["LAK"],"symbols":["₭"]},"LBP":{"names":["Lebanese Pound","Lebanese pounds","Lebanese lira","Lebanese lire","ليرة لبنانية","جنيه لبناني","pound","pounds"],"exact":["LBP","LL","L.L.","ل.ل"],"symbols":["L£","£"]},"LKR":{"names":["Sri Lankan Rupee","Sri Lankan rupees","Sri Lanka Rupee","ශ්‍රී ලංකා රුපියල","இலங்கை ரூபாய்","இலங்கை ரூபாய்கள்","rupee","rupees"],"exact":["LKR","Rs","Rs.","SLRs"],"symbols":["₨"]},"LRD":{"names":["Liberian Dollar","Liberian dollars","dollar","dollars"],"exact":["LRD"],"symbols":["$","L$"]},"LSL":{"names":["Lesotho Loti","Lesotho lotis","Loti","lotis","maloti"],"exact":["LSL","L","M"],"symbols":[]},"LTL":{"names":["Lithuanian Litas","Lithuanian litai","litas","litai","Lietuvos litas","Lietuvos litai"],"exact":["LTL","Lt"],"symbols":[]},"LVL":{"names":["Latvian Lats","Latvian lati","lats","lati","Latvijas lats","Latvijas lati"],"exact":["LVL","Ls"],"symbols":[]},"LYD":{"names":["Libyan Dinar","Libyan dinars","دينار ليبي","ديناران ليبيان","dinar","dinars"],"exact":["LYD","LD","ل.د"],"symbols":[]},"MAD":{"names":["Moroccan Dirham","Moroccan dirhams","Morocco dirham","درهم مغربي","درهمان مغربيان","dirham marocain","dirhams marocains","dirham","dirhams"],"exact":["MAD","DH","Dhs","د.م."],"symbols":[]},"MDL":{"names":["Moldovan Leu","Moldovan lei","Moldavian leu","leu","lei","leu moldovenesc","lei moldovenești"],"exact":["MDL","L"],"symbols":[]},"MGA":{"names":["Malagasy Ariary","Malagasy ariaries","ariary","ariaries"],"exact":["MGA","Ar"],"symbols":[]},"MKD":{"names":["Macedonian Denar","Macedonian denari","Denar","North Macedonian denar","denars","denari","денар","Македонски денар","Македонски денари"],"exact":["MKD","ден"],"symbols":[]},"MMK":{"names":["Myanmar Kyat","Myanmar kyats","Kyat","Burmese kyat","kyats","ကျပ်","မြန်မာ ကျပ်"],"exact":["MMK","K"],"symbols":[]},"MNT":{"names":["Mongolian Tugrik","Mongolian tugriks","Tugrik","Mongolian tugrug","Mongolian togrog","Mongolian tögrög","tugriks","tugrug","togrog","tögrög","төгрөг","Монгол төгрөг"],"exact":["MNT"],"symbols":["₮"]},"MOP":{"names":["Macanese Pataca","Macanese patacas","Pataca","Macao pataca","Macau pataca","patacas","澳門元","澳门元"],"exact":["MOP"],"symbols":["MOP$"]},"MRU":{"names":["Mauritanian Ouguiya","Mauritanian ouguiyas","Ouguiya","ouguiyas","أوقية","أوقية موريتانية"],"exact":["MRU","UM"],"symbols":[]},"MUR":{"names":["Mauritian Rupee","Mauritian rupees","Mauritius Rupee","roupie mauricienne","roupies mauriciennes","rupee","rupees"],"exact":["MUR","Rs","Rs."],"symbols":["₨"]},"MVR":{"names":["Maldivian Rufiyaa","Maldivian rufiyaas","Rufiyaa","rufiyaas","Maldives rufiyaa"],"exact":["MVR","Rf","MRf"],"symbols":[]},"MWK":{"names":["Malawian Kwacha","Malawian kwachas","Malawi Kwacha","kwacha","kwachas"],"exact":["MWK","MK"],"symbols":[]},"MXN":{"names":["Mexican Peso","Mexican pesos","peso mexicano","pesos mexicanos","peso","pesos"],"exact":["MXN"],"symbols":["MX$","$","Mex$"]},"MYR":{"names":["Malaysian Ringgit","Malaysian ringgits","ringgit","ringgits","Ringgit Malaysia"],"exact":["MYR","RM"],"symbols":[]},"MZN":{"names":["Mozambican Metical","Mozambican meticals","Mozambique Metical","metical","meticals","meticais","metical moçambicano","meticais moçambicanos"],"exact":["MZN","MT","MTn"],"symbols":[]},"NAD":{"names":["Namibian Dollar","Namibian dollars","Namibia Dollar","dollar","dollars"],"exact":["NAD"],"symbols":["$","N$"]},"NGN":{"names":["Nigerian Naira","Nigerian nairas","Naira","nairas"],"exact":["NGN"],"symbols":["₦"]},"NIO":{"names":["Nicaraguan Córdoba","Nicaraguan córdobas","Cordoba Oro","cordoba","córdoba","cordobas","córdobas","córdoba nicaragüense","córdobas nicaragüenses"],"exact":["NIO"],"symbols":["C$"]},"NOK":{"names":["Norwegian Krone","Norwegian kroner","krone","kroner","Norwegian crown","Norwegian crowns","crown","crowns","norske kroner","norsk krone"],"exact":["NOK","kr","kr."],"symbols":[]},"NPR":{"names":["Nepalese Rupee","Nepalese rupees","Nepali rupee","नेपाली रूपैयाँ","rupee","rupees"],"exact":["NPR","Rs","Rs."],"symbols":["₨"]},"NZD":{"names":["New Zealand Dollar","New Zealand dollars","dollar","dollars"],"exact":["NZD"],"symbols":["NZ$","$"]},"OMR":{"names":["Omani Rial","Omani rials","Rial Omani","ريال عماني","rial","rials","riyal","riyals"],"exact":["OMR","RO","R.O.","ر.ع."],"symbols":[]},"PAB":{"names":["Panamanian Balboa","Panamanian balboas","Balboa","balboas","balboa panameño","balboas panameños"],"exact":["PAB","B","B/","B/."],"symbols":[]},"PEN":{"names":["Peruvian Sol","Peruvian soles","Sol","soles","nuevo sol","nuevos soles","sol peruano","soles peruanos"],"exact":["PEN","S/","S/."],"symbols":[]},"PGK":{"names":["Papua New Guinean Kina","Kina","kinas"],"exact":["PGK","K"],"symbols":[]},"PHP":{"names":["Philippine Peso","Philippine pesos","Philippine piso","Philippines peso","Philippines piso","piso","pisos","Piso ng Pilipinas","peso","pesos"],"exact":["PHP"],"symbols":["₱"]},"PKR":{"names":["Pakistani Rupee","Pakistani rupees","Pakistan Rupee","روپیہ","پاکستانی روپیہ","rupee","rupees"],"exact":["PKR","Rs","Rs."],"symbols":["₨"]},"PLN":{"names":["Polish Zloty","Polish zlotys","Zloty","Polish złoty","zlotys","zlotych","złoty","złote","złotych","złoty polski","złotego polskiego"],"exact":["PLN","zł"],"symbols":[]},"PYG":{"names":["Paraguayan Guarani","Paraguayan guaranis","Guarani","Paraguayan guaraní","guaraní","guaranis","guaranies","guaraníes","guaraní paraguayo","guaraníes paraguayos"],"exact":["PYG"],"symbols":["₲"]},"QAR":{"names":["Qatari Riyal","Qatari riyals","Qatari Rial","ريال قطري","rial","rials","riyal","riyals"],"exact":["QAR","QR","ر.ق"],"symbols":[]},"RON":{"names":["Romanian Leu","Romanian lei","leu","lei","leu românesc","lei românești"],"exact":["RON","lei"],"symbols":[]},"RSD":{"names":["Serbian Dinar","Serbian dinars","dinar","dinars","српски динар","српских динара"],"exact":["RSD","din","дин"],"symbols":[]},"RUB":{"names":["Russian Ruble","Russian rubles","Russian rouble","Russian roubles","ruble","rubles","rouble","roubles","рубль","рубли","рублей","российский рубль","российского рубля"],"exact":["RUB","руб","руб."],"symbols":["₽"]},"RWF":{"names":["Rwandan Franc","Rwandan francs","Rwanda Franc","franc","francs"],"exact":["RWF","RF","FRw","Fr"],"symbols":[]},"SAR":{"names":["Saudi Riyal","Saudi riyals","Saudi Arabian riyal","Saudi rial","ريال سعودي","rial","rials","riyal","riyals"],"exact":["SAR","SR","ر.س"],"symbols":[]},"SBD":{"names":["Solomon Islands Dollar","Solomon Islands dollars","dollar","dollars"],"exact":["SBD"],"symbols":["$","SI$"]},"SCR":{"names":["Seychellois Rupee","Seychellois rupees","Seychelles Rupee","roupie des Seychelles","roupies des Seychelles","rupee","rupees"],"exact":["SCR","Rs","Rs.","SR"],"symbols":["₨"]},"SDG":{"names":["Sudanese Pound","Sudanese pounds","جنيه سوداني","pound","pounds"],"exact":["SDG","ج.س."],"symbols":[]},"SEK":{"names":["Swedish Krona","Swedish kronor","krona","kronor","Swedish crown","Swedish crowns","crown","crowns","svensk krona","svenska kronor"],"exact":["SEK","kr","kr."],"symbols":[]},"SGD":{"names":["Singapore Dollar","Singapore dollars","新加坡元","dollar","dollars"],"exact":["SGD"],"symbols":["$","S$"]},"SHP":{"names":["St. Helena Pound","St. Helena pounds","Saint Helena Pound","pound","pounds"],"exact":["SHP"],"symbols":["£"]},"SLE":{"names":["Sierra Leonean Leone","Sierra Leonean leones","Leone","Sierra Leone leone","new leone","leones"],"exact":["SLE","Le","NLe"],"symbols":[]},"SLL":{"names":["Sierra Leonean Leone (1964—2022)","Sierra Leonean leones (1964—2022)","Sierra Leone leone","old leone","leone","leones"],"exact":["SLL","Le"],"symbols":[]},"SOS":{"names":["Somali Shilling","Somali shillings","Somalian shilling","Shilingka Soomaaliya"],"exact":["SOS","Sh","SSh"],"symbols":[]},"SRD":{"names":["Surinamese Dollar","Surinamese dollars","Surinam Dollar","dollar","dollars"],"exact":["SRD"],"symbols":["$","Sr$"]},"SSP":{"names":["South Sudanese Pound","South Sudanese pounds","جنيه جنوب السودان","جنيهان جنوب السودان","pound","pounds"],"exact":["SSP"],"symbols":["£"]},"STD":{"names":["São Tomé & Príncipe Dobra (1977–2017)","São Tomé & Príncipe dobras (1977–2017)","Sao Tome and Principe dobra","São Tomé and Príncipe dobra","old dobra","dobra","dobras","Dobra de São Tomé e Príncipe (1977–2017)","Dobras de São Tomé e Príncipe (1977–2017)"],"exact":["STD","Db"],"symbols":[]},"STN":{"names":["São Tomé & Príncipe Dobra","São Tomé & Príncipe dobras","Dobra","Sao Tome and Principe dobra","São Tomé and Príncipe dobra","new dobra","dobras","dobra de São Tomé e Príncipe","dobras de São Tomé e Príncipe"],"exact":["STN","Db"],"symbols":[]},"SVC":{"names":["Salvadoran Colón","Salvadoran colones","El Salvador Colon","Salvadoran colon","colon","colón","colones","colón salvadoreño","colones salvadoreños"],"exact":["SVC"],"symbols":["₡"]},"SYP":{"names":["Syrian Pound","Syrian pounds","Syrian lira","Syrian lire","ليرة سورية","pound","pounds"],"exact":["SYP","LS","L.S.","ل.س"],"symbols":["£"]},"SZL":{"names":["Swazi Lilangeni","Swazi emalangeni","Lilangeni","Eswatini lilangeni","emalangeni"],"exact":["SZL","L","E"],"symbols":[]},"THB":{"names":["Thai Baht","Baht","บาท","บาทไทย"],"exact":["THB"],"symbols":["฿"]},"TJS":{"names":["Tajikistani Somoni","Tajikistani somonis","Somoni","Tajik somoni","somonis","сомонӣ","Сомонии Тоҷикистон"],"exact":["TJS","SM"],"symbols":[]},"TMT":{"names":["Turkmenistani Manat","Turkmenistan New Manat","Turkmen manat","manat","manats","Türkmen manady"],"exact":["TMT","m"],"symbols":[]},"TND":{"names":["Tunisian Dinar","Tunisian dinars","دينار تونسي","ديناران تونسيان","dinar","dinars"],"exact":["TND","DT","د.ت"],"symbols":[]},"TOP":{"names":["Tongan Paʻanga","Pa’anga","paanga","pa'anga","paʻanga","Paʻanga fakatonga"],"exact":["TOP"],"symbols":["T$"]},"TRY":{"names":["Turkish Lira","Türkiye lira","Turkiye lira","lira","liras","lire","Türk lirası"],"exact":["TRY","TL"],"symbols":["₺"]},"TTD":{"names":["Trinidad & Tobago Dollar","Trinidad & Tobago dollars","Trinidad and Tobago Dollar","dollar","dollars"],"exact":["TTD"],"symbols":["$","TT$"]},"TWD":{"names":["New Taiwan Dollar","New Taiwan dollars","Taiwan dollar","Taiwanese dollar","新台幣","新臺幣","新台币","新臺币","dollar","dollars"],"exact":["TWD","NTD"],"symbols":["NT$","$"]},"TZS":{"names":["Tanzanian Shilling","Tanzanian shillings","Shilingi ya Tanzania","shilingi za Tanzania"],"exact":["TZS","TSh","TShs","Sh"],"symbols":[]},"UAH":{"names":["Ukrainian Hryvnia","Ukrainian hryvnias","Hryvnia","hryvnias","hryvnya","hryvni","гривня","гривні","гривень","українська гривня","української гривні"],"exact":["UAH","грн"],"symbols":["₴"]},"UGX":{"names":["Ugandan Shilling","Ugandan shillings","Uganda Shilling","Shilingi ya Uganda","shilingi za Uganda"],"exact":["UGX","USh","UShs","Sh"],"symbols":[]},"USD":{"names":["US Dollar","US dollars","United States dollar","United States dollars","U.S. dollar","U.S. dollars","American dollar","American dollars","dollar","dollars"],"exact":["USD"],"symbols":["$","US$"]},"UYU":{"names":["Uruguayan Peso","Uruguayan pesos","Peso Uruguayo","pesos uruguayos","peso","pesos"],"exact":["UYU"],"symbols":["$","$U"]},"UZS":{"names":["Uzbekistani Som","Uzbekistan Sum","Uzbek som","Uzbek sum","som","sum","sums","so'm","soʻm","so‘m","O‘zbekiston so‘mi"],"exact":["UZS","so'm"],"symbols":[]},"VED":{"names":["Bolívar Soberano","Bolívar Soberanos","Venezuelan digital bolivar","digital bolivar","bolivar digital","bolivar soberano","bolivar","bolivars","bolívares"],"exact":["VED","Bs","Bs."],"symbols":[]},"VEF":{"names":["Venezuelan Bolívar (2008–2018)","Venezuelan bolívars (2008–2018)","Venezuelan bolivar fuerte","bolivar fuerte","bolívar fuerte","bolivar","bolivars","bolívares","bolívar venezolano (2008–2018)","bolívares venezolanos (2008–2018)"],"exact":["VEF","Bs.F","BsF","Bs"],"symbols":[]},"VES":{"names":["Venezuelan Bolívar","Venezuelan bolívars","Bolívar Soberano","Venezuelan bolivar soberano","bolivar soberano","bolivar","bolivars","bolívares","bolívares soberanos"],"exact":["VES","Bs.S","BsS","Bs","Bs."],"symbols":[]},"VND":{"names":["Vietnamese Dong","Dong","Vietnamese đồng","đồng","Đồng Việt Nam"],"exact":["VND"],"symbols":["₫"]},"VUV":{"names":["Vanuatu Vatu","Vanuatu vatus","Vatu","vatus"],"exact":["VUV","VT"],"symbols":[]},"WST":{"names":["Samoan Tala","Tala","tālā"],"exact":["WST"],"symbols":["WS$","$"]},"XAF":{"names":["Central African CFA Franc","Central African CFA francs","CFA Franc BEAC","Central African franc","CFA franc","CFA francs","franc CFA (BEAC)","francs CFA (BEAC)","franc","francs"],"exact":["XAF","CFA","FCFA","BEAC","Fr"],"symbols":[]},"XCD":{"names":["East Caribbean Dollar","East Caribbean dollars","Eastern Caribbean dollar","dollar","dollars"],"exact":["XCD"],"symbols":["EC$","$"]},"XCG":{"names":["Caribbean guilder","Caribbean guilders","Caribische gulden","guilder","guilders","gulden"],"exact":["XCG","Cg","Cg."],"symbols":[]},"XOF":{"names":["West African CFA Franc","West African CFA francs","CFA Franc BCEAO","West African franc","CFA franc","CFA francs","franc CFA (BCEAO)","francs CFA (BCEAO)","franc","francs"],"exact":["XOF","CFA","FCFA","BCEAO","Fr","F CFA"],"symbols":[]},"XPF":{"names":["CFP Franc","CFP francs","French Pacific franc","Pacific franc","franc CFP","francs CFP","franc","francs"],"exact":["XPF","CFP","F CFP","CFPF","Fr"],"symbols":[]},"YER":{"names":["Yemeni Rial","Yemeni rials","Yemen rial","ريال يمني","rial","rials","riyal","riyals"],"exact":["YER","ر.ي"],"symbols":["﷼"]},"ZAR":{"names":["South African Rand","Rand"],"exact":["ZAR","R"],"symbols":[]},"ZMW":{"names":["Zambian Kwacha","Zambian kwachas","Zambia kwacha","kwacha","kwachas"],"exact":["ZMW","ZK"],"symbols":[]},"ZWG":{"names":["Zimbabwean Gold","Zimbabwe Gold"],"exact":["ZWG","ZiG"],"symbols":[]}};
  // END GENERATED COUNTRY SEARCH DATA

  // Hidden aliases supplement the rendered labels; they never change localization values.
  class CountrySearchIndex {
    static normalize(value) {
      return String(value ?? '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/&(?:amp;)?/g, ' and ')
        .replace(/[.'’ʼ`]/g, '')
        .replace(/[^\p{L}\p{M}\p{N}\p{Sc}ƒ]+/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    constructor(locales = ['en']) {
      this.displayNames = [];
      if (typeof Intl.DisplayNames === 'function') {
        for (const locale of new Set([...locales, 'en'].filter(Boolean))) {
          for (const type of ['region', 'currency']) {
            try {
              this.displayNames.push({ type, names: new Intl.DisplayNames([locale], { type, fallback: 'none' }) });
            } catch (error) {
              continue;
            }
          }
        }
      }
    }

    addExact(target, values) {
      for (const value of values) {
        const normalized = CountrySearchIndex.normalize(value);
        if (normalized) {
          target.add(normalized);
          target.add(normalized.replace(/\s/g, ''));
        }
      }
    }

    createEntry({ countryCode, currencyCode, countryName, currencySymbol }) {
      const country = COUNTRY_SEARCH_COUNTRIES[countryCode] || {};
      // Use the currency Shopify actually offers for this row, not the country's national currency.
      const currency = COUNTRY_SEARCH_CURRENCIES[currencyCode] || {};
      const countryExact = new Set();
      const currencyExact = new Set();
      const currencyNotations = new Set([...(currency.exact || []), ...(currency.symbols || []), currencySymbol]
        .filter(Boolean).map((notation) => notation.normalize('NFKD').toLowerCase().replace(/\s/g, '')));
      this.addExact(countryExact, [countryCode, country.alpha3, ...(country.exact || [])]);
      this.addExact(currencyExact, [currencyCode, ...(currency.exact || []), ...(currency.symbols || []), currencySymbol]);
      const labels = { region: [countryName, ...(country.names || [])], currency: [...(currency.names || [])] };
      for (const { type, names } of this.displayNames) {
        try {
          labels[type].push(names.of(type === 'region' ? countryCode : currencyCode));
        } catch (error) {
          continue;
        }
      }
      const displayedName = CountrySearchIndex.normalize(countryName);
      const countryNames = [...new Set(labels.region.map(CountrySearchIndex.normalize).filter(Boolean))];
      const currencyNames = new Set(labels.currency.map(CountrySearchIndex.normalize).filter(Boolean));
      const formal = /\b(?:republic\w*|republik\w*|kingdom|principality|commonwealth|federat\w*|confederation|administrative|sar|province|states?|union|islamic|democratic|duchy|territor\w*)\b/u;
      const extendedNames = countryNames.filter((name) => name !== displayedName && formal.test(name));
      const prefixNames = countryNames.filter((name) => !extendedNames.includes(name));
      return { displayedName, countryExact, currencyExact, currencyNotations, countryNames, currencyNames, prefixNames, extendedNames };
    }

    matchesCountryPrefix(name, tokens) {
      const words = name.split(' ');
      return words.some((word, start) => !['and', 'of', 'the'].includes(word) &&
        tokens.every((token, offset) => offset === tokens.length - 1
          ? words[start + offset]?.startsWith(token)
          : words[start + offset] === token));
    }

    matches(entry, value) {
      const query = CountrySearchIndex.normalize(value);
      if (!query) return String(value ?? '').trim() === '';
      const raw = String(value ?? '').trim();
      if (/^[a-z]$/u.test(query)) {
        return /^[\p{L}\p{M}]+$/u.test(raw)
          ? entry.displayedName.startsWith(query)
          : entry.currencyNotations.has(raw.normalize('NFKD').toLowerCase().replace(/\s/g, ''));
      }
      const compact = query.replace(/\s/g, '');
      if ([entry.countryExact, entry.currencyExact].some((exact) => exact.has(query) || exact.has(compact))) return true;
      if (entry.countryNames.includes(query) || entry.currencyNames.has(query)) return true;
      if (query.length < 2) return false;
      const tokens = query.split(' ');
      if (entry.prefixNames.some((name) => this.matchesCountryPrefix(name, tokens))) return true;
      if (compact.length < 3) return false;
      const genericOpening = /^(?:the|of|and|united|republic\w*|republik\w*|kingdom|principality|commonwealth|federat\w*|democratic|islamic|peoples?|state\w*|union|grand|special)$/u;
      return entry.extendedNames.some((name) => name.startsWith(query) &&
        (!genericOpening.test(name.split(' ')[0]) || (tokens.length >= 2 && tokens.at(-1).length >= 2)));
    }
  }

  class CountrySearch extends HTMLElement {
    connectedCallback() {
      // Drawer reparenting keeps this same connected subtree and its search index.
      if (this.input && this.listbox && this.dialogElement
        && this.abortController && !this.abortController.signal.aborted) return;
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.observedScrollContainer?.removeEventListener('scroll', this.onScroll);
      this.observedScrollContainer = null;
      window.cancelAnimationFrame(this.layoutFrame);
      this.abortController = new AbortController();

      this.input = this.querySelector('[data-country-search-input]');
      this.listbox = this.querySelector('[data-country-search-results]');
      this.options = Array.from(this.querySelectorAll('button[name="country_code"]'));
      this.dialogElement = this.closest('country-drawer');
      const locales = [document.documentElement.lang, navigator.language, 'en'];
      this.searchIndex = new CountrySearchIndex(locales);
      this.searchEntries = new Map();
      this.motionRevision = 0;

      if (!this.input || !this.listbox || !this.dialogElement) {
        return;
      }

      for (const option of this.options) {
        this.searchEntries.set(option, this.searchIndex.createEntry({
          countryCode: option.value,
          currencyCode: option.dataset.countrySearchCurrencyCode,
          countryName: option.dataset.countrySearchName,
          currencySymbol: option.dataset.countrySearchCurrencySymbol
        }));
      }

      const signal = this.abortController.signal;

      this.input.addEventListener('input', () => this.filter(), { signal });
      this.addEventListener('keydown', (event) => this.onKeyDown(event), { capture: true, signal });
      this.dialogElement.addEventListener('dialog:before-show', () => this.prepareToShow(), { signal });
      this.dialogElement.addEventListener('dialog:after-show', () => this.focusInput(), { signal });
      this.dialogElement.addEventListener('dialog:after-hide', () => this.afterHide(), { signal });

      this.onScroll = () => this.updateBottomVignette();
      this.observeScrollContainer();
      window.addEventListener('resize', () => this.scheduleVignetteRefresh(), { passive: true, signal });
      window.visualViewport?.addEventListener('resize', () => this.scheduleVignetteRefresh(), { passive: true, signal });
    }

    disconnectedCallback() {
      // Native append/appendChild queues this callback after the move has completed.
      if (this.isConnected) return;
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.observedScrollContainer?.removeEventListener('scroll', this.onScroll);
      this.observedScrollContainer = null;
      window.cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = null;
      this.cancelMotion();
      this.dialogElement?.removeAttribute('data-country-can-scroll-down');
    }

    normalize(value) {
      // Keep currency notation intact for matching, including restored drawer queries.
      return String(value ?? '').trim();
    }

    filter() {
      const query = this.normalize(this.input.value);
      const revision = ++this.motionRevision;
      const scrollContainer = this.getScrollContainer();

      window.clearTimeout(this.filterTimer);

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !scrollContainer ||
        scrollContainer.getBoundingClientRect().height === 0
      ) {
        this.stopAnimations();
        this.clearMotionStyles();
        this.applyQuery(query);
        this.scrollToTop();
        return;
      }

      this.filterTimer = window.setTimeout(() => {
        this.filterTimer = null;
        this.transitionToQuery(query, revision);
      }, 48);
    }

    applyQuery(query) {
      for (const option of this.options) {
        option.hidden = !this.searchIndex.matches(this.searchEntries.get(option), query);
      }
    }

    async transitionToQuery(query, revision) {
      if (revision !== this.motionRevision) {
        return;
      }

      if (!this.listbox) {
        this.applyQuery(query);
        return;
      }

      const frozenState = this.freezeMotionState();
      this.listbox.setAttribute('aria-busy', 'true');

      this.resultsAnimation = this.listbox.animate(
        [
          { opacity: frozenState.opacity, transform: frozenState.transform },
          { opacity: 0, transform: 'translateY(-3px)' }
        ],
        { duration: 96, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
      );

      await this.waitForAnimation(this.resultsAnimation);

      if (revision !== this.motionRevision) {
        return;
      }

      this.listbox.style.opacity = '0';
      this.listbox.style.transform = 'translateY(-3px)';
      this.resultsAnimation?.cancel();
      this.resultsAnimation = null;

      this.applyQuery(query);
      this.scrollToTop();

      this.listbox.style.transform = 'translateY(4px)';

      this.resultsAnimation = this.listbox.animate(
        [
          { opacity: 0, transform: 'translateY(4px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 230, delay: 42, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
      );

      await this.waitForAnimation(this.resultsAnimation);

      if (revision !== this.motionRevision) {
        return;
      }

      this.stopAnimations();
      this.clearMotionStyles();
    }

    freezeMotionState() {
      const listboxStyle = window.getComputedStyle(this.listbox);
      const opacity = listboxStyle.opacity;
      const transform = listboxStyle.transform === 'none' ? 'translateY(0)' : listboxStyle.transform;

      this.stopAnimations();
      this.listbox.style.opacity = opacity;
      this.listbox.style.transform = transform;

      return { opacity, transform };
    }

    waitForAnimation(animation) {
      return animation?.finished.catch(() => undefined) ?? Promise.resolve();
    }

    stopAnimations() {
      this.resultsAnimation?.cancel();
      this.resultsAnimation = null;
    }

    clearMotionStyles() {
      this.listbox?.removeAttribute('aria-busy');
      this.listbox?.style.removeProperty('opacity');
      this.listbox?.style.removeProperty('transform');
      this.updateBottomVignette();
    }

    cancelMotion() {
      this.motionRevision = (this.motionRevision ?? 0) + 1;
      window.clearTimeout(this.filterTimer);
      this.filterTimer = null;
      this.stopAnimations();
      this.clearMotionStyles();
    }

    reset() {
      this.cancelMotion();
      this.input.value = '';
      this.applyQuery('');
      this.scrollToTop();
    }

    prepareToShow() {
      this.observeScrollContainer();
      this.reset();
    }

    afterHide() {
      this.reset();
      this.dialogElement?.removeAttribute('data-country-can-scroll-down');
    }

    focusInput() {
      if (!this.dialogElement?.open) {
        return;
      }

      this.scrollToTop();

      try {
        this.input.focus({ preventScroll: true });
      } catch (error) {
        this.input.focus();
      }
    }

    scheduleVignetteRefresh() {
      window.cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = window.requestAnimationFrame(() => {
        this.layoutFrame = null;
        this.updateBottomVignette();
      });
    }

    getScrollContainer() {
      return this.dialogElement?.shadowRoot?.querySelector('[part~="body"]') || null;
    }

    ensureVisibleFocus() {
      const scroller = this.getScrollContainer();
      if (!scroller || document.activeElement !== this.input) return;
      const bounds = scroller.getBoundingClientRect();
      const inputBounds = this.input.getBoundingClientRect();
      const clearance = parseFloat(getComputedStyle(scroller).scrollPaddingTop) || 0;
      if (inputBounds.top < bounds.top + clearance || inputBounds.bottom > bounds.bottom) {
        this.dialogElement.shadowRoot.querySelector('[part~="close-button"]')?.focus({ preventScroll: true });
      }
    }

    observeScrollContainer() {
      const scrollContainer = this.getScrollContainer();
      if (scrollContainer === this.observedScrollContainer) return;
      this.observedScrollContainer?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      this.observedScrollContainer = scrollContainer;
      if (!scrollContainer) return;
      scrollContainer.addEventListener('scroll', this.onScroll, { passive: true, signal: this.abortController.signal });
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => this.scheduleVignetteRefresh());
        this.resizeObserver.observe(scrollContainer);
      }
    }

    scrollToTop() {
      const scrollContainer = this.getScrollContainer();

      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
        this.updateBottomVignette();
      }
    }

    updateBottomVignette() {
      if (!this.dialogElement?.open || this.isConnected === false) {
        this.dialogElement?.removeAttribute('data-country-can-scroll-down');
        return;
      }
      const scrollContainer = this.getScrollContainer();
      const hasMoreBelow = Boolean(
        scrollContainer &&
          scrollContainer.clientHeight > 0 &&
          scrollContainer.scrollTop + scrollContainer.clientHeight < scrollContainer.scrollHeight - 1
      );

      this.dialogElement?.toggleAttribute('data-country-can-scroll-down', hasMoreBelow);
    }

    onKeyDown(event) {
      if (event.target === this.input) {
        if (event.key === 'Enter') {
          event.preventDefault();
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          const visibleOptions = this.options.filter((option) => !option.hidden);
          const option = event.key === 'ArrowDown' ? visibleOptions[0] : visibleOptions.at(-1);

          option?.focus();
          event.preventDefault();
        }

        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
        return;
      }

      const currentOption = event.target.closest('button[name="country_code"]');

      if (!currentOption) {
        return;
      }

      const visibleOptions = this.options.filter((option) => !option.hidden);
      const currentIndex = visibleOptions.indexOf(currentOption);
      const nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;

      visibleOptions[nextIndex]?.focus();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  if (!window.customElements.get('country-search')) {
    window.customElements.define('country-search', CountrySearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-range"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('formatted-price-range')) {
    class FormattedPriceRange extends HTMLElement {
      connectedCallback() {
        if (this.dataset.formattedPriceRangeReady === 'true') {
          this.priceScaleObserver?.observe(this);
          this.installInventoryScale?.();
          return;
        }

        this.dataset.formattedPriceRangeReady = 'true';

        const minimumDisplay = this.querySelector('[data-price-display="minimum"]');
        const maximumDisplay = this.querySelector('[data-price-display="maximum"]');
        const minimumValue = this.querySelector('[data-price-value="minimum"]');
        const maximumValue = this.querySelector('[data-price-value="maximum"]');
        const minimumRange = this.querySelector('input[type="range"]:first-child');
        const maximumRange = this.querySelector('input[type="range"]:last-child');
        const rangeGroup = minimumRange.parentElement;
        let rangeMaximum = Number.parseInt(maximumRange.max, 10);
        let contextualMinimum = 0;
        const originalMaximum = rangeMaximum;
        const priceStep = Number.parseInt(maximumRange.step, 10);
        const onlinePurchaseToggle = this.querySelector('[data-online-purchase-toggle]');
        const onlinePurchaseMaximum = Math.min(
          Number.parseInt(this.dataset.onlinePurchaseMax, 10),
          rangeMaximum
        );
        const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
        const displaySwapDuration = 100;
        const onlinePurchaseSliderDuration = 360;
        const rangeTrackSliderDuration = 260;
        const rangeTrackDragThreshold = 4;
        const minimumRangeStep = 'any';
        const maximumRangeStep = 'any';
        let displaySwapTimer = null;
        let onlinePurchaseSliderFrame = null;
        let rangeTrackSliderFrame = null;
        let rangeTrackSliderRange = null;
        let rangeTrackSliderTarget = null;
        let rangeTrackSliderStep = null;
        let pendingMinimumDisplay = minimumDisplay.value;
        let pendingMaximumDisplay = maximumDisplay.value;
        let inventoryScale = null;
        let pendingScale = null;
        let makeInventoryScale = null;
        const basePosition = price => inventoryScale ? inventoryScale.toPosition(price) : price / rangeMaximum;
        const priceToPosition = price => (basePosition(price) - basePosition(contextualMinimum)) / Math.max(0.000001, 1 - basePosition(contextualMinimum));
        const positionToPrice = position => {
          const mapped = basePosition(contextualMinimum) + position * (1 - basePosition(contextualMinimum));
          return inventoryScale ? inventoryScale.toPrice(mapped) : mapped * rangeMaximum;
        };
        const getRangePrice = range => this.hasAttribute('data-single-range')
          ? (range === minimumRange ? contextualMinimum : rangeMaximum) : Math.round(positionToPrice(Number(range.value) / rangeMaximum));
        const setRangePrice = (range, price) => {
          range.step = 'any';
          // A single price has no numeric span; retain two distinct visual endpoints.
          range.value = this.hasAttribute('data-single-range')
            ? (range === minimumRange ? range.min : range.max)
            : priceToPosition(price) * rangeMaximum;
          range.setAttribute('aria-valuetext', format(Math.round(price)));
        };
        let rangesReversed = getRangePrice(minimumRange) > getRangePrice(maximumRange);

        const numberFrom = (value) => {
          const digits = String(value ?? '').replace(/[^\d]/g, '');
          return digits === '' ? '' : String(Number.parseInt(digits, 10));
        };

        const format = (value) => {
          const number = numberFrom(value);
          return number === '' ? '' : formatter.format(Number.parseInt(number, 10));
        };

        const priceIncrement = value => value > 1000000 ? 100000 : value > 500000 ? 50000 : value > 250000 ? 25000 : value > 100000 ? 10000 : value > 50000 ? 5000 : priceStep;
        const snap = value => value >= rangeMaximum ? rangeMaximum : Math.max(contextualMinimum, Math.min(rangeMaximum, Math.round(value / priceIncrement(value)) * priceIncrement(value)));
        const advancePrice = (value, steps) => {
          const direction = Math.sign(steps);
          for (let index = 0; index < Math.abs(steps); index++) {
            const increment = priceIncrement(value + (direction > 0 ? 1 : 0));
            value = direction > 0
              ? (Math.floor(value / increment) + 1) * increment
              : (Math.ceil(value / increment) - 1) * increment;
          }
          return Math.min(rangeMaximum, Math.max(contextualMinimum, value));
        };
        const notifyChange = () => {
          this.dispatchEvent(new CustomEvent('raiman:facet-range-change', { bubbles: true }));
        };
        const commitDisplaySwap = () => {
          displaySwapTimer = null;
          minimumDisplay.value = pendingMinimumDisplay;
          maximumDisplay.value = pendingMaximumDisplay;

          requestAnimationFrame(() => {
            minimumDisplay.classList.remove('range-value--swapping');
            maximumDisplay.classList.remove('range-value--swapping');
          });
        };
        const beginDisplaySwap = () => {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
          }

          if (displaySwapTimer !== null) {
            window.clearTimeout(displaySwapTimer);
          }

          pendingMinimumDisplay = minimumDisplay.value;
          pendingMaximumDisplay = maximumDisplay.value;
          minimumDisplay.classList.add('range-value--swapping');
          maximumDisplay.classList.add('range-value--swapping');
          displaySwapTimer = window.setTimeout(commitDisplaySwap, displaySwapDuration);
        };
        const setMinimumDisplay = (value) => {
          if (displaySwapTimer !== null) {
            pendingMinimumDisplay = value;
          } else {
            minimumDisplay.value = value;
          }
        };
        const setMaximumDisplay = (value) => {
          if (displaySwapTimer !== null) {
            pendingMaximumDisplay = value;
          } else {
            maximumDisplay.value = value;
          }
        };
        const cancelDisplaySwap = () => {
          if (displaySwapTimer !== null) {
            window.clearTimeout(displaySwapTimer);
            displaySwapTimer = null;
          }

          minimumDisplay.classList.remove('range-value--swapping');
          maximumDisplay.classList.remove('range-value--swapping');
          pendingMinimumDisplay = minimumDisplay.value;
          pendingMaximumDisplay = maximumDisplay.value;
        };
        const setMinimum = (value, updateRange = true) => {
          const isDefault = value <= contextualMinimum;

          if (updateRange) {
            setRangePrice(minimumRange, isDefault ? contextualMinimum : value);
          }

          minimumValue.value = isDefault ? '' : value;
          setMinimumDisplay(isDefault ? '' : format(value));
        };
        const setMaximum = (value, updateRange = true) => {
          const isDefault = value >= rangeMaximum;

          if (updateRange) {
            setRangePrice(maximumRange, isDefault ? rangeMaximum : value);
          }

          maximumValue.value = isDefault ? '' : value;
          setMaximumDisplay(isDefault ? '' : format(value));
        };

        const prepareDisplay = (display) => {
          display.value = format(display.value);
          display.placeholder = format(display.placeholder);
          display.addEventListener('focus', () => display.select());
          display.addEventListener('input', () => {
            display.value = format(display.value);
          });
        };

        const updateProgress = () => {
          const firstPosition = Number(minimumRange.value) / Number(minimumRange.max);
          const secondPosition = Number(maximumRange.value) / Number(maximumRange.max);

          rangeGroup.style.setProperty('--range-min', `${Math.min(firstPosition, secondPosition) * 100}%`);
          rangeGroup.style.setProperty('--range-max', `${Math.max(firstPosition, secondPosition) * 100}%`);
        };

        const clearRangeTrackSliderTransition = () => {
          rangeTrackSliderFrame = null;
          rangeTrackSliderRange = null;
          rangeTrackSliderTarget = null;
          rangeTrackSliderStep = null;
        };

        const cancelRangeTrackSliderTransition = () => {
          if (rangeTrackSliderFrame !== null) {
            window.cancelAnimationFrame(rangeTrackSliderFrame);
          }

          if (rangeTrackSliderRange) {
            rangeTrackSliderRange.step = rangeTrackSliderStep;
            setRangePrice(rangeTrackSliderRange, Math.min(
              rangeMaximum,
              Math.max(contextualMinimum, snap(getRangePrice(rangeTrackSliderRange)))
            ));
            updateProgress();
          }

          clearRangeTrackSliderTransition();
          this.installInventoryScale?.();
        };

        const completeRangeTrackSliderTransition = () => {
          if (!rangeTrackSliderRange) {
            return;
          }

          if (rangeTrackSliderFrame !== null) {
            window.cancelAnimationFrame(rangeTrackSliderFrame);
          }

          const range = rangeTrackSliderRange;
          const targetValue = rangeTrackSliderTarget;

          range.step = rangeTrackSliderStep;
          setRangePrice(range, targetValue);
          clearRangeTrackSliderTransition();
          range.dispatchEvent(new Event('input', { bubbles: true }));
          normalizePhysicalRangeOrder();
          this.installInventoryScale?.();
        };

        const easeRangeTrackSlider = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const animateRangeTrackSliderTo = (range, target) => {
          cancelRangeTrackSliderTransition();

          const startValue = getRangePrice(range);
          const targetValue = Math.min(rangeMaximum, Math.max(contextualMinimum, snap(target)));

          rangeTrackSliderRange = range;
          rangeTrackSliderTarget = targetValue;
          rangeTrackSliderStep = range.step;

          if (
            startValue === targetValue
            || window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            completeRangeTrackSliderTransition();
            return;
          }

          range.step = 'any';

          let startTime = null;
          const animate = (timestamp) => {
            if (!this.isConnected) {
              cancelRangeTrackSliderTransition();
              return;
            }

            startTime ??= timestamp;
            const progress = Math.min((timestamp - startTime) / rangeTrackSliderDuration, 1);
            const easedProgress = easeRangeTrackSlider(progress);

            setRangePrice(range, positionToPrice(
              priceToPosition(startValue) + (priceToPosition(targetValue) - priceToPosition(startValue)) * easedProgress
            ));
            updateProgress();

            if (progress < 1) {
              rangeTrackSliderFrame = window.requestAnimationFrame(animate);
            } else {
              completeRangeTrackSliderTransition();
            }
          };

          rangeTrackSliderFrame = window.requestAnimationFrame(animate);
        };

        this.cancelTrackClickTransition = cancelRangeTrackSliderTransition;

        const setPriceControlsLocked = (locked) => {
          this.toggleAttribute('data-online-purchase-active', locked);
          if (!locked) return;
          // The checkout preset keeps the same scale on selection and navigation.
          const minimum = getRangePrice(minimumRange);
          const maximum = getRangePrice(maximumRange);
          this.removeAttribute('data-single-range');
          contextualMinimum = 0;
          rangeMaximum = originalMaximum;
          inventoryScale = makeInventoryScale ? makeInventoryScale([], rangeMaximum) : null;
          pendingScale = null;
          [minimumRange, maximumRange].forEach(range => { range.max = Math.max(1, rangeMaximum); });
          minimumDisplay.placeholder = '0';
          maximumDisplay.placeholder = format(rangeMaximum);
          setRangePrice(minimumRange, minimum);
          setRangePrice(maximumRange, maximum);
          updateProgress();
        };

        const cancelOnlinePurchaseSliderTransition = () => {
          if (onlinePurchaseSliderFrame !== null) {
            window.cancelAnimationFrame(onlinePurchaseSliderFrame);
            onlinePurchaseSliderFrame = null;
          }

          minimumRange.step = minimumRangeStep;
          maximumRange.step = maximumRangeStep;
          if (this.hasAttribute('data-single-range')) {
            minimumRange.value = 0;
            maximumRange.value = maximumRange.max;
            rangeGroup.style.setProperty('--range-min', '0%');
            rangeGroup.style.setProperty('--range-max', '100%');
            return;
          }

          setRangePrice(minimumRange, Math.min(
            rangeMaximum,
            Math.max(contextualMinimum, snap(getRangePrice(minimumRange)))
          ));
          setRangePrice(maximumRange, Math.min(
            rangeMaximum,
            Math.max(contextualMinimum, snap(getRangePrice(maximumRange)))
          ));
          updateProgress();
        };

        const easeOnlinePurchaseSlider = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const animatePriceSlidersTo = (minimumTarget, maximumTarget) => {
          cancelOnlinePurchaseSliderTransition();
          if (this.hasAttribute('data-single-range')) return;

          const minimumStartValue = getRangePrice(minimumRange);
          const maximumStartValue = getRangePrice(maximumRange);
          const minimumTargetValue = Math.min(
            rangeMaximum,
            Math.max(0, minimumTarget)
          );
          const maximumTargetValue = Math.min(
            rangeMaximum,
            Math.max(0, maximumTarget)
          );
          const finish = () => {
            setRangePrice(minimumRange, minimumTargetValue);
            setRangePrice(maximumRange, maximumTargetValue);
            minimumRange.step = minimumRangeStep;
            maximumRange.step = maximumRangeStep;
            updateProgress();
            onlinePurchaseSliderFrame = null;
            this.installInventoryScale?.();
          };

          if (
            (
              minimumStartValue === minimumTargetValue
              && maximumStartValue === maximumTargetValue
            )
            || window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            finish();
            return;
          }

          minimumRange.step = 'any';
          maximumRange.step = 'any';

          let startTime = null;
          const animate = (timestamp) => {
            if (!this.isConnected) {
              finish();
              return;
            }

            startTime ??= timestamp;
            const progress = Math.min((timestamp - startTime) / onlinePurchaseSliderDuration, 1);
            const easedProgress = easeOnlinePurchaseSlider(progress);

            setRangePrice(minimumRange, positionToPrice(
              priceToPosition(minimumStartValue)
              + (priceToPosition(minimumTargetValue) - priceToPosition(minimumStartValue)) * easedProgress
            ));
            setRangePrice(maximumRange, positionToPrice(
              priceToPosition(maximumStartValue)
              + (priceToPosition(maximumTargetValue) - priceToPosition(maximumStartValue)) * easedProgress
            ));
            updateProgress();

            if (progress < 1) {
              onlinePurchaseSliderFrame = window.requestAnimationFrame(animate);
            } else {
              finish();
            }
          };

          onlinePurchaseSliderFrame = window.requestAnimationFrame(animate);
        };

        const readPreviousPriceRange = () => {
          const previousMinimum = this.dataset.onlinePurchasePreviousMin;
          const previousMaximum = this.dataset.onlinePurchasePreviousMax;

          if (previousMinimum === undefined || previousMaximum === undefined) {
            return null;
          }

          return {
            minimum: Number.parseInt(previousMinimum, 10),
            maximum: Number.parseInt(previousMaximum, 10)
          };
        };

        const rememberPreviousPriceRange = () => {
          this.dataset.onlinePurchasePreviousMin = minimumValue.value || '0';
          this.dataset.onlinePurchasePreviousMax = maximumValue.value || String(rangeMaximum);
        };

        const clearPreviousPriceRange = () => {
          delete this.dataset.onlinePurchasePreviousMin;
          delete this.dataset.onlinePurchasePreviousMax;
        };

        const releaseOnlinePurchaseForManualChange = () => {
          if (onlinePurchaseSliderFrame !== null) {
            cancelOnlinePurchaseSliderTransition();
          }

          if (!onlinePurchaseToggle?.checked) {
            return;
          }

          onlinePurchaseToggle.checked = false;
          clearPreviousPriceRange();
          setPriceControlsLocked(false);
        };

        const restorePriceRange = () => {
          cancelRangeTrackSliderTransition();
          cancelOnlinePurchaseSliderTransition();

          const previousPriceRange = readPreviousPriceRange();
          const previousMinimum = previousPriceRange?.minimum ?? 0;
          const previousMaximum = previousPriceRange?.maximum ?? rangeMaximum;

          setMinimum(previousMinimum, false);
          setMaximum(previousMaximum, false);
          rangesReversed = false;
          clearPreviousPriceRange();
          animatePriceSlidersTo(previousMinimum, previousMaximum);
        };

        const activateOnlinePurchaseFilter = () => {
          cancelRangeTrackSliderTransition();
          rememberPreviousPriceRange();
          setPriceControlsLocked(true);
          setMinimum(0, false);
          setMaximum(onlinePurchaseMaximum, false);
          rangesReversed = false;
          animatePriceSlidersTo(0, onlinePurchaseMaximum);
        };

        const resetOnlinePurchaseState = () => {
          cancelRangeTrackSliderTransition();
          cancelOnlinePurchaseSliderTransition();

          if (onlinePurchaseToggle) {
            onlinePurchaseToggle.checked = false;
          }

          setPriceControlsLocked(false);
          clearPreviousPriceRange();
        };

        this.resetOnlinePurchaseFilter = resetOnlinePurchaseState;
        this.resetRange = () => {
          resetOnlinePurchaseState();
          cancelDisplaySwap();
          setMinimum(0, false);
          setMaximum(rangeMaximum, false);
          rangesReversed = false;
          animatePriceSlidersTo(0, rangeMaximum);
        };

        let draggedRange = null;
        let draggedPointerId = null;
        let pointerStartClientX = null;
        let pendingTrackClickTarget = null;

        const normalizePhysicalRangeOrder = () => {
          if (!rangesReversed) {
            return;
          }

          const firstValue = getRangePrice(minimumRange);
          const secondValue = getRangePrice(maximumRange);

          setRangePrice(minimumRange, Math.min(firstValue, secondValue));
          setRangePrice(maximumRange, Math.max(firstValue, secondValue));
          rangesReversed = false;
        };

        const progressFromPointer = (event) => {
          const bounds = rangeGroup.getBoundingClientRect();

          if (bounds.width <= 0) {
            return null;
          }

          const isRightToLeft = getComputedStyle(rangeGroup).direction === 'rtl';
          const rawProgress = (event.clientX - bounds.left) / bounds.width;

          return Math.min(1, Math.max(0, isRightToLeft ? 1 - rawProgress : rawProgress));
        };

        let pointerSmoothFrame = null;
        let pointerSmoothRange = null;
        let pointerSmoothValue = 0;
        let pointerSmoothTarget = 0;
        const renderPointerValue = () => {
          setRangePrice(pointerSmoothRange, positionToPrice(pointerSmoothValue));
          pointerSmoothRange.dispatchEvent(new Event('input', { bubbles: true }));
        };
        const flushPointerMotion = () => {
          if (pointerSmoothFrame !== null) cancelAnimationFrame(pointerSmoothFrame);
          pointerSmoothFrame = null;
          if (pointerSmoothRange) {
            pointerSmoothValue = pointerSmoothTarget;
            renderPointerValue();
            pointerSmoothRange = null;
          }
        };
        this.cancelPointerMotion = () => {
          if (pointerSmoothFrame !== null) cancelAnimationFrame(pointerSmoothFrame);
          pointerSmoothFrame = null;
          pointerSmoothRange = null;
        };
        const smoothPointerTo = (range, progress) => {
          if (pointerSmoothRange !== range) { pointerSmoothRange = range; pointerSmoothValue = priceToPosition(getRangePrice(range)); }
          pointerSmoothTarget = progress;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) { flushPointerMotion(); return; }
          if (pointerSmoothFrame !== null) return;
          const tick = () => {
            if (!this.isConnected || !pointerSmoothRange) { this.cancelPointerMotion(); return; }
            const distance = pointerSmoothTarget - pointerSmoothValue;
            pointerSmoothValue += distance * .4;
            if (Math.abs(distance) < .0005) pointerSmoothValue = pointerSmoothTarget;
            renderPointerValue();
            pointerSmoothFrame = pointerSmoothValue === pointerSmoothTarget ? null : requestAnimationFrame(tick);
          };
          pointerSmoothFrame = requestAnimationFrame(tick);
        };
        const setRangeFromPointer = (event, range) => {
          const progress = progressFromPointer(event);

          if (progress === null) {
            return;
          }

          smoothPointerTo(range, progress);
        };

        const moveClosestHandle = (event) => {
          if (this.hasAttribute('data-single-range')) return;
          if (event.button !== 0) {
            return;
          }

          completeRangeTrackSliderTransition();
          releaseOnlinePurchaseForManualChange();

          const progress = progressFromPointer(event);

          if (progress === null) {
            return;
          }

          const minimumProgress = priceToPosition(getRangePrice(minimumRange));
          const maximumProgress = priceToPosition(getRangePrice(maximumRange));
          const pointerRange = event.target === minimumRange || event.target === maximumRange
            ? event.target
            : null;

          draggedRange = pointerRange || (
            Math.abs(progress - minimumProgress) <= Math.abs(progress - maximumProgress)
              ? minimumRange
              : maximumRange
          );
          draggedPointerId = event.pointerId;
          pointerStartClientX = event.clientX;
          pendingTrackClickTarget = pointerRange ? null : snap(positionToPrice(progress));

          event.preventDefault();
          rangeGroup.setPointerCapture(event.pointerId);

          if (pointerRange) {
            setRangeFromPointer(event, draggedRange);
          }
        };

        const dragClosestHandle = (event) => {
          if (draggedRange === null || event.pointerId !== draggedPointerId) {
            return;
          }

          if (
            pendingTrackClickTarget !== null
            && Math.abs(event.clientX - pointerStartClientX) < rangeTrackDragThreshold
          ) {
            return;
          }

          event.preventDefault();
          pendingTrackClickTarget = null;
          setRangeFromPointer(event, draggedRange);
        };

        const stopDragging = (event) => {
          if (event.pointerId !== draggedPointerId) {
            return;
          }

          if (rangeGroup.hasPointerCapture(event.pointerId)) {
            rangeGroup.releasePointerCapture(event.pointerId);
          }

          flushPointerMotion();
          const range = draggedRange;
          const trackClickTarget = pendingTrackClickTarget;
          const shouldAnimateTrackClick = event.type === 'pointerup'
            && trackClickTarget !== null;

          draggedRange = null;
          draggedPointerId = null;
          pointerStartClientX = null;
          pendingTrackClickTarget = null;

          if (shouldAnimateTrackClick) {
            animateRangeTrackSliderTo(range, trackClickTarget);
          } else {
            if (range) {
              setRangePrice(range, snap(getRangePrice(range)));
              range.dispatchEvent(new Event('input', { bubbles: true }));
            }
            normalizePhysicalRangeOrder();
            this.installInventoryScale?.();
          }
        };

        const commitMinimum = () => {
          cancelRangeTrackSliderTransition();
          const rawValue = numberFrom(minimumDisplay.value);

          if (rawValue === '') {
            setMinimum(0);
          } else {
            const upper = Number.parseInt(maximumValue.value || maximumRange.max, 10);
            const value = Math.max(0, Math.min(Number.parseInt(rawValue, 10), upper - 1));

            setMinimum(value);
          }

          rangesReversed = false;
          updateProgress();
          notifyChange();
        };

        const commitMaximum = () => {
          cancelRangeTrackSliderTransition();
          const rawValue = numberFrom(maximumDisplay.value);

          if (rawValue === '') {
            setMaximum(rangeMaximum);
          } else {
            const lower = Number.parseInt(minimumValue.value || minimumRange.min, 10);
            const value = Math.min(rangeMaximum, Math.max(Number.parseInt(rawValue, 10), lower + 1));

            setMaximum(value);
          }

          rangesReversed = false;
          updateProgress();
          notifyChange();
        };

        prepareDisplay(minimumDisplay);
        prepareDisplay(maximumDisplay);

        [minimumDisplay, maximumDisplay].forEach((display) => {
          display.addEventListener('input', () => {
            cancelRangeTrackSliderTransition();

            if (onlinePurchaseSliderFrame !== null) {
              cancelOnlinePurchaseSliderTransition();
            }
          });
        });

        if (onlinePurchaseToggle) {
          const onlinePurchaseIsActive = this.hasAttribute('data-online-purchase-active');

          onlinePurchaseToggle.checked = onlinePurchaseIsActive;
          setPriceControlsLocked(onlinePurchaseIsActive);

          let checkoutFadeModule;
          const fadeSource = document.querySelector('[data-rr-contextual-range-url]');
          if (fadeSource) import(fadeSource.dataset.rrContextualRangeUrl)
            .then(module => { checkoutFadeModule = module; }).catch(console.error);
          onlinePurchaseToggle.addEventListener('change', () => {
            const fields = Array.from(this.querySelectorAll('[data-price-display]'));
            const before = fields.map(field => field.value || field.placeholder);
            if (onlinePurchaseToggle.checked) {
              activateOnlinePurchaseFilter();
            } else {
              setPriceControlsLocked(false);
              restorePriceRange();
            }
            if (checkoutFadeModule) checkoutFadeModule.fadeValues(this, before);
          });

          [minimumDisplay, maximumDisplay].forEach((display) => {
            display.addEventListener('input', releaseOnlinePurchaseForManualChange);
          });

          [minimumRange, maximumRange].forEach((range) => {
            range.addEventListener('input', releaseOnlinePurchaseForManualChange);
          });
        }

        this.syncPriceRangeFromUrl = (minimum, maximum, animate = false) => {
          cancelRangeTrackSliderTransition();
          cancelOnlinePurchaseSliderTransition();
          cancelDisplaySwap();

          const nextMinimum = minimum === '' ? 0 : Number.parseInt(minimum, 10);
          const nextMaximum = maximum === '' ? rangeMaximum : Number.parseInt(maximum, 10);
          const onlinePurchaseIsActive = !!onlinePurchaseToggle && nextMinimum <= 0
            && nextMaximum === onlinePurchaseMaximum
            && originalMaximum > onlinePurchaseMaximum;

          clearPreviousPriceRange();
          if (onlinePurchaseToggle) onlinePurchaseToggle.checked = onlinePurchaseIsActive;
          setPriceControlsLocked(onlinePurchaseIsActive);
          setMinimum(nextMinimum, !animate);
          setMaximum(nextMaximum, !animate);
          rangesReversed = false;
          updateProgress();
          if (animate) animatePriceSlidersTo(nextMinimum, nextMaximum);
        };

        minimumDisplay.addEventListener('change', commitMinimum);
        maximumDisplay.addEventListener('change', commitMaximum);

        [minimumRange, maximumRange].forEach((range) => {
          range.addEventListener('input', () => {
            if (rangeTrackSliderFrame !== null) {
              cancelRangeTrackSliderTransition();
            }

            if (onlinePurchaseSliderFrame !== null) {
              cancelOnlinePurchaseSliderTransition();
            }
          });
        });

        [minimumDisplay, maximumDisplay].forEach((display) => {
          display.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') {
              return;
            }

            event.preventDefault();
            display.blur();
          });
        });

        minimumRange.addEventListener('input', () => {
          if (draggedRange !== minimumRange) {
            setRangePrice(minimumRange, snap(getRangePrice(minimumRange)));
          }
          const firstValue = draggedRange === minimumRange ? snap(getRangePrice(minimumRange)) : getRangePrice(minimumRange);
          const secondValue = draggedRange === maximumRange ? snap(getRangePrice(maximumRange)) : getRangePrice(maximumRange);
          const nextRangesReversed = firstValue > secondValue;

          if (nextRangesReversed !== rangesReversed) {
            beginDisplaySwap();
          }

          rangesReversed = nextRangesReversed;
          setMinimum(Math.min(firstValue, secondValue), false);
          setMaximum(Math.max(firstValue, secondValue), false);
          updateProgress();
          notifyChange();
        });

        maximumRange.addEventListener('input', () => {
          if (draggedRange !== maximumRange) {
            setRangePrice(maximumRange, snap(getRangePrice(maximumRange)));
          }
          const firstValue = draggedRange === minimumRange ? snap(getRangePrice(minimumRange)) : getRangePrice(minimumRange);
          const secondValue = draggedRange === maximumRange ? snap(getRangePrice(maximumRange)) : getRangePrice(maximumRange);
          const nextRangesReversed = firstValue > secondValue;

          if (nextRangesReversed !== rangesReversed) {
            beginDisplaySwap();
          }

          rangesReversed = nextRangesReversed;
          setMinimum(Math.min(firstValue, secondValue), false);
          setMaximum(Math.max(firstValue, secondValue), false);
          updateProgress();
          notifyChange();
        });

        [minimumRange, maximumRange].forEach(range => {
          range.addEventListener('keydown', event => {
            const direction = getComputedStyle(rangeGroup).direction === 'rtl' ? -1 : 1;
            const steps = { ArrowLeft: -direction, ArrowRight: direction, ArrowDown: -1, ArrowUp: 1, PageDown: -10, PageUp: 10 };
            if (!(event.key in steps) && event.key !== 'Home' && event.key !== 'End') return;
            event.preventDefault();
            cancelRangeTrackSliderTransition();
            cancelOnlinePurchaseSliderTransition();
            releaseOnlinePurchaseForManualChange();
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? rangeMaximum : advancePrice(getRangePrice(range), steps[event.key]);
            setRangePrice(range, Math.min(rangeMaximum, Math.max(contextualMinimum, target)));
            range.dispatchEvent(new Event('input', { bubbles: true }));
            normalizePhysicalRangeOrder();
          });
        });

        this.readContextSelection = () => [minimumValue.value, maximumValue.value];
        this.contextRangeBusy = () => !!draggedRange || rangeTrackSliderFrame !== null || onlinePurchaseSliderFrame !== null;
        this.applyContextBounds = (bounds, selection) => {
          if (this.contextRangeBusy()) return false;
          cancelDisplaySwap();
          const checkoutActive = !!onlinePurchaseToggle?.checked;
          const single = !checkoutActive && !!bounds && bounds[0] === bounds[1];
          this.toggleAttribute('data-single-range', single);
          if (onlinePurchaseToggle) onlinePurchaseToggle.disabled = !bounds || bounds[0] > onlinePurchaseMaximum;
          contextualMinimum = 0;
          rangeMaximum = !checkoutActive && bounds ? Math.max(bounds[0], bounds[1]) : originalMaximum;
          inventoryScale = makeInventoryScale ? makeInventoryScale([], rangeMaximum) : null;
          pendingScale = null;
          [minimumRange, maximumRange].forEach(range => { range.max = Math.max(1, rangeMaximum); });
          minimumDisplay.placeholder = '0';
          maximumDisplay.placeholder = bounds ? format(rangeMaximum) : '—';
          const valid = value => value !== '' && Number(value) >= contextualMinimum && Number(value) <= rangeMaximum;
          const lower = checkoutActive ? 0 : valid(selection[0]) ? Number(selection[0]) : contextualMinimum;
          const upper = checkoutActive ? onlinePurchaseMaximum : valid(selection[1]) ? Number(selection[1]) : rangeMaximum;
          setMinimum(Math.min(lower, upper)); setMaximum(Math.max(lower, upper));
          [minimumRange, maximumRange, minimumDisplay, maximumDisplay].forEach(input => { input.disabled = !bounds || bounds[0] === bounds[1] || !!onlinePurchaseToggle?.checked; });
          updateProgress();
          if (single) {
            minimumRange.value = 0;
            maximumRange.value = maximumRange.max;
            rangeGroup.style.setProperty('--range-min', '0%');
            rangeGroup.style.setProperty('--range-max', '100%');
          }
          return true;
        };
        const installScale = () => {
          if (!pendingScale || draggedRange || onlinePurchaseSliderFrame !== null || rangeTrackSliderFrame !== null || !this.isConnected) return;
          // Browser form restoration may contain thumb coordinates from an older scale.
          const minimum = minimumValue.value === '' ? contextualMinimum : Number(minimumValue.value);
          const maximum = maximumValue.value === '' ? rangeMaximum : Number(maximumValue.value);
          inventoryScale = pendingScale;
          pendingScale = null;
          setRangePrice(minimumRange, minimum);
          setRangePrice(maximumRange, maximum);
          this.dataset.inventoryScaleCount = String(inventoryScale.count);
          updateProgress();
        };
        this.installInventoryScale = installScale;
        const prepareInventoryScale = () => {
          if (!this.dataset.priceCollectionUrl || this.inventoryScaleStarted) return;
          this.inventoryScaleStarted = true;
          import(this.dataset.priceScaleUrl)
            .then(async ({ createInventoryPriceScale, loadInventoryPrices }) => {
              makeInventoryScale = createInventoryPriceScale;
              const prices = await loadInventoryPrices(this.dataset.priceCollectionUrl, this.dataset.priceCurrency);
              if (!this.isConnected) return;
              pendingScale = createInventoryPriceScale(prices, rangeMaximum);
              installScale();
            })
            .catch(() => { this.inventoryScaleStarted = false; });
        };
        this.priceScaleObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.priceScaleObserver.disconnect();
            prepareInventoryScale();
          }
        });
        this.priceScaleObserver.observe(this);
        this.addEventListener('focusin', prepareInventoryScale, { once: true });
        this.addEventListener('pointerenter', prepareInventoryScale, { once: true });
        rangeGroup.addEventListener('pointerdown', moveClosestHandle);
        rangeGroup.addEventListener('pointermove', dragClosestHandle);
        rangeGroup.addEventListener('pointerup', stopDragging);
        rangeGroup.addEventListener('pointercancel', stopDragging);

        minimumRange.addEventListener('change', (event) => {
          event.stopPropagation();
          normalizePhysicalRangeOrder();
        });

        maximumRange.addEventListener('change', (event) => {
          event.stopPropagation();
          normalizePhysicalRangeOrder();
        });
      }

      disconnectedCallback() {
        this.cancelPointerMotion?.();
        this.priceScaleObserver?.disconnect();
        this.cancelTrackClickTransition?.();
      }
    }

    customElements.define('formatted-price-range', FormattedPriceRange);
    window.addEventListener('pageshow', () => {
      // Run after native form restoration, including the back/forward cache.
      window.requestAnimationFrame(() => {
        if (window.RRSearchPage?.active) return;
        const params = new URL(window.location.href).searchParams;
        document.querySelectorAll('formatted-price-range[data-price-collection-url]').forEach(control => {
          if (control.classList.contains('rr-price-unavailable')) return;
          window.RRContextualRanges?.cancelControl(control);
          const minimum = control.querySelector('[data-price-value="minimum"]');
          const maximum = control.querySelector('[data-price-value="maximum"]');
          control.syncPriceRangeFromUrl?.(params.get(minimum.name) || '', params.get(maximum.name) || '');
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-availability-filter"] && !Shopify.designMode) return;
  try {
    const stockParam = window.RRCatalogAvailability?.param || 'filter.v.availability';
  const stockURL = url => window.RRCatalogAvailability?.normalize(url) || url;
  if (!customElements.get('rr-availability-filter')) {
    customElements.define('rr-availability-filter', class extends HTMLElement {
      static archiveChecks = new Map();
      async checkArchives() {
        const url = new URL(window.location.href);
        const scope = (window.RRCatalogAvailability?.base(url) || url).pathname;
        if (!scope.includes('/collections/')) {
          this.removeAttribute('data-archive-pending');
          return;
        }
        if (!this.constructor.archiveChecks.has(scope)) {
          url.search = '';
          url.searchParams.set('section_id', 'rr-archive-presence');
          url.searchParams.set(stockParam, '0');
          this.constructor.archiveChecks.set(scope, fetch(stockURL(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(response => {
              if (!response.ok) throw new Error('Archive availability check failed.');
              return response.text();
            })
            .then(html => {
              const marker = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rr-archive-count]');
              const count = Number(marker?.getAttribute('data-rr-archive-count'));
              if (!marker || !Number.isFinite(count) || count < 0) throw new Error('Archive availability count missing.');
              return count > 0;
            }).catch(error => { this.constructor.archiveChecks.delete(scope); throw error; }));
        }
        try {
          const hasArchives = await this.constructor.archiveChecks.get(scope);
          if (!this.isConnected || (window.RRCatalogAvailability?.base(window.location.href).pathname || window.location.pathname) !== scope) return;
          this.toggleAttribute('data-no-archives', !hasArchives);
          if (!hasArchives && !this.hasAttribute('data-archive-collection')) {
            const current = new URL(window.location.href);
            const values = current.searchParams.getAll(stockParam).flatMap(value => value.split(','));
            if (values.includes('0') && !window.Shopify?.designMode) {
              current.searchParams.set(stockParam, '1');
              current.searchParams.set('rr_availability', 'selected');
              current.searchParams.delete('page');
              window.location.replace(stockURL(current).href);
            }
          }
        } catch (error) {
          console.warn(error);
        } finally {
          if (this.isConnected) this.removeAttribute('data-archive-pending');
        }
      }
      connectedCallback() {
        if (window.RRCatalogAvailability?.redirecting) return;
        this.checkArchives();
        this.availabilityListeners?.abort();
        this.availabilityListeners = new AbortController();
        this.addEventListener('click', event => {
          const input = event.target.closest?.(`input[type="checkbox"][name="${stockParam}"]`);
          if (!input || !this.contains(input)) return;
          // Checkbox activation has already flipped checked before click dispatch.
          // Both choices may be selected. Deselecting the sole active choice
          // selects its opposite; the native change still refreshes only once.
          this.querySelectorAll(`input[name="${stockParam}"]`).forEach(other => {
            if (other !== input && !input.checked) other.checked = true;
          });
        }, { capture: true, signal: this.availabilityListeners.signal });
        const url = new URL(window.location.href);
        const values = url.searchParams.getAll(stockParam).flatMap(value => value.split(','));
        const explicitSelection = values.some(value => value === '0' || value === '1');
        const defaultValues = (this.getAttribute('data-default-availability') || '1').split(',');
        this.querySelectorAll('input[type="checkbox"]').forEach(input => {
          input.checked = explicitSelection ? values.includes(input.value) : defaultValues.includes(input.value);
        });
        // Apply the default to the server-side collection, including counts and pagination.
        // Empty or invalid availability URLs normalize to this collection default.
        if ((this.hasAttribute('data-enabled') || this.hasAttribute('data-archive-collection')) && !explicitSelection && !window.Shopify?.designMode && !window.RRSearchPage?.active) {
          url.searchParams.set(stockParam, defaultValues[0]);
          url.searchParams.set('rr_availability', 'selected');
          url.searchParams.delete('page');
          window.location.replace(stockURL(url).href);
        }
      }
      disconnectedCallback() {
        this.availabilityListeners?.abort();
      }
    });
    // Keep an explicit availability selection when Shopify generates page links.
    document.addEventListener('click', event => {
      const link = event.target.closest?.('.pagination a[href]');
      if (!link || !new URL(window.location.href).searchParams.has('rr_availability')) return;
      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;
      destination.searchParams.set('rr_availability', 'selected');
      link.href = destination.href;
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-collection-drawer-sort"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('rr-collection-drawer-sort')) {
    class RrCollectionDrawerSort extends HTMLElement {
      connectedCallback() {
        this.sortStateObserver?.disconnect();
        this.listenerController?.abort();
        this.listenerController = new AbortController();
        this.querySelectorAll('[data-rr-drawer-sort-hold-active]').forEach((row) => {
          row.removeAttribute('data-rr-drawer-sort-hold-active');
        });

        const listenerOptions = { signal: this.listenerController.signal };
        const sortDetails = this.querySelector('[data-rr-drawer-sort-details]');
        const stateKey = 'rr-sort-accordion-open';
        if (sortDetails) {
          let expanded = true;
          try { expanded = sessionStorage.getItem(stateKey) !== 'false'; } catch (_) {}
          sortDetails.open = expanded;
          sortDetails.setAttribute('aria-expanded', String(expanded));
          const rememberSortState = () => {
            try {
              sessionStorage.setItem(stateKey, sortDetails.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
            } catch (_) {}
          };
          this.sortStateObserver = new MutationObserver(rememberSortState);
          this.sortStateObserver.observe(sortDetails, { attributes: true, attributeFilter: ['aria-expanded'] });
          window.addEventListener('pagehide', rememberSortState, listenerOptions);
        }


        this.addEventListener('click', this.handleProxyClick.bind(this), listenerOptions);
        const preventSpectrumImageAction = (event) => {
          if (event.target.closest?.('.rr-drawer-sort__spectrum-icon')) event.preventDefault();
        };
        this.addEventListener('contextmenu', preventSpectrumImageAction, listenerOptions);
        this.addEventListener('dragstart', preventSpectrumImageAction, listenerOptions);
        this.querySelectorAll('[data-rr-drawer-sort-proxy="label"]').forEach((label) => {
          label.addEventListener(
            'pointerleave',
            this.handleLabelPointerLeave.bind(this),
            listenerOptions
          );
        });
        document.addEventListener('facet:update', this.handleFacetUpdate.bind(this), listenerOptions);
        document.addEventListener('rr:collection-results-replaced', this.handleResultsReplaced.bind(this), listenerOptions);
        window.addEventListener('popstate', this.handlePopState.bind(this), listenerOptions);
        const facetsDrawer = this.closest('#facets-drawer');
        facetsDrawer?.addEventListener(
          'dialog:before-show',
          this.handleDrawerBeforeShow.bind(this),
          listenerOptions
        );
        facetsDrawer?.addEventListener(
          'dialog:after-hide',
          this.handleDrawerHidden.bind(this),
          listenerOptions
        );

        this.syncFromUrl(new URL(window.location.href));
      }

      disconnectedCallback() {
        this.sortStateObserver?.disconnect();
        this.listenerController?.abort();
      }

      get canonicalSortPopover() {
        const sectionId = this.getAttribute('section-id');
        const owningSection = sectionId
          ? document.getElementById(`shopify-section-${sectionId}`)
          : null;

        return owningSection?.querySelector('#sort-by-popover')
          || document.querySelector('#sort-by-popover');
      }

      handleProxyClick(event) {
        const proxy = event.target.closest?.('[data-rr-drawer-sort-proxy]');

        if (!proxy || !this.contains(proxy)) {
          return;
        }

        const canonicalPopover = this.canonicalSortPopover;

        if (!canonicalPopover) {
          return;
        }

        let canonicalControl;

        if (proxy.dataset.rrDrawerSortProxy === 'standard') {
          canonicalControl = canonicalPopover.querySelector(
            `[role="option"][value="${CSS.escape(proxy.value)}"]:not([data-rr-sort-label-toggle])`
          );
        } else {
          const criterion = proxy.dataset.rrDrawerSortCriterion
            || proxy.dataset.rrDrawerSortLabel;
          const canonicalRow = canonicalPopover.querySelector(
            `[data-rr-sort-control-row="${CSS.escape(criterion)}"]`
          );

          if (proxy.dataset.rrDrawerSortProxy === 'direction') {
            canonicalControl = canonicalRow?.querySelector(
              `[data-rr-sort-direction-choice="${CSS.escape(proxy.dataset.rrDrawerSortDirection)}"]`
            );
          } else {
            const activeDirection = this.dataset.activeCriterion === criterion
              ? this.dataset.activeDirection
              : null;
            const nextDirection = activeDirection === 'ascending'
              ? 'descending'
              : 'ascending';

            canonicalControl = canonicalRow?.querySelector(
              `[data-rr-sort-direction-choice="${nextDirection}"]`
            );
          }
        }

        if ((proxy.dataset.rrDrawerSortCriterion || proxy.dataset.rrDrawerSortLabel) === 'title') {
          const direction = proxy.dataset.rrDrawerSortDirection
            || (this.dataset.activeCriterion === 'title' && this.dataset.activeDirection === 'ascending' ? 'descending' : 'ascending');
          canonicalControl = canonicalPopover.querySelector(`[role="option"][value="title-${direction}"]`);
        }

        if (
          canonicalControl
          && proxy.dataset.rrDrawerSortProxy === 'label'
          && proxy.matches(':hover')
        ) {
          proxy.closest('[data-rr-drawer-sort-row]')
            ?.setAttribute('data-rr-drawer-sort-hold-active', 'true');
        }

        canonicalControl?.click();
      }

      handleLabelPointerLeave(event) {
        event.currentTarget.closest('[data-rr-drawer-sort-row]')
          ?.removeAttribute('data-rr-drawer-sort-hold-active');
      }

      handleFacetUpdate(event) {
        if (!event.detail?.url) {
          return;
        }

        this.syncFromUrl(new URL(event.detail.url, window.location.origin));
      }

      handleResultsReplaced() {
        this.syncFromUrl(new URL(window.location.href));
      }

      handlePopState() {
        this.syncFromUrl(new URL(window.location.href));
      }

      handleDrawerBeforeShow() {
        this.querySelectorAll('[data-rr-drawer-sort-hold-active]').forEach((row) => {
          row.removeAttribute('data-rr-drawer-sort-hold-active');
        });
      }

      handleDrawerHidden() {
        this.querySelectorAll('[data-rr-drawer-sort-hold-active]').forEach((row) => {
          row.removeAttribute('data-rr-drawer-sort-hold-active');
        });
      }

      syncFromUrl(url) {
        const customDirection = url.searchParams.get('rr_sort');
        const shopifySort = url.searchParams.get('sort_by')
          || this.dataset.defaultSortBy;
        let activeCriterion = null;
        let activeDirection = null;
        let activeStandardValue = null;
        let activeLabel = this.dataset.defaultSortLabel || 'Alphabetically';

        if (customDirection === 'ascending' || customDirection === 'descending') {
          activeCriterion = 'carat';
          activeDirection = customDirection;
          activeLabel = 'Carats';
        } else if (shopifySort === 'title-ascending' || shopifySort === 'title-descending') {
          activeCriterion = 'title';
          activeDirection = shopifySort.endsWith('-ascending') ? 'ascending' : 'descending';
          activeLabel = 'Alphabetically';
        } else if (shopifySort === 'price-ascending' || shopifySort === 'price-descending') {
          activeCriterion = 'price';
          activeDirection = shopifySort.endsWith('-ascending')
            ? 'ascending'
            : 'descending';
          activeLabel = 'Price';
        } else {
          activeStandardValue = shopifySort;
          const activeStandard = Array.from(
            this.querySelectorAll('[data-rr-drawer-sort-proxy="standard"]')
          ).find((option) => option.value === activeStandardValue);

          if (activeStandard?.dataset.rrDrawerSortLabelValue) {
            activeLabel = activeStandard.dataset.rrDrawerSortLabelValue;
          }
        }

        this.querySelectorAll('[data-rr-drawer-sort-proxy="standard"]').forEach((option) => {
          const isActive = activeCriterion === null && option.value === activeStandardValue;

          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', String(isActive));
        });

        this.querySelectorAll('[data-rr-drawer-sort-row]').forEach((row) => {
          const criterion = row.dataset.rrDrawerSortRow;
          const isActive = criterion === activeCriterion;

          row.classList.toggle('is-active', isActive);
          row.querySelector('[data-rr-drawer-sort-proxy="label"]')
            ?.setAttribute('aria-pressed', String(isActive));
          row.querySelectorAll('[data-rr-drawer-sort-proxy="direction"]').forEach((direction) => {
            const isPressed = isActive
              && direction.dataset.rrDrawerSortDirection === activeDirection;

            direction.setAttribute('aria-pressed', String(isPressed));
          });
        });

        const spectrumIcon = this.querySelector('[data-rr-summary-spectrum]');
        if (spectrumIcon) spectrumIcon.hidden = activeStandardValue !== 'manual';

        const summaryLabel = this.querySelector('[data-rr-drawer-sort-summary-label]');
        const summary = this.querySelector('[data-rr-drawer-sort-summary]');
        const directionLabel = activeDirection === 'ascending'
          ? ', low to high'
          : activeDirection === 'descending'
            ? ', high to low'
            : '';
        const isAlphabetically = activeCriterion === 'title';

        if (summaryLabel) {
          summaryLabel.textContent = activeLabel;
        }

        const summaryLetters = this.querySelector('[data-rr-summary-letters]');
        if (summaryLetters) {
          summaryLetters.hidden = !isAlphabetically;
          summaryLetters.textContent = isAlphabetically ? (activeDirection === 'descending' ? 'Z–A' : 'A–Z') : '';
        }

        summary?.setAttribute(
          'aria-label',
          isAlphabetically
            ? `Sort Alphabetically, ${activeDirection === 'descending' ? 'Z to A' : 'A to Z'}`
            : `Sort by ${activeLabel}${directionLabel}`
        );

        if (isAlphabetically) {
          this.dataset.activeAlphabetically = 'true';
        } else {
          delete this.dataset.activeAlphabetically;
        }

        if (activeCriterion) {
          this.dataset.activeCriterion = activeCriterion;
        } else {
          delete this.dataset.activeCriterion;
        }

        if (activeDirection) {
          this.dataset.activeDirection = activeDirection;
        } else {
          delete this.dataset.activeDirection;
        }
      }
    }

    window.customElements.define('rr-collection-drawer-sort', RrCollectionDrawerSort);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-inline-collection-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.rr-inline-collection').forEach(item => {
    const media = item.querySelector('.rr-inline-collection__media');
    const image = media?.querySelector('img');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let revision = 0;
    const mediaKey = (src, video = '') => `${new URL(src, location.href).href}|${video}`;
    let displayedKey = image ? mediaKey(image.getAttribute('src')) : '';
    let requestedKey = displayedKey;
    const show = async (src, videoSrc = '') => {
      if (!image || !src) return;
      const key = mediaKey(src, videoSrc);
      if (key === requestedKey) return;
      requestedKey = key;
      const current = ++revision;
      // Cancel an obsolete fade without leaving the current image transparent.
      image.style.opacity = '1';
      if (key === displayedKey) return;
      media.querySelector('video')?.remove();
      const next = new Image(); next.src = src;
      try { await next.decode(); } catch {
        if (current === revision) requestedKey = displayedKey;
        return;
      }
      if (current !== revision) return;
      image.style.opacity = '0';
      if (!reduced.matches) await new Promise(resolve => setTimeout(resolve, 180));
      if (current !== revision) return;
      // Frame these approved assets by jewelry bounds, not their black canvas.
      const framing = {
        'stack.png': 'translate(-0.3213%, 2.506%) scale(1.1165)',
        'Color_Stones_Stuck_up.png': 'translate(-0.0781%, 1.25%) scale(1.20625)',
        'color-ring-stack-a.jpg': 'translate(-0.8036%, 5.4286%) scale(1.14286)'
      };
      const filename = decodeURIComponent(new URL(src, location.href).pathname.split('/').pop());
      image.style.transform = framing[filename] || 'none';
      image.removeAttribute('srcset'); image.src = src; image.style.opacity = '1';
      displayedKey = key;
      if (videoSrc && !reduced.matches) {
        const video = document.createElement('video');
        video.muted = true; video.loop = true; video.playsInline = true; video.poster = src; video.src = videoSrc;
        video.setAttribute('aria-hidden', 'true'); media.append(video); video.play().catch(() => video.remove());
      }
    };
    item.querySelectorAll('a').forEach(link => {
      const preview = () => show(link.dataset.hoverImage || link.dataset.hoverPoster || media?.dataset.defaultImage, link.dataset.hoverVideo);
      link.addEventListener('pointerenter', preview);
      link.addEventListener('focus', preview);
    });
    item.addEventListener('pointerleave', () => show(media?.dataset.defaultImage));
    item.closest('header-sidebar')?.addEventListener('dialog:before-hide', () => {
      ++revision;
      media?.querySelector('video')?.remove();
      if (image) {
        image.style.opacity = '1';
        displayedKey = mediaKey(image.getAttribute('src'));
        requestedKey = displayedKey;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-staff-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-staff-style')) {
    customElements.define('rr-staff-style', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.enabled = false;
        this.readPreference();
        this.refresh();
        const title = this.parentElement.querySelector('h1.product-title');
        title?.addEventListener('click', (event) => {
          if (!event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
          event.preventDefault();
          this.enabled = !this.enabled;
          try { localStorage.setItem('rr-staff-style-visible', String(this.enabled)); } catch {}
          window.dispatchEvent(new CustomEvent('rr:staff-style-change', { detail: { enabled: this.enabled } }));
          this.refresh();
        }, options);
        this.closest('.shopify-section')?.addEventListener('variant:change', (event) => {
          this.dataset.sku = event.detail?.variant?.sku || '';
          this.refresh();
        }, options);
        window.addEventListener('rr:staff-style-change', (event) => {
          this.enabled = event.detail.enabled;
          this.refresh();
        }, options);
        window.addEventListener('storage', (event) => {
          if (event.key !== null && event.key !== 'rr-staff-style-visible') return;
          this.readPreference();
          this.refresh();
        }, options);
        window.addEventListener('pageshow', () => {
          this.readPreference();
          this.refresh();
        }, options);
      }
      readPreference() {
        try {
          const key = 'rr-staff-style-visible';
          let saved = localStorage.getItem(key);
          if (saved === null) {
            saved = sessionStorage.getItem(key);
            if (saved !== null) localStorage.setItem(key, saved);
          }
          sessionStorage.removeItem(key);
          this.enabled = saved === 'true';
        } catch {}
      }
      refresh() {
        this.hidden = false;
        const visible = this.enabled && Boolean(this.dataset.sku?.trim());
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.querySelector('[data-style-value]').textContent = this.dataset.sku || '';
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
